export * from '../models/AccessCondition';
export * from '../models/AccessConditionEffect';
export * from '../models/AccessConditionalExpression';
export * from '../models/Account';
export * from '../models/AccountConfigInput';
export * from '../models/AccountIdCondition';
export * from '../models/AccountIdFilters';
export * from '../models/AccountInstallationMethod';
export * from '../models/AccountMetricsDestination';
export * from '../models/AccountNameFilters';
export * from '../models/AccountState';
export * from '../models/AccountStatusFilters';
export * from '../models/AccountUpdateInput';
export * from '../models/AccountVersion';
export * from '../models/ActionFilters';
export * from '../models/ActionRequiredDetails';
export * from '../models/ActivateAtlasOrganizationResponse';
export * from '../models/ActivateGcpFolderResponse';
export * from '../models/ActivateGcpOrganizationResponse';
export * from '../models/AddRestoreAtlasPrivateLinkRequest';
export * from '../models/AgreementWithCredits';
export * from '../models/Ami';
export * from '../models/AmiBlockDevice';
export * from '../models/AnalyzeSqlQueryRequest';
export * from '../models/AnnuallyConfig';
export * from '../models/AnomalyDataPoint';
export * from '../models/AnomalyGraphData';
export * from '../models/ApiCredentials';
export * from '../models/ApiCredentialsProperties';
export * from '../models/App';
export * from '../models/AppFilters';
export * from '../models/ApplicationOverride';
export * from '../models/AppsCondition';
export * from '../models/AppsDetails';
export * from '../models/AtlasOrganization';
export * from '../models/AtlasProject';
export * from '../models/AtlasProjects';
export * from '../models/AuditLog';
export * from '../models/AuditLogAction';
export * from '../models/AuditLogAuthMethod';
export * from '../models/AuditLogAuthStatus';
export * from '../models/AuditLogEntitiesInner';
export * from '../models/AuditLogExtendedData';
export * from '../models/AuditLogExtendedDataAuth';
export * from '../models/AuditLogFilterConditions';
export * from '../models/AuditLogInitiatorType';
export * from '../models/AuditLogMfaMethod';
export * from '../models/AuthResponse';
export * from '../models/AwsAccountConfigInput';
export * from '../models/AwsAccountConnectorProperties';
export * from '../models/AwsAccountConnectorPropertiesInput';
export * from '../models/AwsAccountMetricsDestination';
export * from '../models/AwsDatabaseDestination';
export * from '../models/AwsDynamoDBDestination';
export * from '../models/AwsDynamoDbResource';
export * from '../models/AwsDynamoDbSnapshotProperties';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput';
export * from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner';
export * from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner';
export * from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection';
export * from '../models/AwsEbsSnapshotConvertResult';
export * from '../models/AwsEbsVolumeResource';
export * from '../models/AwsEbsVolumeRestoreData';
export * from '../models/AwsEbsVolumeRestoreResult';
export * from '../models/AwsEbsVolumeSnapshotProperties';
export * from '../models/AwsEc2AmiConvertResult';
export * from '../models/AwsEc2InstanceRestoreDestination';
export * from '../models/AwsEc2InstanceRestoreResult';
export * from '../models/AwsEc2InstanceRestoreTarget';
export * from '../models/AwsEc2Resource';
export * from '../models/AwsEc2SnapshotProperties';
export * from '../models/AwsEksNamespaceResource';
export * from '../models/AwsEksNamespaceSnapshotProperties';
export * from '../models/AwsFsxResource';
export * from '../models/AwsKeyspacesDestination';
export * from '../models/AwsKeyspacesResource';
export * from '../models/AwsNativePitrBackupPolicyPlan';
export * from '../models/AwsNativePitrBackupResourceType';
export * from '../models/AwsNativePitrConfig';
export * from '../models/AwsNeptuneResource';
export * from '../models/AwsRdsEngine';
export * from '../models/AwsRdsResource';
export * from '../models/AwsRdsResourceAurora';
export * from '../models/AwsRdsResourceStorageSettings';
export * from '../models/AwsRedshiftResource';
export * from '../models/AwsRestoreAccountAttributes';
export * from '../models/AwsRestoreAccountAttributesInput';
export * from '../models/AwsRestoreAccountConnectivityConfig';
export * from '../models/AwsRuntimeConfig';
export * from '../models/AwsSourceAccountAttributes';
export * from '../models/AwsSourceAccountAttributesInput';
export * from '../models/AwsVaultConfig';
export * from '../models/AwsVaultConfigInput';
export * from '../models/AwsVpcConnectivityConfig';
export * from '../models/AzureAccountConfigInput';
export * from '../models/AzureAksNamespaceResource';
export * from '../models/AzureAppRegistrationOption';
export * from '../models/AzureBackupApplicationsResponse';
export * from '../models/AzureCmkEligibleApp';
export * from '../models/AzureConsentUrlResponse';
export * from '../models/AzureDisk';
export * from '../models/AzureDiskRestoreData';
export * from '../models/AzureDiskRestoreDestination';
export * from '../models/AzureDiskRestoreResult';
export * from '../models/AzureDiskSettings';
export * from '../models/AzureDiskTarget';
export * from '../models/AzureEonApplication';
export * from '../models/AzureListResourceGroupsResponse';
export * from '../models/AzureListSubscriptionsResponse';
export * from '../models/AzureManagementGroup';
export * from '../models/AzureManagementGroups';
export * from '../models/AzureMarketplaceWebhookInput';
export * from '../models/AzureMarketplaceWebhookInputSubscription';
export * from '../models/AzureMarketplaceWebhookInputSubscriptionBeneficiary';
export * from '../models/AzureMarketplaceWebhookInputSubscriptionPurchaser';
export * from '../models/AzureMarketplaceWebhookInputSubscriptionTerm';
export * from '../models/AzureMssqlSnapshotProperties';
export * from '../models/AzureOnboardedTenantsResponse';
export * from '../models/AzureOnboardingStatus';
export * from '../models/AzurePostgresDatabaseRestoreDestination';
export * from '../models/AzurePostgresDatabaseRestoreTarget';
export * from '../models/AzureResourceGroup';
export * from '../models/AzureResourceGroups';
export * from '../models/AzureRestoreAccountAttributes';
export * from '../models/AzureRestoreAccountAttributesInput';
export * from '../models/AzureRestoreAccountConnectivityConfig';
export * from '../models/AzureRestorePointData';
export * from '../models/AzureRestorePointSpec';
export * from '../models/AzureSapHanaResource';
export * from '../models/AzureScanningAccountSetupStatus200Response';
export * from '../models/AzureSourceAccountAttributes';
export * from '../models/AzureSourceAccountAttributesInput';
export * from '../models/AzureSqlDatabaseRestoreDestination';
export * from '../models/AzureSqlDatabaseRestoreTarget';
export * from '../models/AzureStorageAccount';
export * from '../models/AzureStorageAccounts';
export * from '../models/AzureSubscription';
export * from '../models/AzureTenant';
export * from '../models/AzureVaultConfig';
export * from '../models/AzureVaultConfigInput';
export * from '../models/AzureVaultType';
export * from '../models/AzureVmInstanceRestoreDestination';
export * from '../models/AzureVmInstanceRestoreResult';
export * from '../models/AzureVmInstanceRestoreTarget';
export * from '../models/AzureVmSnapshotProperties';
export * from '../models/AzureVnetConnectivityConfig';
export * from '../models/BackedUpByResourceType';
export * from '../models/BackedUpByResourceTypeDataInner';
export * from '../models/BackedUpStorageDateHistogram';
export * from '../models/BackupControlViolations';
export * from '../models/BackupJob';
export * from '../models/BackupJobResponse';
export * from '../models/BackupJobSortField';
export * from '../models/BackupJobType';
export * from '../models/BackupJobTypeFilters';
export * from '../models/BackupJobsFilterConditions';
export * from '../models/BackupPoliciesFilters';
export * from '../models/BackupPoliciesLimits';
export * from '../models/BackupPoliciesSecurityConfig';
export * from '../models/BackupPolicy';
export * from '../models/BackupPolicyAppliesNotificationArguments';
export * from '../models/BackupPolicyConfig';
export * from '../models/BackupPolicyExpression';
export * from '../models/BackupPolicyGroupCondition';
export * from '../models/BackupPolicyNotificationArguments';
export * from '../models/BackupPolicyPlan';
export * from '../models/BackupPolicyResourceSelector';
export * from '../models/BackupPolicySecurityConfig';
export * from '../models/BackupPolicyType';
export * from '../models/BackupRegionsFilters';
export * from '../models/BackupSchedule';
export * from '../models/BackupScope';
export * from '../models/BackupScopeSummary';
export * from '../models/BackupStatus';
export * from '../models/BackupStatusFilters';
export * from '../models/BackupVault';
export * from '../models/BackupZeroEtlAccessConfiguration';
export * from '../models/BackupZeroEtlAwsAccessConfiguration';
export * from '../models/BackupZeroEtlAwsGlueCatalogConfiguration';
export * from '../models/BackupZeroEtlCatalogConfiguration';
export * from '../models/BackupZeroEtlIdentityColumnField';
export * from '../models/BackupZeroEtlIdentityColumnSpec';
export * from '../models/BackupZeroEtlPolicy';
export * from '../models/BackupZeroEtlResourceSelector';
export * from '../models/BackupZeroEtlRoutingMode';
export * from '../models/BackupZeroEtlRoutingPolicy';
export * from '../models/BackupZeroEtlStorageConfiguration';
export * from '../models/BatchApplicationOverrides';
export * from '../models/BatchMode';
export * from '../models/BatchOperationResponse';
export * from '../models/BatchResourceValidationResult';
export * from '../models/BatchUpdateLlgPoliciesRequest';
export * from '../models/BatchUpdateLlgPolicyItem';
export * from '../models/BatchValidateResourceConfigurationRequest';
export * from '../models/BatchValidateResourceConfigurationResponse';
export * from '../models/BigQueryDatasetDestination';
export * from '../models/BigQueryIntegrationConfig';
export * from '../models/BigQueryNativePitrBackupPolicyPlan';
export * from '../models/BigQueryNativePitrBackupResourceType';
export * from '../models/BigQueryNativePitrConfig';
export * from '../models/BigQueryNativePitrDestination';
export * from '../models/BiglakeCatalogProperties';
export * from '../models/BillingPeriod';
export * from '../models/BillingTransactionHistory';
export * from '../models/BooleanFilters';
export * from '../models/BucketPathPartitionSpec';
export * from '../models/CancelExclusionFromBackupResponse';
export * from '../models/CatalogAccessRequest';
export * from '../models/CatalogAccessResponse';
export * from '../models/CdcBackupModeCheckResult';
export * from '../models/CheckAzureVMNameExists200Response';
export * from '../models/CheckAzureVMNameExistsRequest';
export * from '../models/CheckCdcPrerequisitesResponse';
export * from '../models/Classifications';
export * from '../models/CloudAccountIdFilters';
export * from '../models/CloudAccountNotificationArguments';
export * from '../models/CloudAccountType';
export * from '../models/CloudProviderCondition';
export * from '../models/CloudProviderFilters';
export * from '../models/CloudRegion';
export * from '../models/CloudResourceAttachmentEvent';
export * from '../models/CloudResourceAttachmentEventType';
export * from '../models/CloudResourceConfiguration';
export * from '../models/CloudResourceConfigurationCdcBackup';
export * from '../models/CloudResourceConfigurationInventoryBackup';
export * from '../models/CloudResourceSecurityProperties';
export * from '../models/CloudSnapshotsPerVolume';
export * from '../models/ClusterNameFilters';
export * from '../models/ColumnMetadata';
export * from '../models/CompactionStrategy';
export * from '../models/CompanyContact';
export * from '../models/Condition';
export * from '../models/ConditionOperatorEnum';
export * from '../models/ConnectAtlasOrganizationRequest';
export * from '../models/ConnectAtlasOrganizationResponse';
export * from '../models/ConnectAzureBackupAccountRequest';
export * from '../models/ConnectAzureBackupApplicationsRequest';
export * from '../models/ConnectAzureRestoreAccountRequest';
export * from '../models/ConnectAzureSourceAccountRequest';
export * from '../models/ConnectAzureVaultAccountRequest';
export * from '../models/ConnectBYOApps200Response';
export * from '../models/ConnectBYOAppsRequest';
export * from '../models/ConnectBYOAzureBackupApplicationsRequest';
export * from '../models/ConnectCustomerVaultAccountRequest';
export * from '../models/ConnectCustomerVaultAccountResponse';
export * from '../models/ConnectGcpFolderRequest';
export * from '../models/ConnectGcpFolderResponse';
export * from '../models/ConnectGcpOrganizationRequest';
export * from '../models/ConnectGcpOrganizationResponse';
export * from '../models/ConnectRestoreAccountRequest';
export * from '../models/ConnectRestoreAccountResponse';
export * from '../models/ConnectSourceAccountRequest';
export * from '../models/ConnectSourceAccountResponse';
export * from '../models/ConnectSourceAwsOrganizationalUnitRequest';
export * from '../models/ConnectSourceAwsOrganizationalUnitResponse';
export * from '../models/Connector';
export * from '../models/ConnectorStatus';
export * from '../models/ConnectorType';
export * from '../models/Control';
export * from '../models/ControlPlaneConfig';
export * from '../models/ControlRules';
export * from '../models/ControlViolation';
export * from '../models/ControlViolations';
export * from '../models/ControlViolationsPerSeverity';
export * from '../models/ControlViolationsPerSeverityViolatedControlsInner';
export * from '../models/ControlsFilters';
export * from '../models/ConvertEbsSnapshotConfig';
export * from '../models/ConvertEc2ImageConfig';
export * from '../models/ConvertOtherSnapshotsOnDemandRequest';
export * from '../models/ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner';
export * from '../models/ConvertResourceSnapshotsRequest';
export * from '../models/ConvertResourceSnapshotsResponse';
export * from '../models/Cost';
export * from '../models/CostDataFilters';
export * from '../models/CostDataGroupBy';
export * from '../models/CostDataRecord';
export * from '../models/CostDataRecordCost';
export * from '../models/CostDataRecordDimensions';
export * from '../models/CostGranularity';
export * from '../models/CostRecordMetadata';
export * from '../models/CostRecordMetadataDataTransfer';
export * from '../models/CostRecordMetadataType';
export * from '../models/CostUnit';
export * from '../models/CreateAccountInput';
export * from '../models/CreateApiCredentialsRequest';
export * from '../models/CreateApiCredentialsResponse';
export * from '../models/CreateBackupPolicyRequest';
export * from '../models/CreateBackupPolicyResponse';
export * from '../models/CreateBackupZeroEtlPolicyInput';
export * from '../models/CreateConnectorInput';
export * from '../models/CreateDashboardInput';
export * from '../models/CreateDataCatalogInput';
export * from '../models/CreateDlsgPolicyRequest';
export * from '../models/CreateDlsgPolicyResponse';
export * from '../models/CreateFabricTableShortcutDemoRequest';
export * from '../models/CreateFabricTableShortcutDemoRequestShortcutsInner';
export * from '../models/CreateFabricTableShortcutDemoResponse';
export * from '../models/CreateFabricTableShortcutDemoResponseResultsInner';
export * from '../models/CreateGraphInput';
export * from '../models/CreateIdpGroupRequest';
export * from '../models/CreateIdpGroupResponse';
export * from '../models/CreateInfectedExcludePathInput';
export * from '../models/CreateIngestionPipelineInput';
export * from '../models/CreateIntegrationRequest';
export * from '../models/CreateIntegrationResponse';
export * from '../models/CreateJobTemplateInput';
export * from '../models/CreateNotebookInput';
export * from '../models/CreateOAuthAppRequest';
export * from '../models/CreateOAuthAppResponse';
export * from '../models/CreatePolicyInput';
export * from '../models/CreatePolicyScheduleInput';
export * from '../models/CreatePrivateLinkInput';
export * from '../models/CreateProjectInput';
export * from '../models/CreatePulumiConfigurationRequest';
export * from '../models/CreateRoleRequest';
export * from '../models/CreateRoleResponse';
export * from '../models/CreateSamlIdentityProviderConfigInput';
export * from '../models/CreateSavedQueryInput';
export * from '../models/CreateScanJobInput';
export * from '../models/CreateScanJobResponse';
export * from '../models/CreateSessionRequest';
export * from '../models/CreateSparkEngineInput';
export * from '../models/CreateSqlEngineInput';
export * from '../models/CreateUserInput';
export * from '../models/CreateVaultRequest';
export * from '../models/CreateVaultResponse';
export * from '../models/CreateVpcPeeringInput';
export * from '../models/CreateZeroEtlPolicyInput';
export * from '../models/CredentialFinding';
export * from '../models/CreditsMonthlyUsageNotificationArguments';
export * from '../models/CreditsNotificationArguments';
export * from '../models/CrossResourceQueryRequest';
export * from '../models/CrossResourceQueryRequestResourcesInner';
export * from '../models/CustomTagsInner';
export * from '../models/CustomerVaultAccount';
export * from '../models/DBResourceMetadata';
export * from '../models/DBServerRecord';
export * from '../models/DBSnapshotMetadata';
export * from '../models/DBSnapshotType';
export * from '../models/DailyConfig';
export * from '../models/DailySnapshotData';
export * from '../models/DailyStorageSummaries';
export * from '../models/DailyStorageSummary';
export * from '../models/Dashboard';
export * from '../models/DashboardGraph';
export * from '../models/DashboardGraphLayout';
export * from '../models/DashboardWithGraphs';
export * from '../models/DataCatalog';
export * from '../models/DataCatalogType';
export * from '../models/DataClass';
export * from '../models/DataClassesCondition';
export * from '../models/DataClassesDetails';
export * from '../models/DataClassesFilters';
export * from '../models/DataClassificationEntity';
export * from '../models/DataShareIntegrationConfig';
export * from '../models/DataTransferOperationType';
export * from '../models/DatabaseDestination';
export * from '../models/DatabaseRecord';
export * from '../models/DatabricksIntegrationConfig';
export * from '../models/DayOfWeek';
export * from '../models/DeactivateAccountRequest';
export * from '../models/DeactivateAccountResponse';
export * from '../models/DeactivateAtlasOrganizationResponse';
export * from '../models/DeactivateGcpFolderResponse';
export * from '../models/DeactivateGcpOrganizationResponse';
export * from '../models/DeleteRestoreAccountV1Request';
export * from '../models/DestinationDetails';
export * from '../models/DestinationProviderAttributes';
export * from '../models/DestinationProviderAttributesAzure';
export * from '../models/DestinationRestoreTypeAttributes';
export * from '../models/DetectorSummary';
export * from '../models/DetectorType';
export * from '../models/DisableResourceOverrideLimitsResponse';
export * from '../models/DisconnectCustomerVaultAccountResponse';
export * from '../models/DisconnectRestoreAccountResponse';
export * from '../models/DisconnectSourceAccountResponse';
export * from '../models/DisconnectSourceAwsOrganizationalUnitResponse';
export * from '../models/DiscoveryInvokeParams';
export * from '../models/DiscoveryJob';
export * from '../models/DiscoveryStatusResponse';
export * from '../models/DlsgPolicy';
export * from '../models/DlsgPolicyConfig';
export * from '../models/DlsgPolicyFilters';
export * from '../models/DlsgPolicyPlan';
export * from '../models/DlsgSettings';
export * from '../models/DocumentDBRestoreDestination';
export * from '../models/DocumentDbClusterParameterGroup';
export * from '../models/DocumentDbClusterParameterGroups';
export * from '../models/DocumentDbSnapshotProperties';
export * from '../models/DriftProtectionPolicy';
export * from '../models/DriftProtectionSummary';
export * from '../models/DriftProtectionTimePoint';
export * from '../models/DynamoDBAdvancedIndexConfig';
export * from '../models/DynamoDBRestoreMethodAvailabilityRequest';
export * from '../models/DynamoDBRestoreMethodAvailabilityResponse';
export * from '../models/DynamoDbBackupConfig';
export * from '../models/DynamoDbBackupConfigApplication';
export * from '../models/DynamoDbBillingMode';
export * from '../models/DynamodbTableRestoreDestination';
export * from '../models/EFSRestoreDestination';
export * from '../models/EbsRestoreDestination';
export * from '../models/EbsSnapshotRestoreDestination';
export * from '../models/EbsSnapshotTarget';
export * from '../models/EbsTarget';
export * from '../models/EfsSnapshotProperties';
export * from '../models/EksCluster';
export * from '../models/EksClusterStatus';
export * from '../models/EksNamespaceRestoreDestination';
export * from '../models/EksNamespaceRestoreResult';
export * from '../models/EksVolumeRestoreResult';
export * from '../models/EmrIntegrationConfig';
export * from '../models/EnableFromLimitExceededResponse';
export * from '../models/EnableResourceOverrideLimitsResponse';
export * from '../models/EnableRestoreAccountMetricsConfigRequest';
export * from '../models/EnableRestoreAccountMetricsConfigResponse';
export * from '../models/EnableSourceAccountMetricsConfigRequest';
export * from '../models/EnableSourceAccountMetricsConfigResponse';
export * from '../models/EncryptionKey';
export * from '../models/EncryptionKeys';
export * from '../models/EndTimeDateFilters';
export * from '../models/Environment';
export * from '../models/EnvironmentCondition';
export * from '../models/EnvironmentDetails';
export * from '../models/EnvironmentFilters';
export * from '../models/EonAccount';
export * from '../models/EonAccountIdFilters';
export * from '../models/EonAccountStatus';
export * from '../models/EonSparkVersion';
export * from '../models/ErrorCode';
export * from '../models/ErrorPolicy';
export * from '../models/ExcludeFromBackupResponse';
export * from '../models/ExecuteNotebookCodeInput';
export * from '../models/ExportCostData400Response';
export * from '../models/ExportCostDataRequest';
export * from '../models/FSxRestoreDestination';
export * from '../models/FSxRestoreDestinationOntapRestoreOptions';
export * from '../models/FeatureFlagOverrideGet200Response';
export * from '../models/FileExplorerCountSecurityAlertsInResourceResponse';
export * from '../models/FileExplorerResponse';
export * from '../models/FileFormat';
export * from '../models/FilePath';
export * from '../models/FileRestoreData';
export * from '../models/FileSearchRecord';
export * from '../models/FileSnapshot';
export * from '../models/FindingCountEntry';
export * from '../models/FindingEntry';
export * from '../models/ForceDeleteSnapshotsRequest';
export * from '../models/FreeTextFilters';
export * from '../models/FsxOntapVolume';
export * from '../models/FsxSnapshotProperties';
export * from '../models/FsxVolumeBackupInfo';
export * from '../models/GCSBucket';
export * from '../models/GCSBuckets';
export * from '../models/GCSRestoreDestination';
export * from '../models/GCSRestoreTarget';
export * from '../models/GcpAccountConfigInput';
export * from '../models/GcpBigQueryResource';
export * from '../models/GcpBigQueryResourceMaterializedViewsInner';
export * from '../models/GcpBigQueryResourceRoutinesInner';
export * from '../models/GcpBigQueryResourceTablesInner';
export * from '../models/GcpBigQueryResourceViewsInner';
export * from '../models/GcpCloudSqlResource';
export * from '../models/GcpCloudSqlResourceStorageSettings';
export * from '../models/GcpCloudSqlRestoreDestination';
export * from '../models/GcpCloudSqlSnapshotProperties';
export * from '../models/GcpCloudSqlTarget';
export * from '../models/GcpDiskResource';
export * from '../models/GcpDiskRestoreData';
export * from '../models/GcpDiskRestoreDestination';
export * from '../models/GcpDiskSettings';
export * from '../models/GcpDiskSnapshotProperties';
export * from '../models/GcpDiskTarget';
export * from '../models/GcpDiskTypesResponse';
export * from '../models/GcpEncryptionKey';
export * from '../models/GcpEncryptionKeys';
export * from '../models/GcpGkeNamespaceResource';
export * from '../models/GcpMachineTypesResponse';
export * from '../models/GcpNetworkConnectivityConfig';
export * from '../models/GcpNetworkType';
export * from '../models/GcpOrganization';
export * from '../models/GcpProjectConnectorProperties';
export * from '../models/GcpProjectConnectorPropertiesInput';
export * from '../models/GcpRestoreAccountAttributes';
export * from '../models/GcpRestoreAccountAttributesInput';
export * from '../models/GcpRestoreAccountConnectivityConfig';
export * from '../models/GcpSapHanaResource';
export * from '../models/GcpSourceAccountAttributes';
export * from '../models/GcpSourceAccountAttributesInput';
export * from '../models/GcpSubnet';
export * from '../models/GcpSubnetPerRegion';
export * from '../models/GcpVaultConfig';
export * from '../models/GcpVaultConfigInput';
export * from '../models/GcpVmInstanceRestoreDestination';
export * from '../models/GcpVmInstanceRestoreResult';
export * from '../models/GcpVmInstanceRestoreTarget';
export * from '../models/GcpVmResource';
export * from '../models/GcpVmSnapshotProperties';
export * from '../models/GcsSourceProperties';
export * from '../models/GenericSnapshotData';
export * from '../models/GetAWSStackDetailsResponse';
export * from '../models/GetAdditionalAzureAppsOnboardingStatus200Response';
export * from '../models/GetAgreementsResponse';
export * from '../models/GetAwsPrivateLinkStatusResponse';
export * from '../models/GetBackupJobResponse';
export * from '../models/GetBackupPolicyResponse';
export * from '../models/GetBillingPeriodsResponse';
export * from '../models/GetCloudResourceSecurityPropertiesResponse';
export * from '../models/GetCredits400Response';
export * from '../models/GetCreditsResponse';
export * from '../models/GetDlsgPolicyResponse';
export * from '../models/GetGcsServiceAgentResponse';
export * from '../models/GetIdpGroupResponse';
export * from '../models/GetIntegrationResponse';
export * from '../models/GetLimitsResponseValue';
export * from '../models/GetNotebookContent200Response';
export * from '../models/GetProjectConfigurationKeyResponse';
export * from '../models/GetProjectConfigurationKeysResponse';
export * from '../models/GetResourceResponse';
export * from '../models/GetRestoreAccountConnectivityConfigResponse';
export * from '../models/GetRestoreAccountMetricsConfigResponse';
export * from '../models/GetRestoreJobResponse';
export * from '../models/GetRoleResponse';
export * from '../models/GetScanJobResponse';
export * from '../models/GetSnapshotResponse';
export * from '../models/GetSourceAccountMetricsConfigResponse';
export * from '../models/GetSqlVmNetworkInfoRequest';
export * from '../models/GetSqlVmNetworkInfoResponse';
export * from '../models/GetVaultResponse';
export * from '../models/GlobalClusterIdentifierCondition';
export * from '../models/GlueCatalogProperties';
export * from '../models/HighFrequencyBackupPolicyPlan';
export * from '../models/HighFrequencyBackupResourceType';
export * from '../models/HighFrequencyBackupScheduleConfig';
export * from '../models/HighFrequencyBackupScheduleFrequency';
export * from '../models/HighFrequencyBackupSchedules';
export * from '../models/HighFrequencyIntervalConfig';
export * from '../models/IDs';
export * from '../models/IcebergRestCatalogAuthType';
export * from '../models/IcebergRestCatalogProperties';
export * from '../models/IdFilters';
export * from '../models/Identifier';
export * from '../models/IdentityProvidersNames';
export * from '../models/Idp';
export * from '../models/IdpGroup';
export * from '../models/ImportDlsgCertificateRequest';
export * from '../models/IndexRestoreMode';
export * from '../models/InfectedDataByClassification';
export * from '../models/InfectedDataClassificationSize';
export * from '../models/InfectedDataOverTime';
export * from '../models/InfectedDateSize';
export * from '../models/InfectedExcludePath';
export * from '../models/InfectedResourcesCountResponse';
export * from '../models/IngestionPipeline';
export * from '../models/IngestionPipelineStatus';
export * from '../models/IngestionSourceType';
export * from '../models/InitAuthInput';
export * from '../models/Initiator';
export * from '../models/InitiatorNameFilters';
export * from '../models/IntegConfig';
export * from '../models/IntegType';
export * from '../models/IntegrationConfig';
export * from '../models/InventoryFilterConditions';
export * from '../models/InventoryGcpDisk';
export * from '../models/InventoryResource';
export * from '../models/InventoryResourceMetadata';
export * from '../models/InventorySnapshotVolume';
export * from '../models/InventoryVault';
export * from '../models/InventoryVolume';
export * from '../models/IsVaultDeletableResponse';
export * from '../models/IssueMutedNotificationArguments';
export * from '../models/JobExecutionDetails';
export * from '../models/JobFailedNotificationArguments';
export * from '../models/JobIdFilters';
export * from '../models/JobInitiationResponse';
export * from '../models/JobMetricsReportFailedArguments';
export * from '../models/JobSnapshotDetails';
export * from '../models/JobStatus';
export * from '../models/JobStatusFilters';
export * from '../models/JobStep';
export * from '../models/JobStepName';
export * from '../models/JobStepStatus';
export * from '../models/JobSucceededNotificationArguments';
export * from '../models/JobTemplate';
export * from '../models/KafkaBatchConfig';
export * from '../models/KafkaErrorHandlingConfig';
export * from '../models/KafkaKeyHandling';
export * from '../models/KafkaMessageFormat';
export * from '../models/KafkaPartitioningConfig';
export * from '../models/KafkaSaslMechanism';
export * from '../models/KafkaSecurityConfig';
export * from '../models/KafkaSecurityProtocol';
export * from '../models/KafkaSourceConfig';
export * from '../models/KafkaSourceProperties';
export * from '../models/KafkaStartingOffset';
export * from '../models/KeyspacesBackupConfig';
export * from '../models/KeyspacesBackupConfigApplication';
export * from '../models/KeyspacesTableRestoreDestination';
export * from '../models/KubeAccessStatus';
export * from '../models/KubernetesAccessMode';
export * from '../models/LimitData';
export * from '../models/ListAccountsResponse';
export * from '../models/ListAllRegionsResponse';
export * from '../models/ListAllRegionsResponseRegions';
export * from '../models/ListApiCredentialsResponse';
export * from '../models/ListApplicationOverrideResponse';
export * from '../models/ListAtlasOrganizationsResponse';
export * from '../models/ListAuditLogRequest';
export * from '../models/ListAuditLogResponse';
export * from '../models/ListAuditLogsResponse';
export * from '../models/ListAwsVpcsResponse';
export * from '../models/ListAwsVpcsResponseVpcsInner';
export * from '../models/ListAzureAppRegistrationsResponse';
export * from '../models/ListAzureCmkEligibleAppsResponse';
export * from '../models/ListAzureRegions200Response';
export * from '../models/ListAzureSKUs200Response';
export * from '../models/ListAzureSKUs200ResponseSkusInner';
export * from '../models/ListAzureSKUsRequest';
export * from '../models/ListAzureStorageAccountContainers200Response';
export * from '../models/ListAzureStorageAccountContainersRequest';
export * from '../models/ListAzureSubnets200Response';
export * from '../models/ListAzureSubnets200ResponseSubnetsInner';
export * from '../models/ListAzureSubnetsRequest';
export * from '../models/ListAzureUnassignedNetworkInterfaces200Response';
export * from '../models/ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner';
export * from '../models/ListAzureUnassignedNetworkInterfacesRequest';
export * from '../models/ListAzureVirtualNetworks200Response';
export * from '../models/ListAzureVirtualNetworks200ResponseVirtualNetworksInner';
export * from '../models/ListAzureVirtualNetworksRequest';
export * from '../models/ListBackupJobTypesResponse';
export * from '../models/ListBackupJobsInternal200Response';
export * from '../models/ListBackupJobsRequest';
export * from '../models/ListBackupJobsResponse';
export * from '../models/ListBackupPoliciesResponse';
export * from '../models/ListBackupPolicyResponse';
export * from '../models/ListBackupVaultResponse';
export * from '../models/ListBackupZeroEtlPoliciesResponse';
export * from '../models/ListBillingTransactionHistoryRequest';
export * from '../models/ListBillingTransactionHistoryResponse';
export * from '../models/ListCloudSnapshotsResponse';
export * from '../models/ListConnectorsResponse';
export * from '../models/ListControlViolationsResponse';
export * from '../models/ListControlsResponse';
export * from '../models/ListCredentialFindingsResponse';
export * from '../models/ListDailySnapshotsResponse';
export * from '../models/ListDashboardsResponse';
export * from '../models/ListDataCatalogsResponse';
export * from '../models/ListDataClassificationEntitiesResponse';
export * from '../models/ListDatabaseSnapshotsResponse';
export * from '../models/ListDlsgPoliciesResponse';
export * from '../models/ListDynamoDbBackupConfigsResponse';
export * from '../models/ListEksClustersResponse';
export * from '../models/ListFindingsResponse';
export * from '../models/ListGcpFoldersResponse';
export * from '../models/ListGcpNetworksResponse';
export * from '../models/ListGcpNetworksResponseNetworksInner';
export * from '../models/ListGcpOrganizationsResponse';
export * from '../models/ListGcpSubnetsResponse';
export * from '../models/ListIdpGroupsResponse';
export * from '../models/ListIdpsResponse';
export * from '../models/ListInfectedExcludePathsResponse';
export * from '../models/ListIngestionPipelinesResponse';
export * from '../models/ListInstanceProfilesResponse';
export * from '../models/ListInstanceTypesResponse';
export * from '../models/ListIntegrationsResponse';
export * from '../models/ListInventoryAppsResponse';
export * from '../models/ListInventoryBackupRegionsResponse';
export * from '../models/ListInventoryEnvironmentsResponse';
export * from '../models/ListInventoryGlobalDatabasesResponse';
export * from '../models/ListInventoryItemSnapshotsResponse';
export * from '../models/ListInventoryNetworksResponse';
export * from '../models/ListInventoryRequest';
export * from '../models/ListInventoryResourceGroupsResponse';
export * from '../models/ListInventoryResourceIdentifiersResponse';
export * from '../models/ListInventoryResourceTypesResponse';
export * from '../models/ListInventoryResourcesResponse';
export * from '../models/ListInventorySensitivityAnnotationValuesResponse';
export * from '../models/ListInventorySnapshotsRequest';
export * from '../models/ListInventorySnapshotsResponse';
export * from '../models/ListInventorySourceRegionsResponse';
export * from '../models/ListInventorySubnetsResponse';
export * from '../models/ListInventoryTagsResponse';
export * from '../models/ListJobErrorCodesResponse';
export * from '../models/ListJobTemplatesResponse';
export * from '../models/ListKeyspacesBackupConfigsResponse';
export * from '../models/ListKnownAppsResponse';
export * from '../models/ListLogSourcesPoliciesResponse';
export * from '../models/ListLogSourcesResponse';
export * from '../models/ListMongoAtlasPrivateLinks200Response';
export * from '../models/ListNotebooksResponse';
export * from '../models/ListNotificationPoliciesResponse';
export * from '../models/ListNotificationsResponse';
export * from '../models/ListOAuthAppsResponse';
export * from '../models/ListObjectStoreExclusionRulesResponse';
export * from '../models/ListOperators';
export * from '../models/ListPermissionsResponse';
export * from '../models/ListProjectsResponse';
export * from '../models/ListResourceAttachmentEventsResponse';
export * from '../models/ListResourcesResponse';
export * from '../models/ListRestoreAccountsRequest';
export * from '../models/ListRestoreAccountsResponse';
export * from '../models/ListRestoreJobTypesResponse';
export * from '../models/ListRestoreJobsInternal200Response';
export * from '../models/ListRestoreJobsRequest';
export * from '../models/ListRestoreJobsResponse';
export * from '../models/ListRolesResponse';
export * from '../models/ListSavedQueriesResponse';
export * from '../models/ListScanJobTypesResponse';
export * from '../models/ListScanJobsInternal200Response';
export * from '../models/ListScanJobsRequest';
export * from '../models/ListScanJobsResponse';
export * from '../models/ListSensitivityAnnotationsResponse';
export * from '../models/ListSourceAccountsRequest';
export * from '../models/ListSourceAccountsResponse';
export * from '../models/ListSourceAwsOrganizationalUnitsResponse';
export * from '../models/ListSparkEnginesResponse';
export * from '../models/ListSparkJobsResponse';
export * from '../models/ListSqlEnginesResponse';
export * from '../models/ListSqlQueryExecutionsResponse';
export * from '../models/ListStorageGatewaysResponse';
export * from '../models/ListSubnetsResponse';
export * from '../models/ListSubnetsResponseV2';
export * from '../models/ListSubnetsResponseV2SubnetsInner';
export * from '../models/ListUsersResponse';
export * from '../models/ListZeroEtlPoliciesResponse';
export * from '../models/LlgLocationResource';
export * from '../models/LlgLocationWithResources';
export * from '../models/LlgResourcePolicy';
export * from '../models/LogRecord';
export * from '../models/LogSource';
export * from '../models/LogSourceLocation';
export * from '../models/LogSourceLocationCloudTrail';
export * from '../models/LogSourceLocationCloudWatchLogs';
export * from '../models/LogSourceLocationDatadog';
export * from '../models/LogSourceLocationGcpCloudLogging';
export * from '../models/LogSourceLocationSplunkDdss';
export * from '../models/LogSourceWithPolicy';
export * from '../models/LogicalOperator';
export * from '../models/LogsHistogramDataPoint';
export * from '../models/LogsSchema';
export * from '../models/LogsSchemaColumn';
export * from '../models/LogsSchemaEntry';
export * from '../models/LogsSchemasResponse';
export * from '../models/LuceneQueryInput';
export * from '../models/MaxRetentionRule';
export * from '../models/Message';
export * from '../models/MeteringDimension';
export * from '../models/MicrosoftFabricIntegrationConfig';
export * from '../models/MinRetentionRule';
export * from '../models/ModelError';
export * from '../models/MongoAtlasPrivateLinkEntry';
export * from '../models/MongoAtlasRestoreAccountAttributes';
export * from '../models/MongoAtlasRestoreAccountAttributesInput';
export * from '../models/MongoAtlasSourceAccountAttributes';
export * from '../models/MongoAtlasSourceAccountAttributesInput';
export * from '../models/MonthlyConfig';
export * from '../models/MonthlySnapshotData';
export * from '../models/MsaAcceptanceResponse';
export * from '../models/NativeStandardBackupPolicyPlan';
export * from '../models/NativeStandardBackupSchedules';
export * from '../models/NativeStandardConfig';
export * from '../models/NeptuneClusterParameterGroup';
export * from '../models/NeptuneClusterParameterGroups';
export * from '../models/NeptuneRestoreDestination';
export * from '../models/NeptuneSnapshotProperties';
export * from '../models/NetworkInterfaceConfig';
export * from '../models/Notebook';
export * from '../models/NotebookExecutionOutput';
export * from '../models/NotebookExecutionResult';
export * from '../models/NotebookSession';
export * from '../models/NotebookSessionStatus';
export * from '../models/Notification';
export * from '../models/NotificationArguments';
export * from '../models/NotificationPolicy';
export * from '../models/NotificationPolicyConfig';
export * from '../models/NotificationPolicyConfigEmail';
export * from '../models/NotificationPolicyConfigServiceNow';
export * from '../models/NotificationPolicyConfigSlack';
export * from '../models/NotificationPolicyConfigSns';
export * from '../models/NotificationPolicyConfigSplunk';
export * from '../models/NotificationPolicyConfigWebhook';
export * from '../models/NotificationStatus';
export * from '../models/NotificationType';
export * from '../models/NumberOfCopiesRule';
export * from '../models/OAuthApp';
export * from '../models/Oauth2TokenResponse';
export * from '../models/ObjectStorageDestination';
export * from '../models/ObjectStoreExclusionRule';
export * from '../models/OnboardAdditionalAzureApps200Response';
export * from '../models/OnboardAdditionalAzureAppsRequest';
export * from '../models/OnboardRdsCdcRequest';
export * from '../models/OnboardRdsCdcResponse';
export * from '../models/OnboardingAzureResourceGroup';
export * from '../models/OperationIdFilters';
export * from '../models/OverrideDataClassificationsRequest';
export * from '../models/OverrideDataClassificationsResponse';
export * from '../models/OverrideEnvironmentRequest';
export * from '../models/OverrideEnvironmentResponse';
export * from '../models/OverrideSensitivityAnnotationsRequest';
export * from '../models/Pagination';
export * from '../models/ParameterCheckResult';
export * from '../models/ParentIdFilters';
export * from '../models/PartialRestoreData';
export * from '../models/PartialRestoreType';
export * from '../models/PartitionFormat';
export * from '../models/PartitionSegmentType';
export * from '../models/PartitionType';
export * from '../models/Path';
export * from '../models/PathSegment';
export * from '../models/PathSnapshotsRequest';
export * from '../models/PathSnapshotsResponse';
export * from '../models/PathType';
export * from '../models/Permission';
export * from '../models/PermissionCategory';
export * from '../models/PermissionGrant';
export * from '../models/PermissionGrantInput';
export * from '../models/PermissionType';
export * from '../models/PersistentVolumeClaimProperties';
export * from '../models/PitrBackupPolicyPlan';
export * from '../models/PitrBackupResourceType';
export * from '../models/PitrBackupSchedules';
export * from '../models/PitrIntervalConfig';
export * from '../models/PitrRestoreVaultWindows';
export * from '../models/PitrRestoreWindow';
export * from '../models/PitrRestoreWindowsResponse';
export * from '../models/Preferences';
export * from '../models/PrivateLink';
export * from '../models/PrivateLinkCheckResult';
export * from '../models/PrivateLinkFormatInstructions';
export * from '../models/PrivateLinkInstructionStep';
export * from '../models/PrivateLinkStatus';
export * from '../models/Project';
export * from '../models/ProjectConfigurationKeyEnum';
export * from '../models/ProjectIdFilters';
export * from '../models/Provider';
export * from '../models/ProviderAccountIdFilters';
export * from '../models/ProviderParentIdFilters';
export * from '../models/ProviderRestoreAccountConnectivityConfig';
export * from '../models/PulumiConfiguration';
export * from '../models/PulumiConfigurations';
export * from '../models/PulumiConfigurationsFilterConditions';
export * from '../models/PulumiConfigurationsRequest';
export * from '../models/QueryCostData400Response';
export * from '../models/QueryCostDataRequest';
export * from '../models/QueryCostDataResponse';
export * from '../models/QueryDBRequest';
export * from '../models/QueryDBResponse';
export * from '../models/QueryDBRestoreDestination';
export * from '../models/QueryDBRestoreDestinationType';
export * from '../models/QueryDBResultResponse';
export * from '../models/QueryDBStatus';
export * from '../models/QueryDBStatusResponse';
export * from '../models/QuotaStatus';
export * from '../models/QuotaStatusFilters';
export * from '../models/RamShareCheckResult';
export * from '../models/RansomwareResourceNotificationArguments';
export * from '../models/RdsNativePitrAdvancedConfig';
export * from '../models/RdsNativePitrClusterAdvancedConfig';
export * from '../models/RdsNativePitrNetworkConfig';
export * from '../models/RdsNativePitrWindow';
export * from '../models/RdsPasswordConfig';
export * from '../models/RdsSecurityGroup';
export * from '../models/ReactivateAccountRequest';
export * from '../models/ReconnectCustomerVaultAccountResponse';
export * from '../models/ReconnectRestoreAccountResponse';
export * from '../models/ReconnectSourceAccountResponse';
export * from '../models/ReconnectSourceAwsOrganizationalUnitResponse';
export * from '../models/RecordRestoreResult';
export * from '../models/RecoveryPointData';
export * from '../models/RedshiftCluster';
export * from '../models/RedshiftClusters';
export * from '../models/RedshiftIntegrationConfig';
export * from '../models/RedshiftRestoreDestination';
export * from '../models/RedshiftServerlessNamespace';
export * from '../models/RedshiftServerlessNamespaces';
export * from '../models/RedshiftSnapshotProperties';
export * from '../models/RegionCondition';
export * from '../models/RegisterInput';
export * from '../models/RegisterInputBillingToken';
export * from '../models/RegisterResponse';
export * from '../models/RelatedGlobalDbCluster';
export * from '../models/RequestDetails';
export * from '../models/ResourceDetails';
export * from '../models/ResourceGroupNameCondition';
export * from '../models/ResourceIdCondition';
export * from '../models/ResourceIdFilters';
export * from '../models/ResourceIdentifiers';
export * from '../models/ResourceNameCondition';
export * from '../models/ResourceNameFilters';
export * from '../models/ResourceProperties';
export * from '../models/ResourceSelectorMode';
export * from '../models/ResourceSnapshot';
export * from '../models/ResourceSnapshotProperties';
export * from '../models/ResourceSortField';
export * from '../models/ResourceTag';
export * from '../models/ResourceType';
export * from '../models/ResourceTypeCondition';
export * from '../models/ResourceTypeFilters';
export * from '../models/ResourceTypeToSecurityGroup';
export * from '../models/ResourceValidationError';
export * from '../models/RestoreAccount';
export * from '../models/RestoreAccountAttributesInput';
export * from '../models/RestoreAccountCloudAttributes';
export * from '../models/RestoreAccountConnectivityConfig';
export * from '../models/RestoreAccountMetricsConfig';
export * from '../models/RestoreAccountRegions';
export * from '../models/RestoreAccountSortField';
export * from '../models/RestoreAccountsFilterConditions';
export * from '../models/RestoreAtlasClusterInput';
export * from '../models/RestoreAvailabilityZones';
export * from '../models/RestoreAwsEc2InstanceRequest';
export * from '../models/RestoreAzureDiskConfig';
export * from '../models/RestoreAzureDiskRequest';
export * from '../models/RestoreAzureInstanceDiskInput';
export * from '../models/RestoreAzurePostgresDatabaseRequest';
export * from '../models/RestoreAzureSqlDatabaseRequest';
export * from '../models/RestoreAzureSqlVmPitrRequest';
export * from '../models/RestoreAzureVMInstanceConfig';
export * from '../models/RestoreAzureVmInstanceRequest';
export * from '../models/RestoreBigQueryDatasetRequest';
export * from '../models/RestoreBigQueryNativePitrRequest';
export * from '../models/RestoreBucketRequest';
export * from '../models/RestoreDbToRdsInstanceRequest';
export * from '../models/RestoreDbToRdsSnapshotRequest';
export * from '../models/RestoreDestinationLimits';
export * from '../models/RestoreDocumentDBRequest';
export * from '../models/RestoreDynamoDBTableRequest';
export * from '../models/RestoreDynamoDBToExistingTableRequest';
export * from '../models/RestoreDynamoDbTableConfig';
export * from '../models/RestoreEFSRequest';
export * from '../models/RestoreEbsVolumeConfig';
export * from '../models/RestoreEc2InstanceConfig';
export * from '../models/RestoreEksNamespaceConfig';
export * from '../models/RestoreEksNamespaceInput';
export * from '../models/RestoreEksNamespaceVolumeInput';
export * from '../models/RestoreFSxRequest';
export * from '../models/RestoreFilesRequest';
export * from '../models/RestoreGceDiskConfig';
export * from '../models/RestoreGceInstanceConfig';
export * from '../models/RestoreGcpCloudSqlDatabaseConfig';
export * from '../models/RestoreGcpCloudSqlRequest';
export * from '../models/RestoreGcpDiskRequest';
export * from '../models/RestoreGcpInstanceDiskInput';
export * from '../models/RestoreGcpVmInstanceRequest';
export * from '../models/RestoreImageImageDeviceInput';
export * from '../models/RestoreImageImageInput';
export * from '../models/RestoreImageInput';
export * from '../models/RestoreImageVolumeInput';
export * from '../models/RestoreInstanceImageDeviceInput';
export * from '../models/RestoreInstanceImageInput';
export * from '../models/RestoreInstanceVolumeInput';
export * from '../models/RestoreJob';
export * from '../models/RestoreJobConfiguration';
export * from '../models/RestoreJobInitiationResponse';
export * from '../models/RestoreJobSortField';
export * from '../models/RestoreJobType';
export * from '../models/RestoreJobTypeFilters';
export * from '../models/RestoreJobsFilterConditions';
export * from '../models/RestoreKeyspacesTableRequest';
export * from '../models/RestoreMethod';
export * from '../models/RestoreMethodAvailabilityReason';
export * from '../models/RestoreNeptuneRequest';
export * from '../models/RestoreRdsInstanceClasses';
export * from '../models/RestoreRdsInstanceConfig';
export * from '../models/RestoreRdsNativePitrRequest';
export * from '../models/RestoreRdsSubnetGroups';
export * from '../models/RestoreRdsSubnetGroupsRdsSubnetGroupsInner';
export * from '../models/RestoreRedshiftRequest';
export * from '../models/RestoreResult';
export * from '../models/RestoreSecurityGroups';
export * from '../models/RestoreSecurityGroupsSecurityGroupsInner';
export * from '../models/RestoreVolumeToEbsRequest';
export * from '../models/RestoreVolumeToEbsSnapshotRequest';
export * from '../models/Role';
export * from '../models/RoleAccessGroupCondition';
export * from '../models/RoleInstallationMethod';
export * from '../models/S3Bucket';
export * from '../models/S3Buckets';
export * from '../models/S3RestoreDestination';
export * from '../models/S3RestoreTarget';
export * from '../models/S3SourceProperties';
export * from '../models/SAMLCallback400Response';
export * from '../models/SAMLCallback401Response';
export * from '../models/SAMLCallback500Response';
export * from '../models/SamlIdentityProvider';
export * from '../models/SamlIdentityProviderConfigsResponse';
export * from '../models/SapHanaInstance';
export * from '../models/SapHanaRestoreProperties';
export * from '../models/SaveCloudResourceSecurityPropertiesRequest';
export * from '../models/SaveNotebookContentRequest';
export * from '../models/SavedQuery';
export * from '../models/ScalarOperators';
export * from '../models/ScanJob';
export * from '../models/ScanJobType';
export * from '../models/ScheduleMode';
export * from '../models/ScheduleType';
export * from '../models/SchemaEvolutionMode';
export * from '../models/SchemaRecord';
export * from '../models/SchemaRegistryAuthConfig';
export * from '../models/SchemaRegistryAuthType';
export * from '../models/SchemaRegistryConfig';
export * from '../models/SearchDBResponse';
export * from '../models/SearchFilesResponse';
export * from '../models/SearchInput';
export * from '../models/SearchLogsHistogramInput';
export * from '../models/SearchLogsHistogramResponse';
export * from '../models/SearchLogsInput';
export * from '../models/SearchLogsResponse';
export * from '../models/SearchResources200Response';
export * from '../models/SearchResources200ResponseTablesInner';
export * from '../models/SearchResources200ResponseTablesInnerResource';
export * from '../models/SearchResources200ResponseTablesInnerSnapshots';
export * from '../models/SearchResources200ResponseTablesInnerSource';
export * from '../models/SearchResources200ResponseTablesInnerTablesInner';
export * from '../models/SearchResources200ResponseTablesInnerTablesInnerColumnsInner';
export * from '../models/SearchResourcesRequest';
export * from '../models/SecurityAssignmentStatus';
export * from '../models/SecurityGroupRule';
export * from '../models/SecurityGroupRuleProtocol';
export * from '../models/SecurityInformation';
export * from '../models/SecurityPlan';
export * from '../models/SecurityPlanEnabledResponse';
export * from '../models/SecurityResourceNotificationArguments';
export * from '../models/SecurityScan';
export * from '../models/SecurityScanConclusion';
export * from '../models/SecurityScanExclusionPathType';
export * from '../models/SecurityScanNotificationData';
export * from '../models/SecurityScanResult';
export * from '../models/SecurityScansSummaryResponse';
export * from '../models/SecuritySnapshotNotificationArguments';
export * from '../models/SecuritySummary';
export * from '../models/SegmentType';
export * from '../models/SendA2AMessageRequest';
export * from '../models/SendMessageToAI400Response';
export * from '../models/SendMessageToAIRequest';
export * from '../models/SensitivityAnnotation';
export * from '../models/SensitivityAnnotationsDetails';
export * from '../models/ServiceProviderDetails';
export * from '../models/Session';
export * from '../models/SetupAwsPrivateLinkRequest';
export * from '../models/SetupAwsPrivateLinkResponse';
export * from '../models/SetupMongoAtlasPrivateLinkRequest';
export * from '../models/SetupMongoAtlasPrivateLinkResponse';
export * from '../models/Severity';
export * from '../models/SeverityFilters';
export * from '../models/Snapshot';
export * from '../models/SnapshotAccessDeniedNotificationArguments';
export * from '../models/SnapshotDateFilters';
export * from '../models/SnapshotFilterConditions';
export * from '../models/SnapshotFindingCountsResponse';
export * from '../models/SnapshotIdFilters';
export * from '../models/SnapshotLocation';
export * from '../models/SnapshotReference';
export * from '../models/SnapshotSortField';
export * from '../models/SnapshotStatus';
export * from '../models/SnapshotStorage';
export * from '../models/SnapshotsSummaryResponse';
export * from '../models/SnowflakeIntegrationConfig';
export * from '../models/SortBackupJobBy';
export * from '../models/SortColumnSpec';
export * from '../models/SortLogsBy';
export * from '../models/SortOrder';
export * from '../models/SortResourceBy';
export * from '../models/SortRestoreAccountsBy';
export * from '../models/SortRestoreJobBy';
export * from '../models/SortSnapshotsBy';
export * from '../models/SortSourceAccountsBy';
export * from '../models/SourceAccount';
export * from '../models/SourceAccountAttributesInput';
export * from '../models/SourceAccountCloudAttributes';
export * from '../models/SourceAccountMetricsConfig';
export * from '../models/SourceAccountProviderIdFilters';
export * from '../models/SourceAccountSortField';
export * from '../models/SourceAccountsFilterConditions';
export * from '../models/SourceAwsOrganizationalUnit';
export * from '../models/SourceRegionFilters';
export * from '../models/SourceSizeCheckResult';
export * from '../models/SourceStorage';
export * from '../models/SourceStorageBackupStatus';
export * from '../models/SparkEngine';
export * from '../models/SparkEngineStatus';
export * from '../models/SparkJob';
export * from '../models/SparkJobRetryPolicy';
export * from '../models/SparkJobSparkSubmitParams';
export * from '../models/SparkJobStatus';
export * from '../models/SqlEngine';
export * from '../models/SqlEngineStatus';
export * from '../models/SqlInstructions';
export * from '../models/SqlQueryExecution';
export * from '../models/SqlQueryExecutionResult';
export * from '../models/SqlQueryExecutionResultColumn';
export * from '../models/SqlQueryExecutionStatus';
export * from '../models/SqlVmNetworkInfo';
export * from '../models/SsoIntegrationSettings';
export * from '../models/StackNameFilters';
export * from '../models/StandardBackupPolicyPlan';
export * from '../models/StandardBackupScheduleConfig';
export * from '../models/StandardBackupScheduleFrequency';
export * from '../models/StandardBackupSchedules';
export * from '../models/StandardIntervalConfig';
export * from '../models/StartNotebookSessionInput';
export * from '../models/StartSparkJobDirectParams';
export * from '../models/StartSparkJobInput';
export * from '../models/StartSparkJobTemplateParams';
export * from '../models/StartSqlQueryExecutionInput';
export * from '../models/StartTimeDateFilters';
export * from '../models/StatusCodeFilters';
export * from '../models/StorageAccountContainerRestoreDestination';
export * from '../models/StorageAccountRestoreTarget';
export * from '../models/StorageConfig';
export * from '../models/StorageGateway';
export * from '../models/StorageGatewayDetails';
export * from '../models/StorageGatewayStatus';
export * from '../models/SubjectNamingStrategy';
export * from '../models/SubnetConfig';
export * from '../models/SubnetFilters';
export * from '../models/SubnetPerAvailabilityZone';
export * from '../models/SubnetsCondition';
export * from '../models/SupportedProviders';
export * from '../models/TableMaintenanceConfig';
export * from '../models/TableRecord';
export * from '../models/TagKeyValue';
export * from '../models/TagKeyValuesCondition';
export * from '../models/TagKeyValuesFilters';
export * from '../models/TagKeysCondition';
export * from '../models/TagKeysFilters';
export * from '../models/TakeNativeSnapshotRequest';
export * from '../models/TakeSnapshotRequest';
export * from '../models/TakeSnapshotResponse';
export * from '../models/TeardownAwsPrivateLinkResponse';
export * from '../models/TeardownMongoAtlasPrivateLinkResponse';
export * from '../models/TimeFrame';
export * from '../models/TimeOfDay';
export * from '../models/TimeOfYear';
export * from '../models/TokenResponse';
export * from '../models/TotalSourceStorageSizeResponse';
export * from '../models/TriggerKeyspacesScheduledDump200Response';
export * from '../models/UnifiedDBRecord';
export * from '../models/UnifiedDBServerRecord';
export * from '../models/UnifiedDatabaseRecord';
export * from '../models/UnifiedSchemaRecord';
export * from '../models/UnifiedTableRecord';
export * from '../models/UpPulumiStacksResponse';
export * from '../models/UpdateAccountCompanyContactsRequest';
export * from '../models/UpdateAccountLabelsRequest';
export * from '../models/UpdateAccountProfileResponse';
export * from '../models/UpdateApiCredentialsRequest';
export * from '../models/UpdateBackupPolicyRequest';
export * from '../models/UpdateBackupPolicyResponse';
export * from '../models/UpdateBackupZeroEtlPolicyInput';
export * from '../models/UpdateCloudResourceConfigurationRequest';
export * from '../models/UpdateCloudResourceConfigurationRequestCdcBackup';
export * from '../models/UpdateCloudResourceConfigurationRequestInventoryBackup';
export * from '../models/UpdateControlViolationInput';
export * from '../models/UpdateDashboardInput';
export * from '../models/UpdateDlsgPolicyRequest';
export * from '../models/UpdateDlsgPolicyResponse';
export * from '../models/UpdateGraphInput';
export * from '../models/UpdateIdpGroupRequest';
export * from '../models/UpdateIdpGroupResponse';
export * from '../models/UpdateIngestionPipelineInput';
export * from '../models/UpdateIntegrationRequest';
export * from '../models/UpdateIntegrationResponse';
export * from '../models/UpdateJobTemplateInput';
export * from '../models/UpdateNotebookInput';
export * from '../models/UpdatePrivateLinkInput';
export * from '../models/UpdateProjectConfigurationKeyRequest';
export * from '../models/UpdatePulumiConfigurationRequest';
export * from '../models/UpdateResourceSecurityScansExclusionRequest';
export * from '../models/UpdateRestoreAccountConnectivityConfigRequest';
export * from '../models/UpdateRestoreAccountConnectivityConfigResponse';
export * from '../models/UpdateRoleRequest';
export * from '../models/UpdateRoleResponse';
export * from '../models/UpdateSamlIdentityProviderInput';
export * from '../models/UpdateSavedQueryInput';
export * from '../models/UpdateSessionRequest';
export * from '../models/UpdateShouldFullBackupResourceRequest';
export * from '../models/UpdateTableMaintenanceConfigInput';
export * from '../models/UpdateUserInput';
export * from '../models/UpdateVaultRequest';
export * from '../models/UpdateVaultResponse';
export * from '../models/UpdateViewerRoleRequest';
export * from '../models/UpdateWorkspaceBucketPolicyInput';
export * from '../models/UpdateWorkspaceLoggingSettingsInput';
export * from '../models/UpdateWorkspaceMetricsSettingsInput';
export * from '../models/UpdateZeroEtlPolicyInput';
export * from '../models/Usage';
export * from '../models/UsageUnit';
export * from '../models/User';
export * from '../models/UserIdFilters';
export * from '../models/VNetConfig';
export * from '../models/ValidateResourceConfigurationRequest';
export * from '../models/ValidateResourceConfigurationResponse';
export * from '../models/VaultFilters';
export * from '../models/VaultMetadataReplicationConfig';
export * from '../models/VaultNotificationArguments';
export * from '../models/VaultProviderAttributes';
export * from '../models/VaultProviderAttributesInput';
export * from '../models/VaultSnapshotCount';
export * from '../models/VaultStatus';
export * from '../models/VerifyMongoAtlasPrivateLinkResponse';
export * from '../models/Viewer';
export * from '../models/ViolationsDetectionNotificationArguments';
export * from '../models/VirtualMachineRestoreDestination';
export * from '../models/VisualizationHistogramSeries';
export * from '../models/VisualizationHistogramTimePoint';
export * from '../models/VisualizationLabel';
export * from '../models/VolumeSettings';
export * from '../models/VpcCondition';
export * from '../models/VpcPeering';
export * from '../models/VpcPeeringStatus';
export * from '../models/VpcPropertyFilters';
export * from '../models/WarmCapacity';
export * from '../models/WeeklyConfig';
export * from '../models/Workspace';
export * from '../models/WorkspaceBucketPolicy';
export * from '../models/WorkspaceLoggingSettings';
export * from '../models/WorkspaceMetricsSettings';
export * from '../models/WorkspaceNetworkingSettings';
export * from '../models/WorkspaceStatus';
export * from '../models/YearlySnapshotDistribution';
export * from '../models/ZeroEtlIdentityColumnField';
export * from '../models/ZeroEtlIdentityColumnSpec';
export * from '../models/ZeroEtlPolicy';
export * from '../models/ZeroEtlResourceSelector';
export * from '../models/ZeroEtlRoutingMode';
export * from '../models/ZeroEtlRoutingPolicy';
import { AccessCondition } from '../models/AccessCondition';
import { AccessConditionalExpression } from '../models/AccessConditionalExpression';
import { Account } from '../models/Account';
import { AccountConfigInput } from '../models/AccountConfigInput';
import { AccountIdCondition } from '../models/AccountIdCondition';
import { AccountIdFilters } from '../models/AccountIdFilters';
import { AccountMetricsDestination } from '../models/AccountMetricsDestination';
import { AccountNameFilters } from '../models/AccountNameFilters';
import { AccountStatusFilters } from '../models/AccountStatusFilters';
import { AccountUpdateInput } from '../models/AccountUpdateInput';
import { AccountVersion } from '../models/AccountVersion';
import { ActionFilters } from '../models/ActionFilters';
import { ActivateAtlasOrganizationResponse } from '../models/ActivateAtlasOrganizationResponse';
import { ActivateGcpFolderResponse } from '../models/ActivateGcpFolderResponse';
import { ActivateGcpOrganizationResponse } from '../models/ActivateGcpOrganizationResponse';
import { AddRestoreAtlasPrivateLinkRequest } from '../models/AddRestoreAtlasPrivateLinkRequest';
import { AgreementWithCredits } from '../models/AgreementWithCredits';
import { Ami } from '../models/Ami';
import { AmiBlockDevice } from '../models/AmiBlockDevice';
import { AnalyzeSqlQueryRequest } from '../models/AnalyzeSqlQueryRequest';
import { AnnuallyConfig } from '../models/AnnuallyConfig';
import { AnomalyDataPoint } from '../models/AnomalyDataPoint';
import { AnomalyGraphData } from '../models/AnomalyGraphData';
import { ApiCredentials } from '../models/ApiCredentials';
import { ApiCredentialsProperties } from '../models/ApiCredentialsProperties';
import { App } from '../models/App';
import { AppFilters } from '../models/AppFilters';
import { ApplicationOverride } from '../models/ApplicationOverride';
import { AppsCondition } from '../models/AppsCondition';
import { AppsDetails } from '../models/AppsDetails';
import { AtlasOrganization } from '../models/AtlasOrganization';
import { AtlasProject } from '../models/AtlasProject';
import { AtlasProjects } from '../models/AtlasProjects';
import { AuditLog } from '../models/AuditLog';
import { AuditLogEntitiesInner } from '../models/AuditLogEntitiesInner';
import { AuditLogExtendedData } from '../models/AuditLogExtendedData';
import { AuditLogExtendedDataAuth } from '../models/AuditLogExtendedDataAuth';
import { AuditLogFilterConditions } from '../models/AuditLogFilterConditions';
import { AuthResponse } from '../models/AuthResponse';
import { AwsAccountConfigInput } from '../models/AwsAccountConfigInput';
import { AwsAccountConnectorProperties } from '../models/AwsAccountConnectorProperties';
import { AwsAccountConnectorPropertiesInput } from '../models/AwsAccountConnectorPropertiesInput';
import { AwsAccountMetricsDestination } from '../models/AwsAccountMetricsDestination';
import { AwsDatabaseDestination } from '../models/AwsDatabaseDestination';
import { AwsDynamoDBDestination } from '../models/AwsDynamoDBDestination';
import { AwsDynamoDbResource } from '../models/AwsDynamoDbResource';
import { AwsDynamoDbSnapshotProperties } from '../models/AwsDynamoDbSnapshotProperties';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput';
import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner';
import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner';
import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection';
import { AwsEbsSnapshotConvertResult } from '../models/AwsEbsSnapshotConvertResult';
import { AwsEbsVolumeResource } from '../models/AwsEbsVolumeResource';
import { AwsEbsVolumeRestoreData } from '../models/AwsEbsVolumeRestoreData';
import { AwsEbsVolumeRestoreResult } from '../models/AwsEbsVolumeRestoreResult';
import { AwsEbsVolumeSnapshotProperties } from '../models/AwsEbsVolumeSnapshotProperties';
import { AwsEc2AmiConvertResult } from '../models/AwsEc2AmiConvertResult';
import { AwsEc2InstanceRestoreDestination } from '../models/AwsEc2InstanceRestoreDestination';
import { AwsEc2InstanceRestoreResult } from '../models/AwsEc2InstanceRestoreResult';
import { AwsEc2InstanceRestoreTarget } from '../models/AwsEc2InstanceRestoreTarget';
import { AwsEc2Resource } from '../models/AwsEc2Resource';
import { AwsEc2SnapshotProperties } from '../models/AwsEc2SnapshotProperties';
import { AwsEksNamespaceResource } from '../models/AwsEksNamespaceResource';
import { AwsEksNamespaceSnapshotProperties } from '../models/AwsEksNamespaceSnapshotProperties';
import { AwsFsxResource } from '../models/AwsFsxResource';
import { AwsKeyspacesDestination } from '../models/AwsKeyspacesDestination';
import { AwsKeyspacesResource } from '../models/AwsKeyspacesResource';
import { AwsNativePitrBackupPolicyPlan } from '../models/AwsNativePitrBackupPolicyPlan';
import { AwsNativePitrBackupResourceType } from '../models/AwsNativePitrBackupResourceType';
import { AwsNativePitrConfig } from '../models/AwsNativePitrConfig';
import { AwsNeptuneResource } from '../models/AwsNeptuneResource';
import { AwsRdsResource } from '../models/AwsRdsResource';
import { AwsRdsResourceAurora } from '../models/AwsRdsResourceAurora';
import { AwsRdsResourceStorageSettings } from '../models/AwsRdsResourceStorageSettings';
import { AwsRedshiftResource } from '../models/AwsRedshiftResource';
import { AwsRestoreAccountAttributes } from '../models/AwsRestoreAccountAttributes';
import { AwsRestoreAccountAttributesInput } from '../models/AwsRestoreAccountAttributesInput';
import { AwsRestoreAccountConnectivityConfig } from '../models/AwsRestoreAccountConnectivityConfig';
import { AwsRuntimeConfig } from '../models/AwsRuntimeConfig';
import { AwsSourceAccountAttributes } from '../models/AwsSourceAccountAttributes';
import { AwsSourceAccountAttributesInput } from '../models/AwsSourceAccountAttributesInput';
import { AwsVaultConfig } from '../models/AwsVaultConfig';
import { AwsVaultConfigInput } from '../models/AwsVaultConfigInput';
import { AwsVpcConnectivityConfig } from '../models/AwsVpcConnectivityConfig';
import { AzureAccountConfigInput } from '../models/AzureAccountConfigInput';
import { AzureAksNamespaceResource } from '../models/AzureAksNamespaceResource';
import { AzureAppRegistrationOption } from '../models/AzureAppRegistrationOption';
import { AzureBackupApplicationsResponse } from '../models/AzureBackupApplicationsResponse';
import { AzureCmkEligibleApp } from '../models/AzureCmkEligibleApp';
import { AzureConsentUrlResponse } from '../models/AzureConsentUrlResponse';
import { AzureDisk } from '../models/AzureDisk';
import { AzureDiskRestoreData } from '../models/AzureDiskRestoreData';
import { AzureDiskRestoreDestination } from '../models/AzureDiskRestoreDestination';
import { AzureDiskRestoreResult } from '../models/AzureDiskRestoreResult';
import { AzureDiskSettings } from '../models/AzureDiskSettings';
import { AzureDiskTarget } from '../models/AzureDiskTarget';
import { AzureEonApplication } from '../models/AzureEonApplication';
import { AzureListResourceGroupsResponse } from '../models/AzureListResourceGroupsResponse';
import { AzureListSubscriptionsResponse } from '../models/AzureListSubscriptionsResponse';
import { AzureManagementGroup } from '../models/AzureManagementGroup';
import { AzureManagementGroups } from '../models/AzureManagementGroups';
import { AzureMarketplaceWebhookInput } from '../models/AzureMarketplaceWebhookInput';
import { AzureMarketplaceWebhookInputSubscription } from '../models/AzureMarketplaceWebhookInputSubscription';
import { AzureMarketplaceWebhookInputSubscriptionBeneficiary } from '../models/AzureMarketplaceWebhookInputSubscriptionBeneficiary';
import { AzureMarketplaceWebhookInputSubscriptionPurchaser } from '../models/AzureMarketplaceWebhookInputSubscriptionPurchaser';
import { AzureMarketplaceWebhookInputSubscriptionTerm } from '../models/AzureMarketplaceWebhookInputSubscriptionTerm';
import { AzureMssqlSnapshotProperties } from '../models/AzureMssqlSnapshotProperties';
import { AzureOnboardedTenantsResponse } from '../models/AzureOnboardedTenantsResponse';
import { AzureOnboardingStatus } from '../models/AzureOnboardingStatus';
import { AzurePostgresDatabaseRestoreDestination } from '../models/AzurePostgresDatabaseRestoreDestination';
import { AzurePostgresDatabaseRestoreTarget } from '../models/AzurePostgresDatabaseRestoreTarget';
import { AzureResourceGroup } from '../models/AzureResourceGroup';
import { AzureResourceGroups } from '../models/AzureResourceGroups';
import { AzureRestoreAccountAttributes } from '../models/AzureRestoreAccountAttributes';
import { AzureRestoreAccountAttributesInput } from '../models/AzureRestoreAccountAttributesInput';
import { AzureRestoreAccountConnectivityConfig } from '../models/AzureRestoreAccountConnectivityConfig';
import { AzureRestorePointData } from '../models/AzureRestorePointData';
import { AzureRestorePointSpec } from '../models/AzureRestorePointSpec';
import { AzureSapHanaResource } from '../models/AzureSapHanaResource';
import { AzureScanningAccountSetupStatus200Response } from '../models/AzureScanningAccountSetupStatus200Response';
import { AzureSourceAccountAttributes } from '../models/AzureSourceAccountAttributes';
import { AzureSourceAccountAttributesInput } from '../models/AzureSourceAccountAttributesInput';
import { AzureSqlDatabaseRestoreDestination } from '../models/AzureSqlDatabaseRestoreDestination';
import { AzureSqlDatabaseRestoreTarget } from '../models/AzureSqlDatabaseRestoreTarget';
import { AzureStorageAccount } from '../models/AzureStorageAccount';
import { AzureStorageAccounts } from '../models/AzureStorageAccounts';
import { AzureSubscription } from '../models/AzureSubscription';
import { AzureTenant } from '../models/AzureTenant';
import { AzureVaultConfig } from '../models/AzureVaultConfig';
import { AzureVaultConfigInput } from '../models/AzureVaultConfigInput';
import { AzureVmInstanceRestoreDestination } from '../models/AzureVmInstanceRestoreDestination';
import { AzureVmInstanceRestoreResult } from '../models/AzureVmInstanceRestoreResult';
import { AzureVmInstanceRestoreTarget } from '../models/AzureVmInstanceRestoreTarget';
import { AzureVmSnapshotProperties } from '../models/AzureVmSnapshotProperties';
import { AzureVnetConnectivityConfig } from '../models/AzureVnetConnectivityConfig';
import { BackedUpByResourceType } from '../models/BackedUpByResourceType';
import { BackedUpByResourceTypeDataInner } from '../models/BackedUpByResourceTypeDataInner';
import { BackedUpStorageDateHistogram } from '../models/BackedUpStorageDateHistogram';
import { BackupControlViolations } from '../models/BackupControlViolations';
import { BackupJob } from '../models/BackupJob';
import { BackupJobResponse } from '../models/BackupJobResponse';
import { BackupJobTypeFilters } from '../models/BackupJobTypeFilters';
import { BackupJobsFilterConditions } from '../models/BackupJobsFilterConditions';
import { BackupPoliciesFilters } from '../models/BackupPoliciesFilters';
import { BackupPoliciesLimits } from '../models/BackupPoliciesLimits';
import { BackupPoliciesSecurityConfig } from '../models/BackupPoliciesSecurityConfig';
import { BackupPolicy } from '../models/BackupPolicy';
import { BackupPolicyAppliesNotificationArguments } from '../models/BackupPolicyAppliesNotificationArguments';
import { BackupPolicyConfig } from '../models/BackupPolicyConfig';
import { BackupPolicyExpression } from '../models/BackupPolicyExpression';
import { BackupPolicyGroupCondition } from '../models/BackupPolicyGroupCondition';
import { BackupPolicyNotificationArguments } from '../models/BackupPolicyNotificationArguments';
import { BackupPolicyPlan } from '../models/BackupPolicyPlan';
import { BackupPolicyResourceSelector } from '../models/BackupPolicyResourceSelector';
import { BackupPolicySecurityConfig } from '../models/BackupPolicySecurityConfig';
import { BackupRegionsFilters } from '../models/BackupRegionsFilters';
import { BackupSchedule } from '../models/BackupSchedule';
import { BackupScope } from '../models/BackupScope';
import { BackupScopeSummary } from '../models/BackupScopeSummary';
import { BackupStatusFilters } from '../models/BackupStatusFilters';
import { BackupVault } from '../models/BackupVault';
import { BackupZeroEtlAccessConfiguration } from '../models/BackupZeroEtlAccessConfiguration';
import { BackupZeroEtlAwsAccessConfiguration } from '../models/BackupZeroEtlAwsAccessConfiguration';
import { BackupZeroEtlAwsGlueCatalogConfiguration } from '../models/BackupZeroEtlAwsGlueCatalogConfiguration';
import { BackupZeroEtlCatalogConfiguration } from '../models/BackupZeroEtlCatalogConfiguration';
import { BackupZeroEtlIdentityColumnSpec } from '../models/BackupZeroEtlIdentityColumnSpec';
import { BackupZeroEtlPolicy } from '../models/BackupZeroEtlPolicy';
import { BackupZeroEtlResourceSelector } from '../models/BackupZeroEtlResourceSelector';
import { BackupZeroEtlRoutingPolicy } from '../models/BackupZeroEtlRoutingPolicy';
import { BackupZeroEtlStorageConfiguration } from '../models/BackupZeroEtlStorageConfiguration';
import { BatchApplicationOverrides } from '../models/BatchApplicationOverrides';
import { BatchOperationResponse } from '../models/BatchOperationResponse';
import { BatchResourceValidationResult } from '../models/BatchResourceValidationResult';
import { BatchUpdateLlgPoliciesRequest } from '../models/BatchUpdateLlgPoliciesRequest';
import { BatchUpdateLlgPolicyItem } from '../models/BatchUpdateLlgPolicyItem';
import { BatchValidateResourceConfigurationRequest } from '../models/BatchValidateResourceConfigurationRequest';
import { BatchValidateResourceConfigurationResponse } from '../models/BatchValidateResourceConfigurationResponse';
import { BigQueryDatasetDestination } from '../models/BigQueryDatasetDestination';
import { BigQueryIntegrationConfig } from '../models/BigQueryIntegrationConfig';
import { BigQueryNativePitrBackupPolicyPlan } from '../models/BigQueryNativePitrBackupPolicyPlan';
import { BigQueryNativePitrBackupResourceType } from '../models/BigQueryNativePitrBackupResourceType';
import { BigQueryNativePitrConfig } from '../models/BigQueryNativePitrConfig';
import { BigQueryNativePitrDestination } from '../models/BigQueryNativePitrDestination';
import { BiglakeCatalogProperties } from '../models/BiglakeCatalogProperties';
import { BillingPeriod } from '../models/BillingPeriod';
import { BillingTransactionHistory } from '../models/BillingTransactionHistory';
import { BooleanFilters } from '../models/BooleanFilters';
import { BucketPathPartitionSpec } from '../models/BucketPathPartitionSpec';
import { CancelExclusionFromBackupResponse } from '../models/CancelExclusionFromBackupResponse';
import { CatalogAccessRequest } from '../models/CatalogAccessRequest';
import { CatalogAccessResponse } from '../models/CatalogAccessResponse';
import { CdcBackupModeCheckResult } from '../models/CdcBackupModeCheckResult';
import { CheckAzureVMNameExists200Response } from '../models/CheckAzureVMNameExists200Response';
import { CheckAzureVMNameExistsRequest } from '../models/CheckAzureVMNameExistsRequest';
import { CheckCdcPrerequisitesResponse } from '../models/CheckCdcPrerequisitesResponse';
import { Classifications } from '../models/Classifications';
import { CloudAccountIdFilters } from '../models/CloudAccountIdFilters';
import { CloudAccountNotificationArguments } from '../models/CloudAccountNotificationArguments';
import { CloudProviderCondition } from '../models/CloudProviderCondition';
import { CloudProviderFilters } from '../models/CloudProviderFilters';
import { CloudRegion } from '../models/CloudRegion';
import { CloudResourceAttachmentEvent } from '../models/CloudResourceAttachmentEvent';
import { CloudResourceConfiguration } from '../models/CloudResourceConfiguration';
import { CloudResourceConfigurationCdcBackup } from '../models/CloudResourceConfigurationCdcBackup';
import { CloudResourceConfigurationInventoryBackup } from '../models/CloudResourceConfigurationInventoryBackup';
import { CloudResourceSecurityProperties } from '../models/CloudResourceSecurityProperties';
import { CloudSnapshotsPerVolume } from '../models/CloudSnapshotsPerVolume';
import { ClusterNameFilters } from '../models/ClusterNameFilters';
import { ColumnMetadata } from '../models/ColumnMetadata';
import { CompanyContact } from '../models/CompanyContact';
import { Condition } from '../models/Condition';
import { ConnectAtlasOrganizationRequest } from '../models/ConnectAtlasOrganizationRequest';
import { ConnectAtlasOrganizationResponse } from '../models/ConnectAtlasOrganizationResponse';
import { ConnectAzureBackupAccountRequest } from '../models/ConnectAzureBackupAccountRequest';
import { ConnectAzureBackupApplicationsRequest } from '../models/ConnectAzureBackupApplicationsRequest';
import { ConnectAzureRestoreAccountRequest } from '../models/ConnectAzureRestoreAccountRequest';
import { ConnectAzureSourceAccountRequest } from '../models/ConnectAzureSourceAccountRequest';
import { ConnectAzureVaultAccountRequest } from '../models/ConnectAzureVaultAccountRequest';
import { ConnectBYOApps200Response } from '../models/ConnectBYOApps200Response';
import { ConnectBYOAppsRequest } from '../models/ConnectBYOAppsRequest';
import { ConnectBYOAzureBackupApplicationsRequest } from '../models/ConnectBYOAzureBackupApplicationsRequest';
import { ConnectCustomerVaultAccountRequest } from '../models/ConnectCustomerVaultAccountRequest';
import { ConnectCustomerVaultAccountResponse } from '../models/ConnectCustomerVaultAccountResponse';
import { ConnectGcpFolderRequest } from '../models/ConnectGcpFolderRequest';
import { ConnectGcpFolderResponse } from '../models/ConnectGcpFolderResponse';
import { ConnectGcpOrganizationRequest } from '../models/ConnectGcpOrganizationRequest';
import { ConnectGcpOrganizationResponse } from '../models/ConnectGcpOrganizationResponse';
import { ConnectRestoreAccountRequest } from '../models/ConnectRestoreAccountRequest';
import { ConnectRestoreAccountResponse } from '../models/ConnectRestoreAccountResponse';
import { ConnectSourceAccountRequest } from '../models/ConnectSourceAccountRequest';
import { ConnectSourceAccountResponse } from '../models/ConnectSourceAccountResponse';
import { ConnectSourceAwsOrganizationalUnitRequest } from '../models/ConnectSourceAwsOrganizationalUnitRequest';
import { ConnectSourceAwsOrganizationalUnitResponse } from '../models/ConnectSourceAwsOrganizationalUnitResponse';
import { Connector } from '../models/Connector';
import { Control } from '../models/Control';
import { ControlPlaneConfig } from '../models/ControlPlaneConfig';
import { ControlRules } from '../models/ControlRules';
import { ControlViolation } from '../models/ControlViolation';
import { ControlViolations } from '../models/ControlViolations';
import { ControlViolationsPerSeverity } from '../models/ControlViolationsPerSeverity';
import { ControlViolationsPerSeverityViolatedControlsInner } from '../models/ControlViolationsPerSeverityViolatedControlsInner';
import { ControlsFilters } from '../models/ControlsFilters';
import { ConvertEbsSnapshotConfig } from '../models/ConvertEbsSnapshotConfig';
import { ConvertEc2ImageConfig } from '../models/ConvertEc2ImageConfig';
import { ConvertOtherSnapshotsOnDemandRequest } from '../models/ConvertOtherSnapshotsOnDemandRequest';
import { ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner } from '../models/ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner';
import { ConvertResourceSnapshotsRequest } from '../models/ConvertResourceSnapshotsRequest';
import { ConvertResourceSnapshotsResponse } from '../models/ConvertResourceSnapshotsResponse';
import { Cost } from '../models/Cost';
import { CostDataFilters } from '../models/CostDataFilters';
import { CostDataRecord } from '../models/CostDataRecord';
import { CostDataRecordCost } from '../models/CostDataRecordCost';
import { CostDataRecordDimensions } from '../models/CostDataRecordDimensions';
import { CostRecordMetadata } from '../models/CostRecordMetadata';
import { CostRecordMetadataDataTransfer } from '../models/CostRecordMetadataDataTransfer';
import { CreateAccountInput } from '../models/CreateAccountInput';
import { CreateApiCredentialsRequest } from '../models/CreateApiCredentialsRequest';
import { CreateApiCredentialsResponse } from '../models/CreateApiCredentialsResponse';
import { CreateBackupPolicyRequest } from '../models/CreateBackupPolicyRequest';
import { CreateBackupPolicyResponse } from '../models/CreateBackupPolicyResponse';
import { CreateBackupZeroEtlPolicyInput } from '../models/CreateBackupZeroEtlPolicyInput';
import { CreateConnectorInput } from '../models/CreateConnectorInput';
import { CreateDashboardInput } from '../models/CreateDashboardInput';
import { CreateDataCatalogInput } from '../models/CreateDataCatalogInput';
import { CreateDlsgPolicyRequest } from '../models/CreateDlsgPolicyRequest';
import { CreateDlsgPolicyResponse } from '../models/CreateDlsgPolicyResponse';
import { CreateFabricTableShortcutDemoRequest } from '../models/CreateFabricTableShortcutDemoRequest';
import { CreateFabricTableShortcutDemoRequestShortcutsInner } from '../models/CreateFabricTableShortcutDemoRequestShortcutsInner';
import { CreateFabricTableShortcutDemoResponse } from '../models/CreateFabricTableShortcutDemoResponse';
import { CreateFabricTableShortcutDemoResponseResultsInner } from '../models/CreateFabricTableShortcutDemoResponseResultsInner';
import { CreateGraphInput } from '../models/CreateGraphInput';
import { CreateIdpGroupRequest } from '../models/CreateIdpGroupRequest';
import { CreateIdpGroupResponse } from '../models/CreateIdpGroupResponse';
import { CreateInfectedExcludePathInput } from '../models/CreateInfectedExcludePathInput';
import { CreateIngestionPipelineInput } from '../models/CreateIngestionPipelineInput';
import { CreateIntegrationRequest } from '../models/CreateIntegrationRequest';
import { CreateIntegrationResponse } from '../models/CreateIntegrationResponse';
import { CreateJobTemplateInput } from '../models/CreateJobTemplateInput';
import { CreateNotebookInput } from '../models/CreateNotebookInput';
import { CreateOAuthAppRequest } from '../models/CreateOAuthAppRequest';
import { CreateOAuthAppResponse } from '../models/CreateOAuthAppResponse';
import { CreatePolicyInput } from '../models/CreatePolicyInput';
import { CreatePolicyScheduleInput } from '../models/CreatePolicyScheduleInput';
import { CreatePrivateLinkInput } from '../models/CreatePrivateLinkInput';
import { CreateProjectInput } from '../models/CreateProjectInput';
import { CreatePulumiConfigurationRequest } from '../models/CreatePulumiConfigurationRequest';
import { CreateRoleRequest } from '../models/CreateRoleRequest';
import { CreateRoleResponse } from '../models/CreateRoleResponse';
import { CreateSamlIdentityProviderConfigInput } from '../models/CreateSamlIdentityProviderConfigInput';
import { CreateSavedQueryInput } from '../models/CreateSavedQueryInput';
import { CreateScanJobInput } from '../models/CreateScanJobInput';
import { CreateScanJobResponse } from '../models/CreateScanJobResponse';
import { CreateSessionRequest } from '../models/CreateSessionRequest';
import { CreateSparkEngineInput } from '../models/CreateSparkEngineInput';
import { CreateSqlEngineInput } from '../models/CreateSqlEngineInput';
import { CreateUserInput } from '../models/CreateUserInput';
import { CreateVaultRequest } from '../models/CreateVaultRequest';
import { CreateVaultResponse } from '../models/CreateVaultResponse';
import { CreateVpcPeeringInput } from '../models/CreateVpcPeeringInput';
import { CreateZeroEtlPolicyInput } from '../models/CreateZeroEtlPolicyInput';
import { CredentialFinding } from '../models/CredentialFinding';
import { CreditsMonthlyUsageNotificationArguments } from '../models/CreditsMonthlyUsageNotificationArguments';
import { CreditsNotificationArguments } from '../models/CreditsNotificationArguments';
import { CrossResourceQueryRequest } from '../models/CrossResourceQueryRequest';
import { CrossResourceQueryRequestResourcesInner } from '../models/CrossResourceQueryRequestResourcesInner';
import { CustomTagsInner } from '../models/CustomTagsInner';
import { CustomerVaultAccount } from '../models/CustomerVaultAccount';
import { DBResourceMetadata } from '../models/DBResourceMetadata';
import { DBServerRecord } from '../models/DBServerRecord';
import { DBSnapshotMetadata } from '../models/DBSnapshotMetadata';
import { DailyConfig } from '../models/DailyConfig';
import { DailySnapshotData } from '../models/DailySnapshotData';
import { DailyStorageSummaries } from '../models/DailyStorageSummaries';
import { DailyStorageSummary } from '../models/DailyStorageSummary';
import { Dashboard } from '../models/Dashboard';
import { DashboardGraph } from '../models/DashboardGraph';
import { DashboardGraphLayout } from '../models/DashboardGraphLayout';
import { DashboardWithGraphs } from '../models/DashboardWithGraphs';
import { DataCatalog } from '../models/DataCatalog';
import { DataClassesCondition } from '../models/DataClassesCondition';
import { DataClassesDetails } from '../models/DataClassesDetails';
import { DataClassesFilters } from '../models/DataClassesFilters';
import { DataClassificationEntity } from '../models/DataClassificationEntity';
import { DataShareIntegrationConfig } from '../models/DataShareIntegrationConfig';
import { DatabaseDestination } from '../models/DatabaseDestination';
import { DatabaseRecord } from '../models/DatabaseRecord';
import { DatabricksIntegrationConfig } from '../models/DatabricksIntegrationConfig';
import { DeactivateAccountRequest } from '../models/DeactivateAccountRequest';
import { DeactivateAccountResponse } from '../models/DeactivateAccountResponse';
import { DeactivateAtlasOrganizationResponse } from '../models/DeactivateAtlasOrganizationResponse';
import { DeactivateGcpFolderResponse } from '../models/DeactivateGcpFolderResponse';
import { DeactivateGcpOrganizationResponse } from '../models/DeactivateGcpOrganizationResponse';
import { DeleteRestoreAccountV1Request } from '../models/DeleteRestoreAccountV1Request';
import { DestinationDetails } from '../models/DestinationDetails';
import { DestinationProviderAttributes } from '../models/DestinationProviderAttributes';
import { DestinationProviderAttributesAzure } from '../models/DestinationProviderAttributesAzure';
import { DestinationRestoreTypeAttributes } from '../models/DestinationRestoreTypeAttributes';
import { DetectorSummary } from '../models/DetectorSummary';
import { DisableResourceOverrideLimitsResponse } from '../models/DisableResourceOverrideLimitsResponse';
import { DisconnectCustomerVaultAccountResponse } from '../models/DisconnectCustomerVaultAccountResponse';
import { DisconnectRestoreAccountResponse } from '../models/DisconnectRestoreAccountResponse';
import { DisconnectSourceAccountResponse } from '../models/DisconnectSourceAccountResponse';
import { DisconnectSourceAwsOrganizationalUnitResponse } from '../models/DisconnectSourceAwsOrganizationalUnitResponse';
import { DiscoveryInvokeParams } from '../models/DiscoveryInvokeParams';
import { DiscoveryJob } from '../models/DiscoveryJob';
import { DiscoveryStatusResponse } from '../models/DiscoveryStatusResponse';
import { DlsgPolicy } from '../models/DlsgPolicy';
import { DlsgPolicyConfig } from '../models/DlsgPolicyConfig';
import { DlsgPolicyFilters } from '../models/DlsgPolicyFilters';
import { DlsgPolicyPlan } from '../models/DlsgPolicyPlan';
import { DlsgSettings } from '../models/DlsgSettings';
import { DocumentDBRestoreDestination } from '../models/DocumentDBRestoreDestination';
import { DocumentDbClusterParameterGroup } from '../models/DocumentDbClusterParameterGroup';
import { DocumentDbClusterParameterGroups } from '../models/DocumentDbClusterParameterGroups';
import { DocumentDbSnapshotProperties } from '../models/DocumentDbSnapshotProperties';
import { DriftProtectionPolicy } from '../models/DriftProtectionPolicy';
import { DriftProtectionSummary } from '../models/DriftProtectionSummary';
import { DriftProtectionTimePoint } from '../models/DriftProtectionTimePoint';
import { DynamoDBAdvancedIndexConfig } from '../models/DynamoDBAdvancedIndexConfig';
import { DynamoDBRestoreMethodAvailabilityRequest } from '../models/DynamoDBRestoreMethodAvailabilityRequest';
import { DynamoDBRestoreMethodAvailabilityResponse } from '../models/DynamoDBRestoreMethodAvailabilityResponse';
import { DynamoDbBackupConfig } from '../models/DynamoDbBackupConfig';
import { DynamoDbBackupConfigApplication } from '../models/DynamoDbBackupConfigApplication';
import { DynamodbTableRestoreDestination } from '../models/DynamodbTableRestoreDestination';
import { EFSRestoreDestination } from '../models/EFSRestoreDestination';
import { EbsRestoreDestination } from '../models/EbsRestoreDestination';
import { EbsSnapshotRestoreDestination } from '../models/EbsSnapshotRestoreDestination';
import { EbsSnapshotTarget } from '../models/EbsSnapshotTarget';
import { EbsTarget } from '../models/EbsTarget';
import { EfsSnapshotProperties } from '../models/EfsSnapshotProperties';
import { EksCluster } from '../models/EksCluster';
import { EksNamespaceRestoreDestination } from '../models/EksNamespaceRestoreDestination';
import { EksNamespaceRestoreResult } from '../models/EksNamespaceRestoreResult';
import { EksVolumeRestoreResult } from '../models/EksVolumeRestoreResult';
import { EmrIntegrationConfig } from '../models/EmrIntegrationConfig';
import { EnableFromLimitExceededResponse } from '../models/EnableFromLimitExceededResponse';
import { EnableResourceOverrideLimitsResponse } from '../models/EnableResourceOverrideLimitsResponse';
import { EnableRestoreAccountMetricsConfigRequest } from '../models/EnableRestoreAccountMetricsConfigRequest';
import { EnableRestoreAccountMetricsConfigResponse } from '../models/EnableRestoreAccountMetricsConfigResponse';
import { EnableSourceAccountMetricsConfigRequest } from '../models/EnableSourceAccountMetricsConfigRequest';
import { EnableSourceAccountMetricsConfigResponse } from '../models/EnableSourceAccountMetricsConfigResponse';
import { EncryptionKey } from '../models/EncryptionKey';
import { EncryptionKeys } from '../models/EncryptionKeys';
import { EndTimeDateFilters } from '../models/EndTimeDateFilters';
import { EnvironmentCondition } from '../models/EnvironmentCondition';
import { EnvironmentDetails } from '../models/EnvironmentDetails';
import { EnvironmentFilters } from '../models/EnvironmentFilters';
import { EonAccount } from '../models/EonAccount';
import { EonAccountIdFilters } from '../models/EonAccountIdFilters';
import { ExcludeFromBackupResponse } from '../models/ExcludeFromBackupResponse';
import { ExecuteNotebookCodeInput } from '../models/ExecuteNotebookCodeInput';
import { ExportCostData400Response } from '../models/ExportCostData400Response';
import { ExportCostDataRequest } from '../models/ExportCostDataRequest';
import { FSxRestoreDestination } from '../models/FSxRestoreDestination';
import { FSxRestoreDestinationOntapRestoreOptions } from '../models/FSxRestoreDestinationOntapRestoreOptions';
import { FeatureFlagOverrideGet200Response } from '../models/FeatureFlagOverrideGet200Response';
import { FileExplorerCountSecurityAlertsInResourceResponse } from '../models/FileExplorerCountSecurityAlertsInResourceResponse';
import { FileExplorerResponse } from '../models/FileExplorerResponse';
import { FilePath } from '../models/FilePath';
import { FileRestoreData } from '../models/FileRestoreData';
import { FileSearchRecord } from '../models/FileSearchRecord';
import { FileSnapshot } from '../models/FileSnapshot';
import { FindingCountEntry } from '../models/FindingCountEntry';
import { FindingEntry } from '../models/FindingEntry';
import { ForceDeleteSnapshotsRequest } from '../models/ForceDeleteSnapshotsRequest';
import { FreeTextFilters } from '../models/FreeTextFilters';
import { FsxOntapVolume } from '../models/FsxOntapVolume';
import { FsxSnapshotProperties } from '../models/FsxSnapshotProperties';
import { FsxVolumeBackupInfo } from '../models/FsxVolumeBackupInfo';
import { GCSBucket } from '../models/GCSBucket';
import { GCSBuckets } from '../models/GCSBuckets';
import { GCSRestoreDestination } from '../models/GCSRestoreDestination';
import { GCSRestoreTarget } from '../models/GCSRestoreTarget';
import { GcpAccountConfigInput } from '../models/GcpAccountConfigInput';
import { GcpBigQueryResource } from '../models/GcpBigQueryResource';
import { GcpBigQueryResourceMaterializedViewsInner } from '../models/GcpBigQueryResourceMaterializedViewsInner';
import { GcpBigQueryResourceRoutinesInner } from '../models/GcpBigQueryResourceRoutinesInner';
import { GcpBigQueryResourceTablesInner } from '../models/GcpBigQueryResourceTablesInner';
import { GcpBigQueryResourceViewsInner } from '../models/GcpBigQueryResourceViewsInner';
import { GcpCloudSqlResource } from '../models/GcpCloudSqlResource';
import { GcpCloudSqlResourceStorageSettings } from '../models/GcpCloudSqlResourceStorageSettings';
import { GcpCloudSqlRestoreDestination } from '../models/GcpCloudSqlRestoreDestination';
import { GcpCloudSqlSnapshotProperties } from '../models/GcpCloudSqlSnapshotProperties';
import { GcpCloudSqlTarget } from '../models/GcpCloudSqlTarget';
import { GcpDiskResource } from '../models/GcpDiskResource';
import { GcpDiskRestoreData } from '../models/GcpDiskRestoreData';
import { GcpDiskRestoreDestination } from '../models/GcpDiskRestoreDestination';
import { GcpDiskSettings } from '../models/GcpDiskSettings';
import { GcpDiskSnapshotProperties } from '../models/GcpDiskSnapshotProperties';
import { GcpDiskTarget } from '../models/GcpDiskTarget';
import { GcpDiskTypesResponse } from '../models/GcpDiskTypesResponse';
import { GcpEncryptionKey } from '../models/GcpEncryptionKey';
import { GcpEncryptionKeys } from '../models/GcpEncryptionKeys';
import { GcpGkeNamespaceResource } from '../models/GcpGkeNamespaceResource';
import { GcpMachineTypesResponse } from '../models/GcpMachineTypesResponse';
import { GcpNetworkConnectivityConfig } from '../models/GcpNetworkConnectivityConfig';
import { GcpOrganization } from '../models/GcpOrganization';
import { GcpProjectConnectorProperties } from '../models/GcpProjectConnectorProperties';
import { GcpProjectConnectorPropertiesInput } from '../models/GcpProjectConnectorPropertiesInput';
import { GcpRestoreAccountAttributes } from '../models/GcpRestoreAccountAttributes';
import { GcpRestoreAccountAttributesInput } from '../models/GcpRestoreAccountAttributesInput';
import { GcpRestoreAccountConnectivityConfig } from '../models/GcpRestoreAccountConnectivityConfig';
import { GcpSapHanaResource } from '../models/GcpSapHanaResource';
import { GcpSourceAccountAttributes } from '../models/GcpSourceAccountAttributes';
import { GcpSourceAccountAttributesInput } from '../models/GcpSourceAccountAttributesInput';
import { GcpSubnet } from '../models/GcpSubnet';
import { GcpSubnetPerRegion } from '../models/GcpSubnetPerRegion';
import { GcpVaultConfig } from '../models/GcpVaultConfig';
import { GcpVaultConfigInput } from '../models/GcpVaultConfigInput';
import { GcpVmInstanceRestoreDestination } from '../models/GcpVmInstanceRestoreDestination';
import { GcpVmInstanceRestoreResult } from '../models/GcpVmInstanceRestoreResult';
import { GcpVmInstanceRestoreTarget } from '../models/GcpVmInstanceRestoreTarget';
import { GcpVmResource } from '../models/GcpVmResource';
import { GcpVmSnapshotProperties } from '../models/GcpVmSnapshotProperties';
import { GcsSourceProperties } from '../models/GcsSourceProperties';
import { GenericSnapshotData } from '../models/GenericSnapshotData';
import { GetAWSStackDetailsResponse } from '../models/GetAWSStackDetailsResponse';
import { GetAdditionalAzureAppsOnboardingStatus200Response } from '../models/GetAdditionalAzureAppsOnboardingStatus200Response';
import { GetAgreementsResponse } from '../models/GetAgreementsResponse';
import { GetAwsPrivateLinkStatusResponse } from '../models/GetAwsPrivateLinkStatusResponse';
import { GetBackupJobResponse } from '../models/GetBackupJobResponse';
import { GetBackupPolicyResponse } from '../models/GetBackupPolicyResponse';
import { GetBillingPeriodsResponse } from '../models/GetBillingPeriodsResponse';
import { GetCloudResourceSecurityPropertiesResponse } from '../models/GetCloudResourceSecurityPropertiesResponse';
import { GetCredits400Response } from '../models/GetCredits400Response';
import { GetCreditsResponse } from '../models/GetCreditsResponse';
import { GetDlsgPolicyResponse } from '../models/GetDlsgPolicyResponse';
import { GetGcsServiceAgentResponse } from '../models/GetGcsServiceAgentResponse';
import { GetIdpGroupResponse } from '../models/GetIdpGroupResponse';
import { GetIntegrationResponse } from '../models/GetIntegrationResponse';
import { GetLimitsResponseValue } from '../models/GetLimitsResponseValue';
import { GetNotebookContent200Response } from '../models/GetNotebookContent200Response';
import { GetProjectConfigurationKeyResponse } from '../models/GetProjectConfigurationKeyResponse';
import { GetProjectConfigurationKeysResponse } from '../models/GetProjectConfigurationKeysResponse';
import { GetResourceResponse } from '../models/GetResourceResponse';
import { GetRestoreAccountConnectivityConfigResponse } from '../models/GetRestoreAccountConnectivityConfigResponse';
import { GetRestoreAccountMetricsConfigResponse } from '../models/GetRestoreAccountMetricsConfigResponse';
import { GetRestoreJobResponse } from '../models/GetRestoreJobResponse';
import { GetRoleResponse } from '../models/GetRoleResponse';
import { GetScanJobResponse } from '../models/GetScanJobResponse';
import { GetSnapshotResponse } from '../models/GetSnapshotResponse';
import { GetSourceAccountMetricsConfigResponse } from '../models/GetSourceAccountMetricsConfigResponse';
import { GetSqlVmNetworkInfoRequest } from '../models/GetSqlVmNetworkInfoRequest';
import { GetSqlVmNetworkInfoResponse } from '../models/GetSqlVmNetworkInfoResponse';
import { GetVaultResponse } from '../models/GetVaultResponse';
import { GlobalClusterIdentifierCondition } from '../models/GlobalClusterIdentifierCondition';
import { GlueCatalogProperties } from '../models/GlueCatalogProperties';
import { HighFrequencyBackupPolicyPlan } from '../models/HighFrequencyBackupPolicyPlan';
import { HighFrequencyBackupResourceType } from '../models/HighFrequencyBackupResourceType';
import { HighFrequencyBackupScheduleConfig } from '../models/HighFrequencyBackupScheduleConfig';
import { HighFrequencyBackupSchedules } from '../models/HighFrequencyBackupSchedules';
import { HighFrequencyIntervalConfig } from '../models/HighFrequencyIntervalConfig';
import { IDs } from '../models/IDs';
import { IcebergRestCatalogProperties } from '../models/IcebergRestCatalogProperties';
import { IdFilters } from '../models/IdFilters';
import { Identifier } from '../models/Identifier';
import { IdentityProvidersNames } from '../models/IdentityProvidersNames';
import { Idp } from '../models/Idp';
import { IdpGroup } from '../models/IdpGroup';
import { ImportDlsgCertificateRequest } from '../models/ImportDlsgCertificateRequest';
import { InfectedDataByClassification } from '../models/InfectedDataByClassification';
import { InfectedDataClassificationSize } from '../models/InfectedDataClassificationSize';
import { InfectedDataOverTime } from '../models/InfectedDataOverTime';
import { InfectedDateSize } from '../models/InfectedDateSize';
import { InfectedExcludePath } from '../models/InfectedExcludePath';
import { InfectedResourcesCountResponse } from '../models/InfectedResourcesCountResponse';
import { IngestionPipeline } from '../models/IngestionPipeline';
import { InitAuthInput } from '../models/InitAuthInput';
import { Initiator } from '../models/Initiator';
import { InitiatorNameFilters } from '../models/InitiatorNameFilters';
import { IntegConfig } from '../models/IntegConfig';
import { IntegrationConfig } from '../models/IntegrationConfig';
import { InventoryFilterConditions } from '../models/InventoryFilterConditions';
import { InventoryGcpDisk } from '../models/InventoryGcpDisk';
import { InventoryResource } from '../models/InventoryResource';
import { InventoryResourceMetadata } from '../models/InventoryResourceMetadata';
import { InventorySnapshotVolume } from '../models/InventorySnapshotVolume';
import { InventoryVault } from '../models/InventoryVault';
import { InventoryVolume } from '../models/InventoryVolume';
import { IsVaultDeletableResponse } from '../models/IsVaultDeletableResponse';
import { IssueMutedNotificationArguments } from '../models/IssueMutedNotificationArguments';
import { JobExecutionDetails } from '../models/JobExecutionDetails';
import { JobFailedNotificationArguments } from '../models/JobFailedNotificationArguments';
import { JobIdFilters } from '../models/JobIdFilters';
import { JobInitiationResponse } from '../models/JobInitiationResponse';
import { JobMetricsReportFailedArguments } from '../models/JobMetricsReportFailedArguments';
import { JobSnapshotDetails } from '../models/JobSnapshotDetails';
import { JobStatusFilters } from '../models/JobStatusFilters';
import { JobStep } from '../models/JobStep';
import { JobSucceededNotificationArguments } from '../models/JobSucceededNotificationArguments';
import { JobTemplate } from '../models/JobTemplate';
import { KafkaBatchConfig } from '../models/KafkaBatchConfig';
import { KafkaErrorHandlingConfig } from '../models/KafkaErrorHandlingConfig';
import { KafkaPartitioningConfig } from '../models/KafkaPartitioningConfig';
import { KafkaSecurityConfig } from '../models/KafkaSecurityConfig';
import { KafkaSourceConfig } from '../models/KafkaSourceConfig';
import { KafkaSourceProperties } from '../models/KafkaSourceProperties';
import { KeyspacesBackupConfig } from '../models/KeyspacesBackupConfig';
import { KeyspacesBackupConfigApplication } from '../models/KeyspacesBackupConfigApplication';
import { KeyspacesTableRestoreDestination } from '../models/KeyspacesTableRestoreDestination';
import { LimitData } from '../models/LimitData';
import { ListAccountsResponse } from '../models/ListAccountsResponse';
import { ListAllRegionsResponse } from '../models/ListAllRegionsResponse';
import { ListAllRegionsResponseRegions } from '../models/ListAllRegionsResponseRegions';
import { ListApiCredentialsResponse } from '../models/ListApiCredentialsResponse';
import { ListApplicationOverrideResponse } from '../models/ListApplicationOverrideResponse';
import { ListAtlasOrganizationsResponse } from '../models/ListAtlasOrganizationsResponse';
import { ListAuditLogRequest } from '../models/ListAuditLogRequest';
import { ListAuditLogResponse } from '../models/ListAuditLogResponse';
import { ListAuditLogsResponse } from '../models/ListAuditLogsResponse';
import { ListAwsVpcsResponse } from '../models/ListAwsVpcsResponse';
import { ListAwsVpcsResponseVpcsInner } from '../models/ListAwsVpcsResponseVpcsInner';
import { ListAzureAppRegistrationsResponse } from '../models/ListAzureAppRegistrationsResponse';
import { ListAzureCmkEligibleAppsResponse } from '../models/ListAzureCmkEligibleAppsResponse';
import { ListAzureRegions200Response } from '../models/ListAzureRegions200Response';
import { ListAzureSKUs200Response } from '../models/ListAzureSKUs200Response';
import { ListAzureSKUs200ResponseSkusInner } from '../models/ListAzureSKUs200ResponseSkusInner';
import { ListAzureSKUsRequest } from '../models/ListAzureSKUsRequest';
import { ListAzureStorageAccountContainers200Response } from '../models/ListAzureStorageAccountContainers200Response';
import { ListAzureStorageAccountContainersRequest } from '../models/ListAzureStorageAccountContainersRequest';
import { ListAzureSubnets200Response } from '../models/ListAzureSubnets200Response';
import { ListAzureSubnets200ResponseSubnetsInner } from '../models/ListAzureSubnets200ResponseSubnetsInner';
import { ListAzureSubnetsRequest } from '../models/ListAzureSubnetsRequest';
import { ListAzureUnassignedNetworkInterfaces200Response } from '../models/ListAzureUnassignedNetworkInterfaces200Response';
import { ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner } from '../models/ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner';
import { ListAzureUnassignedNetworkInterfacesRequest } from '../models/ListAzureUnassignedNetworkInterfacesRequest';
import { ListAzureVirtualNetworks200Response } from '../models/ListAzureVirtualNetworks200Response';
import { ListAzureVirtualNetworks200ResponseVirtualNetworksInner } from '../models/ListAzureVirtualNetworks200ResponseVirtualNetworksInner';
import { ListAzureVirtualNetworksRequest } from '../models/ListAzureVirtualNetworksRequest';
import { ListBackupJobTypesResponse } from '../models/ListBackupJobTypesResponse';
import { ListBackupJobsInternal200Response } from '../models/ListBackupJobsInternal200Response';
import { ListBackupJobsRequest } from '../models/ListBackupJobsRequest';
import { ListBackupJobsResponse } from '../models/ListBackupJobsResponse';
import { ListBackupPoliciesResponse } from '../models/ListBackupPoliciesResponse';
import { ListBackupPolicyResponse } from '../models/ListBackupPolicyResponse';
import { ListBackupVaultResponse } from '../models/ListBackupVaultResponse';
import { ListBackupZeroEtlPoliciesResponse } from '../models/ListBackupZeroEtlPoliciesResponse';
import { ListBillingTransactionHistoryRequest } from '../models/ListBillingTransactionHistoryRequest';
import { ListBillingTransactionHistoryResponse } from '../models/ListBillingTransactionHistoryResponse';
import { ListCloudSnapshotsResponse } from '../models/ListCloudSnapshotsResponse';
import { ListConnectorsResponse } from '../models/ListConnectorsResponse';
import { ListControlViolationsResponse } from '../models/ListControlViolationsResponse';
import { ListControlsResponse } from '../models/ListControlsResponse';
import { ListCredentialFindingsResponse } from '../models/ListCredentialFindingsResponse';
import { ListDailySnapshotsResponse } from '../models/ListDailySnapshotsResponse';
import { ListDashboardsResponse } from '../models/ListDashboardsResponse';
import { ListDataCatalogsResponse } from '../models/ListDataCatalogsResponse';
import { ListDataClassificationEntitiesResponse } from '../models/ListDataClassificationEntitiesResponse';
import { ListDatabaseSnapshotsResponse } from '../models/ListDatabaseSnapshotsResponse';
import { ListDlsgPoliciesResponse } from '../models/ListDlsgPoliciesResponse';
import { ListDynamoDbBackupConfigsResponse } from '../models/ListDynamoDbBackupConfigsResponse';
import { ListEksClustersResponse } from '../models/ListEksClustersResponse';
import { ListFindingsResponse } from '../models/ListFindingsResponse';
import { ListGcpFoldersResponse } from '../models/ListGcpFoldersResponse';
import { ListGcpNetworksResponse } from '../models/ListGcpNetworksResponse';
import { ListGcpNetworksResponseNetworksInner } from '../models/ListGcpNetworksResponseNetworksInner';
import { ListGcpOrganizationsResponse } from '../models/ListGcpOrganizationsResponse';
import { ListGcpSubnetsResponse } from '../models/ListGcpSubnetsResponse';
import { ListIdpGroupsResponse } from '../models/ListIdpGroupsResponse';
import { ListIdpsResponse } from '../models/ListIdpsResponse';
import { ListInfectedExcludePathsResponse } from '../models/ListInfectedExcludePathsResponse';
import { ListIngestionPipelinesResponse } from '../models/ListIngestionPipelinesResponse';
import { ListInstanceProfilesResponse } from '../models/ListInstanceProfilesResponse';
import { ListInstanceTypesResponse } from '../models/ListInstanceTypesResponse';
import { ListIntegrationsResponse } from '../models/ListIntegrationsResponse';
import { ListInventoryAppsResponse } from '../models/ListInventoryAppsResponse';
import { ListInventoryBackupRegionsResponse } from '../models/ListInventoryBackupRegionsResponse';
import { ListInventoryEnvironmentsResponse } from '../models/ListInventoryEnvironmentsResponse';
import { ListInventoryGlobalDatabasesResponse } from '../models/ListInventoryGlobalDatabasesResponse';
import { ListInventoryItemSnapshotsResponse } from '../models/ListInventoryItemSnapshotsResponse';
import { ListInventoryNetworksResponse } from '../models/ListInventoryNetworksResponse';
import { ListInventoryRequest } from '../models/ListInventoryRequest';
import { ListInventoryResourceGroupsResponse } from '../models/ListInventoryResourceGroupsResponse';
import { ListInventoryResourceIdentifiersResponse } from '../models/ListInventoryResourceIdentifiersResponse';
import { ListInventoryResourceTypesResponse } from '../models/ListInventoryResourceTypesResponse';
import { ListInventoryResourcesResponse } from '../models/ListInventoryResourcesResponse';
import { ListInventorySensitivityAnnotationValuesResponse } from '../models/ListInventorySensitivityAnnotationValuesResponse';
import { ListInventorySnapshotsRequest } from '../models/ListInventorySnapshotsRequest';
import { ListInventorySnapshotsResponse } from '../models/ListInventorySnapshotsResponse';
import { ListInventorySourceRegionsResponse } from '../models/ListInventorySourceRegionsResponse';
import { ListInventorySubnetsResponse } from '../models/ListInventorySubnetsResponse';
import { ListInventoryTagsResponse } from '../models/ListInventoryTagsResponse';
import { ListJobErrorCodesResponse } from '../models/ListJobErrorCodesResponse';
import { ListJobTemplatesResponse } from '../models/ListJobTemplatesResponse';
import { ListKeyspacesBackupConfigsResponse } from '../models/ListKeyspacesBackupConfigsResponse';
import { ListKnownAppsResponse } from '../models/ListKnownAppsResponse';
import { ListLogSourcesPoliciesResponse } from '../models/ListLogSourcesPoliciesResponse';
import { ListLogSourcesResponse } from '../models/ListLogSourcesResponse';
import { ListMongoAtlasPrivateLinks200Response } from '../models/ListMongoAtlasPrivateLinks200Response';
import { ListNotebooksResponse } from '../models/ListNotebooksResponse';
import { ListNotificationPoliciesResponse } from '../models/ListNotificationPoliciesResponse';
import { ListNotificationsResponse } from '../models/ListNotificationsResponse';
import { ListOAuthAppsResponse } from '../models/ListOAuthAppsResponse';
import { ListObjectStoreExclusionRulesResponse } from '../models/ListObjectStoreExclusionRulesResponse';
import { ListPermissionsResponse } from '../models/ListPermissionsResponse';
import { ListProjectsResponse } from '../models/ListProjectsResponse';
import { ListResourceAttachmentEventsResponse } from '../models/ListResourceAttachmentEventsResponse';
import { ListResourcesResponse } from '../models/ListResourcesResponse';
import { ListRestoreAccountsRequest } from '../models/ListRestoreAccountsRequest';
import { ListRestoreAccountsResponse } from '../models/ListRestoreAccountsResponse';
import { ListRestoreJobTypesResponse } from '../models/ListRestoreJobTypesResponse';
import { ListRestoreJobsInternal200Response } from '../models/ListRestoreJobsInternal200Response';
import { ListRestoreJobsRequest } from '../models/ListRestoreJobsRequest';
import { ListRestoreJobsResponse } from '../models/ListRestoreJobsResponse';
import { ListRolesResponse } from '../models/ListRolesResponse';
import { ListSavedQueriesResponse } from '../models/ListSavedQueriesResponse';
import { ListScanJobTypesResponse } from '../models/ListScanJobTypesResponse';
import { ListScanJobsInternal200Response } from '../models/ListScanJobsInternal200Response';
import { ListScanJobsRequest } from '../models/ListScanJobsRequest';
import { ListScanJobsResponse } from '../models/ListScanJobsResponse';
import { ListSensitivityAnnotationsResponse } from '../models/ListSensitivityAnnotationsResponse';
import { ListSourceAccountsRequest } from '../models/ListSourceAccountsRequest';
import { ListSourceAccountsResponse } from '../models/ListSourceAccountsResponse';
import { ListSourceAwsOrganizationalUnitsResponse } from '../models/ListSourceAwsOrganizationalUnitsResponse';
import { ListSparkEnginesResponse } from '../models/ListSparkEnginesResponse';
import { ListSparkJobsResponse } from '../models/ListSparkJobsResponse';
import { ListSqlEnginesResponse } from '../models/ListSqlEnginesResponse';
import { ListSqlQueryExecutionsResponse } from '../models/ListSqlQueryExecutionsResponse';
import { ListStorageGatewaysResponse } from '../models/ListStorageGatewaysResponse';
import { ListSubnetsResponse } from '../models/ListSubnetsResponse';
import { ListSubnetsResponseV2 } from '../models/ListSubnetsResponseV2';
import { ListSubnetsResponseV2SubnetsInner } from '../models/ListSubnetsResponseV2SubnetsInner';
import { ListUsersResponse } from '../models/ListUsersResponse';
import { ListZeroEtlPoliciesResponse } from '../models/ListZeroEtlPoliciesResponse';
import { LlgLocationResource } from '../models/LlgLocationResource';
import { LlgLocationWithResources } from '../models/LlgLocationWithResources';
import { LlgResourcePolicy } from '../models/LlgResourcePolicy';
import { LogRecord } from '../models/LogRecord';
import { LogSource } from '../models/LogSource';
import { LogSourceLocation } from '../models/LogSourceLocation';
import { LogSourceLocationCloudTrail } from '../models/LogSourceLocationCloudTrail';
import { LogSourceLocationCloudWatchLogs } from '../models/LogSourceLocationCloudWatchLogs';
import { LogSourceLocationDatadog } from '../models/LogSourceLocationDatadog';
import { LogSourceLocationGcpCloudLogging } from '../models/LogSourceLocationGcpCloudLogging';
import { LogSourceLocationSplunkDdss } from '../models/LogSourceLocationSplunkDdss';
import { LogSourceWithPolicy } from '../models/LogSourceWithPolicy';
import { LogsHistogramDataPoint } from '../models/LogsHistogramDataPoint';
import { LogsSchema } from '../models/LogsSchema';
import { LogsSchemaColumn } from '../models/LogsSchemaColumn';
import { LogsSchemaEntry } from '../models/LogsSchemaEntry';
import { LogsSchemasResponse } from '../models/LogsSchemasResponse';
import { LuceneQueryInput } from '../models/LuceneQueryInput';
import { MaxRetentionRule } from '../models/MaxRetentionRule';
import { Message } from '../models/Message';
import { MicrosoftFabricIntegrationConfig } from '../models/MicrosoftFabricIntegrationConfig';
import { MinRetentionRule } from '../models/MinRetentionRule';
import { ModelError } from '../models/ModelError';
import { MongoAtlasPrivateLinkEntry } from '../models/MongoAtlasPrivateLinkEntry';
import { MongoAtlasRestoreAccountAttributes } from '../models/MongoAtlasRestoreAccountAttributes';
import { MongoAtlasRestoreAccountAttributesInput } from '../models/MongoAtlasRestoreAccountAttributesInput';
import { MongoAtlasSourceAccountAttributes } from '../models/MongoAtlasSourceAccountAttributes';
import { MongoAtlasSourceAccountAttributesInput } from '../models/MongoAtlasSourceAccountAttributesInput';
import { MonthlyConfig } from '../models/MonthlyConfig';
import { MonthlySnapshotData } from '../models/MonthlySnapshotData';
import { MsaAcceptanceResponse } from '../models/MsaAcceptanceResponse';
import { NativeStandardBackupPolicyPlan } from '../models/NativeStandardBackupPolicyPlan';
import { NativeStandardBackupSchedules } from '../models/NativeStandardBackupSchedules';
import { NativeStandardConfig } from '../models/NativeStandardConfig';
import { NeptuneClusterParameterGroup } from '../models/NeptuneClusterParameterGroup';
import { NeptuneClusterParameterGroups } from '../models/NeptuneClusterParameterGroups';
import { NeptuneRestoreDestination } from '../models/NeptuneRestoreDestination';
import { NeptuneSnapshotProperties } from '../models/NeptuneSnapshotProperties';
import { NetworkInterfaceConfig } from '../models/NetworkInterfaceConfig';
import { Notebook } from '../models/Notebook';
import { NotebookExecutionOutput } from '../models/NotebookExecutionOutput';
import { NotebookExecutionResult } from '../models/NotebookExecutionResult';
import { NotebookSession } from '../models/NotebookSession';
import { Notification } from '../models/Notification';
import { NotificationArguments } from '../models/NotificationArguments';
import { NotificationPolicy } from '../models/NotificationPolicy';
import { NotificationPolicyConfig } from '../models/NotificationPolicyConfig';
import { NotificationPolicyConfigEmail } from '../models/NotificationPolicyConfigEmail';
import { NotificationPolicyConfigServiceNow } from '../models/NotificationPolicyConfigServiceNow';
import { NotificationPolicyConfigSlack } from '../models/NotificationPolicyConfigSlack';
import { NotificationPolicyConfigSns } from '../models/NotificationPolicyConfigSns';
import { NotificationPolicyConfigSplunk } from '../models/NotificationPolicyConfigSplunk';
import { NotificationPolicyConfigWebhook } from '../models/NotificationPolicyConfigWebhook';
import { NumberOfCopiesRule } from '../models/NumberOfCopiesRule';
import { OAuthApp } from '../models/OAuthApp';
import { Oauth2TokenResponse } from '../models/Oauth2TokenResponse';
import { ObjectStorageDestination } from '../models/ObjectStorageDestination';
import { ObjectStoreExclusionRule } from '../models/ObjectStoreExclusionRule';
import { OnboardAdditionalAzureApps200Response } from '../models/OnboardAdditionalAzureApps200Response';
import { OnboardAdditionalAzureAppsRequest } from '../models/OnboardAdditionalAzureAppsRequest';
import { OnboardRdsCdcRequest } from '../models/OnboardRdsCdcRequest';
import { OnboardRdsCdcResponse } from '../models/OnboardRdsCdcResponse';
import { OnboardingAzureResourceGroup } from '../models/OnboardingAzureResourceGroup';
import { OperationIdFilters } from '../models/OperationIdFilters';
import { OverrideDataClassificationsRequest } from '../models/OverrideDataClassificationsRequest';
import { OverrideDataClassificationsResponse } from '../models/OverrideDataClassificationsResponse';
import { OverrideEnvironmentRequest } from '../models/OverrideEnvironmentRequest';
import { OverrideEnvironmentResponse } from '../models/OverrideEnvironmentResponse';
import { OverrideSensitivityAnnotationsRequest } from '../models/OverrideSensitivityAnnotationsRequest';
import { Pagination } from '../models/Pagination';
import { ParameterCheckResult } from '../models/ParameterCheckResult';
import { ParentIdFilters } from '../models/ParentIdFilters';
import { PartialRestoreData } from '../models/PartialRestoreData';
import { Path } from '../models/Path';
import { PathSegment } from '../models/PathSegment';
import { PathSnapshotsRequest } from '../models/PathSnapshotsRequest';
import { PathSnapshotsResponse } from '../models/PathSnapshotsResponse';
import { Permission } from '../models/Permission';
import { PermissionGrant } from '../models/PermissionGrant';
import { PermissionGrantInput } from '../models/PermissionGrantInput';
import { PersistentVolumeClaimProperties } from '../models/PersistentVolumeClaimProperties';
import { PitrBackupPolicyPlan } from '../models/PitrBackupPolicyPlan';
import { PitrBackupResourceType } from '../models/PitrBackupResourceType';
import { PitrBackupSchedules } from '../models/PitrBackupSchedules';
import { PitrIntervalConfig } from '../models/PitrIntervalConfig';
import { PitrRestoreVaultWindows } from '../models/PitrRestoreVaultWindows';
import { PitrRestoreWindow } from '../models/PitrRestoreWindow';
import { PitrRestoreWindowsResponse } from '../models/PitrRestoreWindowsResponse';
import { Preferences } from '../models/Preferences';
import { PrivateLink } from '../models/PrivateLink';
import { PrivateLinkCheckResult } from '../models/PrivateLinkCheckResult';
import { PrivateLinkFormatInstructions } from '../models/PrivateLinkFormatInstructions';
import { PrivateLinkInstructionStep } from '../models/PrivateLinkInstructionStep';
import { Project } from '../models/Project';
import { ProjectIdFilters } from '../models/ProjectIdFilters';
import { ProviderAccountIdFilters } from '../models/ProviderAccountIdFilters';
import { ProviderParentIdFilters } from '../models/ProviderParentIdFilters';
import { ProviderRestoreAccountConnectivityConfig } from '../models/ProviderRestoreAccountConnectivityConfig';
import { PulumiConfiguration } from '../models/PulumiConfiguration';
import { PulumiConfigurations } from '../models/PulumiConfigurations';
import { PulumiConfigurationsFilterConditions } from '../models/PulumiConfigurationsFilterConditions';
import { PulumiConfigurationsRequest } from '../models/PulumiConfigurationsRequest';
import { QueryCostData400Response } from '../models/QueryCostData400Response';
import { QueryCostDataRequest } from '../models/QueryCostDataRequest';
import { QueryCostDataResponse } from '../models/QueryCostDataResponse';
import { QueryDBRequest } from '../models/QueryDBRequest';
import { QueryDBResponse } from '../models/QueryDBResponse';
import { QueryDBRestoreDestination } from '../models/QueryDBRestoreDestination';
import { QueryDBResultResponse } from '../models/QueryDBResultResponse';
import { QueryDBStatusResponse } from '../models/QueryDBStatusResponse';
import { QuotaStatusFilters } from '../models/QuotaStatusFilters';
import { RamShareCheckResult } from '../models/RamShareCheckResult';
import { RansomwareResourceNotificationArguments } from '../models/RansomwareResourceNotificationArguments';
import { RdsNativePitrAdvancedConfig } from '../models/RdsNativePitrAdvancedConfig';
import { RdsNativePitrClusterAdvancedConfig } from '../models/RdsNativePitrClusterAdvancedConfig';
import { RdsNativePitrNetworkConfig } from '../models/RdsNativePitrNetworkConfig';
import { RdsNativePitrWindow } from '../models/RdsNativePitrWindow';
import { RdsPasswordConfig } from '../models/RdsPasswordConfig';
import { RdsSecurityGroup } from '../models/RdsSecurityGroup';
import { ReactivateAccountRequest } from '../models/ReactivateAccountRequest';
import { ReconnectCustomerVaultAccountResponse } from '../models/ReconnectCustomerVaultAccountResponse';
import { ReconnectRestoreAccountResponse } from '../models/ReconnectRestoreAccountResponse';
import { ReconnectSourceAccountResponse } from '../models/ReconnectSourceAccountResponse';
import { ReconnectSourceAwsOrganizationalUnitResponse } from '../models/ReconnectSourceAwsOrganizationalUnitResponse';
import { RecordRestoreResult } from '../models/RecordRestoreResult';
import { RecoveryPointData } from '../models/RecoveryPointData';
import { RedshiftCluster } from '../models/RedshiftCluster';
import { RedshiftClusters } from '../models/RedshiftClusters';
import { RedshiftIntegrationConfig } from '../models/RedshiftIntegrationConfig';
import { RedshiftRestoreDestination } from '../models/RedshiftRestoreDestination';
import { RedshiftServerlessNamespace } from '../models/RedshiftServerlessNamespace';
import { RedshiftServerlessNamespaces } from '../models/RedshiftServerlessNamespaces';
import { RedshiftSnapshotProperties } from '../models/RedshiftSnapshotProperties';
import { RegionCondition } from '../models/RegionCondition';
import { RegisterInput } from '../models/RegisterInput';
import { RegisterInputBillingToken } from '../models/RegisterInputBillingToken';
import { RegisterResponse } from '../models/RegisterResponse';
import { RelatedGlobalDbCluster } from '../models/RelatedGlobalDbCluster';
import { RequestDetails } from '../models/RequestDetails';
import { ResourceDetails } from '../models/ResourceDetails';
import { ResourceGroupNameCondition } from '../models/ResourceGroupNameCondition';
import { ResourceIdCondition } from '../models/ResourceIdCondition';
import { ResourceIdFilters } from '../models/ResourceIdFilters';
import { ResourceIdentifiers } from '../models/ResourceIdentifiers';
import { ResourceNameCondition } from '../models/ResourceNameCondition';
import { ResourceNameFilters } from '../models/ResourceNameFilters';
import { ResourceProperties } from '../models/ResourceProperties';
import { ResourceSnapshot } from '../models/ResourceSnapshot';
import { ResourceSnapshotProperties } from '../models/ResourceSnapshotProperties';
import { ResourceTag } from '../models/ResourceTag';
import { ResourceTypeCondition } from '../models/ResourceTypeCondition';
import { ResourceTypeFilters } from '../models/ResourceTypeFilters';
import { ResourceTypeToSecurityGroup } from '../models/ResourceTypeToSecurityGroup';
import { ResourceValidationError } from '../models/ResourceValidationError';
import { RestoreAccount } from '../models/RestoreAccount';
import { RestoreAccountAttributesInput } from '../models/RestoreAccountAttributesInput';
import { RestoreAccountCloudAttributes } from '../models/RestoreAccountCloudAttributes';
import { RestoreAccountConnectivityConfig } from '../models/RestoreAccountConnectivityConfig';
import { RestoreAccountMetricsConfig } from '../models/RestoreAccountMetricsConfig';
import { RestoreAccountRegions } from '../models/RestoreAccountRegions';
import { RestoreAccountsFilterConditions } from '../models/RestoreAccountsFilterConditions';
import { RestoreAtlasClusterInput } from '../models/RestoreAtlasClusterInput';
import { RestoreAvailabilityZones } from '../models/RestoreAvailabilityZones';
import { RestoreAwsEc2InstanceRequest } from '../models/RestoreAwsEc2InstanceRequest';
import { RestoreAzureDiskConfig } from '../models/RestoreAzureDiskConfig';
import { RestoreAzureDiskRequest } from '../models/RestoreAzureDiskRequest';
import { RestoreAzureInstanceDiskInput } from '../models/RestoreAzureInstanceDiskInput';
import { RestoreAzurePostgresDatabaseRequest } from '../models/RestoreAzurePostgresDatabaseRequest';
import { RestoreAzureSqlDatabaseRequest } from '../models/RestoreAzureSqlDatabaseRequest';
import { RestoreAzureSqlVmPitrRequest } from '../models/RestoreAzureSqlVmPitrRequest';
import { RestoreAzureVMInstanceConfig } from '../models/RestoreAzureVMInstanceConfig';
import { RestoreAzureVmInstanceRequest } from '../models/RestoreAzureVmInstanceRequest';
import { RestoreBigQueryDatasetRequest } from '../models/RestoreBigQueryDatasetRequest';
import { RestoreBigQueryNativePitrRequest } from '../models/RestoreBigQueryNativePitrRequest';
import { RestoreBucketRequest } from '../models/RestoreBucketRequest';
import { RestoreDbToRdsInstanceRequest } from '../models/RestoreDbToRdsInstanceRequest';
import { RestoreDbToRdsSnapshotRequest } from '../models/RestoreDbToRdsSnapshotRequest';
import { RestoreDestinationLimits } from '../models/RestoreDestinationLimits';
import { RestoreDocumentDBRequest } from '../models/RestoreDocumentDBRequest';
import { RestoreDynamoDBTableRequest } from '../models/RestoreDynamoDBTableRequest';
import { RestoreDynamoDBToExistingTableRequest } from '../models/RestoreDynamoDBToExistingTableRequest';
import { RestoreDynamoDbTableConfig } from '../models/RestoreDynamoDbTableConfig';
import { RestoreEFSRequest } from '../models/RestoreEFSRequest';
import { RestoreEbsVolumeConfig } from '../models/RestoreEbsVolumeConfig';
import { RestoreEc2InstanceConfig } from '../models/RestoreEc2InstanceConfig';
import { RestoreEksNamespaceConfig } from '../models/RestoreEksNamespaceConfig';
import { RestoreEksNamespaceInput } from '../models/RestoreEksNamespaceInput';
import { RestoreEksNamespaceVolumeInput } from '../models/RestoreEksNamespaceVolumeInput';
import { RestoreFSxRequest } from '../models/RestoreFSxRequest';
import { RestoreFilesRequest } from '../models/RestoreFilesRequest';
import { RestoreGceDiskConfig } from '../models/RestoreGceDiskConfig';
import { RestoreGceInstanceConfig } from '../models/RestoreGceInstanceConfig';
import { RestoreGcpCloudSqlDatabaseConfig } from '../models/RestoreGcpCloudSqlDatabaseConfig';
import { RestoreGcpCloudSqlRequest } from '../models/RestoreGcpCloudSqlRequest';
import { RestoreGcpDiskRequest } from '../models/RestoreGcpDiskRequest';
import { RestoreGcpInstanceDiskInput } from '../models/RestoreGcpInstanceDiskInput';
import { RestoreGcpVmInstanceRequest } from '../models/RestoreGcpVmInstanceRequest';
import { RestoreImageImageDeviceInput } from '../models/RestoreImageImageDeviceInput';
import { RestoreImageImageInput } from '../models/RestoreImageImageInput';
import { RestoreImageInput } from '../models/RestoreImageInput';
import { RestoreImageVolumeInput } from '../models/RestoreImageVolumeInput';
import { RestoreInstanceImageDeviceInput } from '../models/RestoreInstanceImageDeviceInput';
import { RestoreInstanceImageInput } from '../models/RestoreInstanceImageInput';
import { RestoreInstanceVolumeInput } from '../models/RestoreInstanceVolumeInput';
import { RestoreJob } from '../models/RestoreJob';
import { RestoreJobConfiguration } from '../models/RestoreJobConfiguration';
import { RestoreJobInitiationResponse } from '../models/RestoreJobInitiationResponse';
import { RestoreJobTypeFilters } from '../models/RestoreJobTypeFilters';
import { RestoreJobsFilterConditions } from '../models/RestoreJobsFilterConditions';
import { RestoreKeyspacesTableRequest } from '../models/RestoreKeyspacesTableRequest';
import { RestoreNeptuneRequest } from '../models/RestoreNeptuneRequest';
import { RestoreRdsInstanceClasses } from '../models/RestoreRdsInstanceClasses';
import { RestoreRdsInstanceConfig } from '../models/RestoreRdsInstanceConfig';
import { RestoreRdsNativePitrRequest } from '../models/RestoreRdsNativePitrRequest';
import { RestoreRdsSubnetGroups } from '../models/RestoreRdsSubnetGroups';
import { RestoreRdsSubnetGroupsRdsSubnetGroupsInner } from '../models/RestoreRdsSubnetGroupsRdsSubnetGroupsInner';
import { RestoreRedshiftRequest } from '../models/RestoreRedshiftRequest';
import { RestoreResult } from '../models/RestoreResult';
import { RestoreSecurityGroups } from '../models/RestoreSecurityGroups';
import { RestoreSecurityGroupsSecurityGroupsInner } from '../models/RestoreSecurityGroupsSecurityGroupsInner';
import { RestoreVolumeToEbsRequest } from '../models/RestoreVolumeToEbsRequest';
import { RestoreVolumeToEbsSnapshotRequest } from '../models/RestoreVolumeToEbsSnapshotRequest';
import { Role } from '../models/Role';
import { RoleAccessGroupCondition } from '../models/RoleAccessGroupCondition';
import { S3Bucket } from '../models/S3Bucket';
import { S3Buckets } from '../models/S3Buckets';
import { S3RestoreDestination } from '../models/S3RestoreDestination';
import { S3RestoreTarget } from '../models/S3RestoreTarget';
import { S3SourceProperties } from '../models/S3SourceProperties';
import { SAMLCallback400Response } from '../models/SAMLCallback400Response';
import { SAMLCallback401Response } from '../models/SAMLCallback401Response';
import { SAMLCallback500Response } from '../models/SAMLCallback500Response';
import { SamlIdentityProvider } from '../models/SamlIdentityProvider';
import { SamlIdentityProviderConfigsResponse } from '../models/SamlIdentityProviderConfigsResponse';
import { SapHanaInstance } from '../models/SapHanaInstance';
import { SapHanaRestoreProperties } from '../models/SapHanaRestoreProperties';
import { SaveCloudResourceSecurityPropertiesRequest } from '../models/SaveCloudResourceSecurityPropertiesRequest';
import { SaveNotebookContentRequest } from '../models/SaveNotebookContentRequest';
import { SavedQuery } from '../models/SavedQuery';
import { ScanJob } from '../models/ScanJob';
import { SchemaRecord } from '../models/SchemaRecord';
import { SchemaRegistryAuthConfig } from '../models/SchemaRegistryAuthConfig';
import { SchemaRegistryConfig } from '../models/SchemaRegistryConfig';
import { SearchDBResponse } from '../models/SearchDBResponse';
import { SearchFilesResponse } from '../models/SearchFilesResponse';
import { SearchInput } from '../models/SearchInput';
import { SearchLogsHistogramInput } from '../models/SearchLogsHistogramInput';
import { SearchLogsHistogramResponse } from '../models/SearchLogsHistogramResponse';
import { SearchLogsInput } from '../models/SearchLogsInput';
import { SearchLogsResponse } from '../models/SearchLogsResponse';
import { SearchResources200Response } from '../models/SearchResources200Response';
import { SearchResources200ResponseTablesInner } from '../models/SearchResources200ResponseTablesInner';
import { SearchResources200ResponseTablesInnerResource } from '../models/SearchResources200ResponseTablesInnerResource';
import { SearchResources200ResponseTablesInnerSnapshots } from '../models/SearchResources200ResponseTablesInnerSnapshots';
import { SearchResources200ResponseTablesInnerSource } from '../models/SearchResources200ResponseTablesInnerSource';
import { SearchResources200ResponseTablesInnerTablesInner } from '../models/SearchResources200ResponseTablesInnerTablesInner';
import { SearchResources200ResponseTablesInnerTablesInnerColumnsInner } from '../models/SearchResources200ResponseTablesInnerTablesInnerColumnsInner';
import { SearchResourcesRequest } from '../models/SearchResourcesRequest';
import { SecurityGroupRule } from '../models/SecurityGroupRule';
import { SecurityInformation } from '../models/SecurityInformation';
import { SecurityPlan } from '../models/SecurityPlan';
import { SecurityPlanEnabledResponse } from '../models/SecurityPlanEnabledResponse';
import { SecurityResourceNotificationArguments } from '../models/SecurityResourceNotificationArguments';
import { SecurityScan } from '../models/SecurityScan';
import { SecurityScanNotificationData } from '../models/SecurityScanNotificationData';
import { SecurityScanResult } from '../models/SecurityScanResult';
import { SecurityScansSummaryResponse } from '../models/SecurityScansSummaryResponse';
import { SecuritySnapshotNotificationArguments } from '../models/SecuritySnapshotNotificationArguments';
import { SecuritySummary } from '../models/SecuritySummary';
import { SendA2AMessageRequest } from '../models/SendA2AMessageRequest';
import { SendMessageToAI400Response } from '../models/SendMessageToAI400Response';
import { SendMessageToAIRequest } from '../models/SendMessageToAIRequest';
import { SensitivityAnnotation } from '../models/SensitivityAnnotation';
import { SensitivityAnnotationsDetails } from '../models/SensitivityAnnotationsDetails';
import { ServiceProviderDetails } from '../models/ServiceProviderDetails';
import { Session } from '../models/Session';
import { SetupAwsPrivateLinkRequest } from '../models/SetupAwsPrivateLinkRequest';
import { SetupAwsPrivateLinkResponse } from '../models/SetupAwsPrivateLinkResponse';
import { SetupMongoAtlasPrivateLinkRequest } from '../models/SetupMongoAtlasPrivateLinkRequest';
import { SetupMongoAtlasPrivateLinkResponse } from '../models/SetupMongoAtlasPrivateLinkResponse';
import { SeverityFilters } from '../models/SeverityFilters';
import { Snapshot } from '../models/Snapshot';
import { SnapshotAccessDeniedNotificationArguments } from '../models/SnapshotAccessDeniedNotificationArguments';
import { SnapshotDateFilters } from '../models/SnapshotDateFilters';
import { SnapshotFilterConditions } from '../models/SnapshotFilterConditions';
import { SnapshotFindingCountsResponse } from '../models/SnapshotFindingCountsResponse';
import { SnapshotIdFilters } from '../models/SnapshotIdFilters';
import { SnapshotLocation } from '../models/SnapshotLocation';
import { SnapshotReference } from '../models/SnapshotReference';
import { SnapshotStorage } from '../models/SnapshotStorage';
import { SnapshotsSummaryResponse } from '../models/SnapshotsSummaryResponse';
import { SnowflakeIntegrationConfig } from '../models/SnowflakeIntegrationConfig';
import { SortBackupJobBy } from '../models/SortBackupJobBy';
import { SortColumnSpec } from '../models/SortColumnSpec';
import { SortLogsBy } from '../models/SortLogsBy';
import { SortResourceBy } from '../models/SortResourceBy';
import { SortRestoreAccountsBy } from '../models/SortRestoreAccountsBy';
import { SortRestoreJobBy } from '../models/SortRestoreJobBy';
import { SortSnapshotsBy } from '../models/SortSnapshotsBy';
import { SortSourceAccountsBy } from '../models/SortSourceAccountsBy';
import { SourceAccount } from '../models/SourceAccount';
import { SourceAccountAttributesInput } from '../models/SourceAccountAttributesInput';
import { SourceAccountCloudAttributes } from '../models/SourceAccountCloudAttributes';
import { SourceAccountMetricsConfig } from '../models/SourceAccountMetricsConfig';
import { SourceAccountProviderIdFilters } from '../models/SourceAccountProviderIdFilters';
import { SourceAccountsFilterConditions } from '../models/SourceAccountsFilterConditions';
import { SourceAwsOrganizationalUnit } from '../models/SourceAwsOrganizationalUnit';
import { SourceRegionFilters } from '../models/SourceRegionFilters';
import { SourceSizeCheckResult } from '../models/SourceSizeCheckResult';
import { SourceStorage } from '../models/SourceStorage';
import { SourceStorageBackupStatus } from '../models/SourceStorageBackupStatus';
import { SparkEngine } from '../models/SparkEngine';
import { SparkJob } from '../models/SparkJob';
import { SparkJobRetryPolicy } from '../models/SparkJobRetryPolicy';
import { SparkJobSparkSubmitParams } from '../models/SparkJobSparkSubmitParams';
import { SqlEngine } from '../models/SqlEngine';
import { SqlInstructions } from '../models/SqlInstructions';
import { SqlQueryExecution } from '../models/SqlQueryExecution';
import { SqlQueryExecutionResult } from '../models/SqlQueryExecutionResult';
import { SqlQueryExecutionResultColumn } from '../models/SqlQueryExecutionResultColumn';
import { SqlVmNetworkInfo } from '../models/SqlVmNetworkInfo';
import { SsoIntegrationSettings } from '../models/SsoIntegrationSettings';
import { StackNameFilters } from '../models/StackNameFilters';
import { StandardBackupPolicyPlan } from '../models/StandardBackupPolicyPlan';
import { StandardBackupScheduleConfig } from '../models/StandardBackupScheduleConfig';
import { StandardBackupSchedules } from '../models/StandardBackupSchedules';
import { StandardIntervalConfig } from '../models/StandardIntervalConfig';
import { StartNotebookSessionInput } from '../models/StartNotebookSessionInput';
import { StartSparkJobDirectParams } from '../models/StartSparkJobDirectParams';
import { StartSparkJobInput } from '../models/StartSparkJobInput';
import { StartSparkJobTemplateParams } from '../models/StartSparkJobTemplateParams';
import { StartSqlQueryExecutionInput } from '../models/StartSqlQueryExecutionInput';
import { StartTimeDateFilters } from '../models/StartTimeDateFilters';
import { StatusCodeFilters } from '../models/StatusCodeFilters';
import { StorageAccountContainerRestoreDestination } from '../models/StorageAccountContainerRestoreDestination';
import { StorageAccountRestoreTarget } from '../models/StorageAccountRestoreTarget';
import { StorageConfig } from '../models/StorageConfig';
import { StorageGateway } from '../models/StorageGateway';
import { StorageGatewayDetails } from '../models/StorageGatewayDetails';
import { SubnetConfig } from '../models/SubnetConfig';
import { SubnetFilters } from '../models/SubnetFilters';
import { SubnetPerAvailabilityZone } from '../models/SubnetPerAvailabilityZone';
import { SubnetsCondition } from '../models/SubnetsCondition';
import { SupportedProviders } from '../models/SupportedProviders';
import { TableMaintenanceConfig } from '../models/TableMaintenanceConfig';
import { TableRecord } from '../models/TableRecord';
import { TagKeyValue } from '../models/TagKeyValue';
import { TagKeyValuesCondition } from '../models/TagKeyValuesCondition';
import { TagKeyValuesFilters } from '../models/TagKeyValuesFilters';
import { TagKeysCondition } from '../models/TagKeysCondition';
import { TagKeysFilters } from '../models/TagKeysFilters';
import { TakeNativeSnapshotRequest } from '../models/TakeNativeSnapshotRequest';
import { TakeSnapshotRequest } from '../models/TakeSnapshotRequest';
import { TakeSnapshotResponse } from '../models/TakeSnapshotResponse';
import { TeardownAwsPrivateLinkResponse } from '../models/TeardownAwsPrivateLinkResponse';
import { TeardownMongoAtlasPrivateLinkResponse } from '../models/TeardownMongoAtlasPrivateLinkResponse';
import { TimeFrame } from '../models/TimeFrame';
import { TimeOfDay } from '../models/TimeOfDay';
import { TimeOfYear } from '../models/TimeOfYear';
import { TokenResponse } from '../models/TokenResponse';
import { TotalSourceStorageSizeResponse } from '../models/TotalSourceStorageSizeResponse';
import { TriggerKeyspacesScheduledDump200Response } from '../models/TriggerKeyspacesScheduledDump200Response';
import { UnifiedDBRecord } from '../models/UnifiedDBRecord';
import { UnifiedDBServerRecord } from '../models/UnifiedDBServerRecord';
import { UnifiedDatabaseRecord } from '../models/UnifiedDatabaseRecord';
import { UnifiedSchemaRecord } from '../models/UnifiedSchemaRecord';
import { UnifiedTableRecord } from '../models/UnifiedTableRecord';
import { UpPulumiStacksResponse } from '../models/UpPulumiStacksResponse';
import { UpdateAccountCompanyContactsRequest } from '../models/UpdateAccountCompanyContactsRequest';
import { UpdateAccountLabelsRequest } from '../models/UpdateAccountLabelsRequest';
import { UpdateAccountProfileResponse } from '../models/UpdateAccountProfileResponse';
import { UpdateApiCredentialsRequest } from '../models/UpdateApiCredentialsRequest';
import { UpdateBackupPolicyRequest } from '../models/UpdateBackupPolicyRequest';
import { UpdateBackupPolicyResponse } from '../models/UpdateBackupPolicyResponse';
import { UpdateBackupZeroEtlPolicyInput } from '../models/UpdateBackupZeroEtlPolicyInput';
import { UpdateCloudResourceConfigurationRequest } from '../models/UpdateCloudResourceConfigurationRequest';
import { UpdateCloudResourceConfigurationRequestCdcBackup } from '../models/UpdateCloudResourceConfigurationRequestCdcBackup';
import { UpdateCloudResourceConfigurationRequestInventoryBackup } from '../models/UpdateCloudResourceConfigurationRequestInventoryBackup';
import { UpdateControlViolationInput } from '../models/UpdateControlViolationInput';
import { UpdateDashboardInput } from '../models/UpdateDashboardInput';
import { UpdateDlsgPolicyRequest } from '../models/UpdateDlsgPolicyRequest';
import { UpdateDlsgPolicyResponse } from '../models/UpdateDlsgPolicyResponse';
import { UpdateGraphInput } from '../models/UpdateGraphInput';
import { UpdateIdpGroupRequest } from '../models/UpdateIdpGroupRequest';
import { UpdateIdpGroupResponse } from '../models/UpdateIdpGroupResponse';
import { UpdateIngestionPipelineInput } from '../models/UpdateIngestionPipelineInput';
import { UpdateIntegrationRequest } from '../models/UpdateIntegrationRequest';
import { UpdateIntegrationResponse } from '../models/UpdateIntegrationResponse';
import { UpdateJobTemplateInput } from '../models/UpdateJobTemplateInput';
import { UpdateNotebookInput } from '../models/UpdateNotebookInput';
import { UpdatePrivateLinkInput } from '../models/UpdatePrivateLinkInput';
import { UpdateProjectConfigurationKeyRequest } from '../models/UpdateProjectConfigurationKeyRequest';
import { UpdatePulumiConfigurationRequest } from '../models/UpdatePulumiConfigurationRequest';
import { UpdateResourceSecurityScansExclusionRequest } from '../models/UpdateResourceSecurityScansExclusionRequest';
import { UpdateRestoreAccountConnectivityConfigRequest } from '../models/UpdateRestoreAccountConnectivityConfigRequest';
import { UpdateRestoreAccountConnectivityConfigResponse } from '../models/UpdateRestoreAccountConnectivityConfigResponse';
import { UpdateRoleRequest } from '../models/UpdateRoleRequest';
import { UpdateRoleResponse } from '../models/UpdateRoleResponse';
import { UpdateSamlIdentityProviderInput } from '../models/UpdateSamlIdentityProviderInput';
import { UpdateSavedQueryInput } from '../models/UpdateSavedQueryInput';
import { UpdateSessionRequest } from '../models/UpdateSessionRequest';
import { UpdateShouldFullBackupResourceRequest } from '../models/UpdateShouldFullBackupResourceRequest';
import { UpdateTableMaintenanceConfigInput } from '../models/UpdateTableMaintenanceConfigInput';
import { UpdateUserInput } from '../models/UpdateUserInput';
import { UpdateVaultRequest } from '../models/UpdateVaultRequest';
import { UpdateVaultResponse } from '../models/UpdateVaultResponse';
import { UpdateViewerRoleRequest } from '../models/UpdateViewerRoleRequest';
import { UpdateWorkspaceBucketPolicyInput } from '../models/UpdateWorkspaceBucketPolicyInput';
import { UpdateWorkspaceLoggingSettingsInput } from '../models/UpdateWorkspaceLoggingSettingsInput';
import { UpdateWorkspaceMetricsSettingsInput } from '../models/UpdateWorkspaceMetricsSettingsInput';
import { UpdateZeroEtlPolicyInput } from '../models/UpdateZeroEtlPolicyInput';
import { Usage } from '../models/Usage';
import { User } from '../models/User';
import { UserIdFilters } from '../models/UserIdFilters';
import { VNetConfig } from '../models/VNetConfig';
import { ValidateResourceConfigurationRequest } from '../models/ValidateResourceConfigurationRequest';
import { ValidateResourceConfigurationResponse } from '../models/ValidateResourceConfigurationResponse';
import { VaultFilters } from '../models/VaultFilters';
import { VaultMetadataReplicationConfig } from '../models/VaultMetadataReplicationConfig';
import { VaultNotificationArguments } from '../models/VaultNotificationArguments';
import { VaultProviderAttributes } from '../models/VaultProviderAttributes';
import { VaultProviderAttributesInput } from '../models/VaultProviderAttributesInput';
import { VaultSnapshotCount } from '../models/VaultSnapshotCount';
import { VerifyMongoAtlasPrivateLinkResponse } from '../models/VerifyMongoAtlasPrivateLinkResponse';
import { Viewer } from '../models/Viewer';
import { ViolationsDetectionNotificationArguments } from '../models/ViolationsDetectionNotificationArguments';
import { VirtualMachineRestoreDestination } from '../models/VirtualMachineRestoreDestination';
import { VisualizationHistogramSeries } from '../models/VisualizationHistogramSeries';
import { VisualizationHistogramTimePoint } from '../models/VisualizationHistogramTimePoint';
import { VisualizationLabel } from '../models/VisualizationLabel';
import { VolumeSettings } from '../models/VolumeSettings';
import { VpcCondition } from '../models/VpcCondition';
import { VpcPeering } from '../models/VpcPeering';
import { VpcPropertyFilters } from '../models/VpcPropertyFilters';
import { WarmCapacity } from '../models/WarmCapacity';
import { WeeklyConfig } from '../models/WeeklyConfig';
import { Workspace } from '../models/Workspace';
import { WorkspaceBucketPolicy } from '../models/WorkspaceBucketPolicy';
import { WorkspaceLoggingSettings } from '../models/WorkspaceLoggingSettings';
import { WorkspaceMetricsSettings } from '../models/WorkspaceMetricsSettings';
import { WorkspaceNetworkingSettings } from '../models/WorkspaceNetworkingSettings';
import { YearlySnapshotDistribution } from '../models/YearlySnapshotDistribution';
import { ZeroEtlIdentityColumnSpec } from '../models/ZeroEtlIdentityColumnSpec';
import { ZeroEtlPolicy } from '../models/ZeroEtlPolicy';
import { ZeroEtlResourceSelector } from '../models/ZeroEtlResourceSelector';
import { ZeroEtlRoutingPolicy } from '../models/ZeroEtlRoutingPolicy';
let primitives = [
    "string",
    "boolean",
    "double",
    "integer",
    "long",
    "float",
    "number",
    "any"
];
let enumsMap = new Set([
    "AccessConditionEffect",
    "AccountInstallationMethod",
    "AccountState",
    "ActionRequiredDetails",
    "AgreementWithCreditsTypeEnum",
    "AuditLogAction",
    "AuditLogAuthMethod",
    "AuditLogAuthStatus",
    "AuditLogInitiatorType",
    "AuditLogMfaMethod",
    "AwsEbsVolumeResourceVolumeTypeEnum",
    "AwsEbsVolumeResourceStateEnum",
    "AwsFsxResourceFileSystemTypeEnum",
    "AwsFsxResourceStorageTypeEnum",
    "AwsFsxResourceLifecycleStatusEnum",
    "AwsKeyspacesResourceCdcStatusEnum",
    "AwsKeyspacesResourceCdcViewTypeEnum",
    "AwsRdsEngine",
    "AwsRedshiftResourceClusterTypeEnum",
    "AzureAppRegistrationOptionApplicationTypeEnum",
    "AzureMarketplaceWebhookInputActionEnum",
    "AzureMarketplaceWebhookInputStatusEnum",
    "AzureMarketplaceWebhookInputOperationRequestSourceEnum",
    "AzureMarketplaceWebhookInputSubscriptionAllowedCustomerOperationsEnum",
    "AzureMarketplaceWebhookInputSubscriptionSessionModeEnum",
    "AzureMarketplaceWebhookInputSubscriptionSandboxTypeEnum",
    "AzureMarketplaceWebhookInputSubscriptionSaasSubscriptionStatusEnum",
    "AzureMarketplaceWebhookInputSubscriptionTermTermUnitEnum",
    "AzureOnboardingStatusStatusEnum",
    "AzureRestorePointDataRestorePointTypeEnum",
    "AzureVaultType",
    "BackupJobSortField",
    "BackupJobType",
    "BackupPolicyType",
    "BackupStatus",
    "BackupZeroEtlIdentityColumnField",
    "BackupZeroEtlRoutingMode",
    "BatchMode",
    "BillingTransactionHistoryTransactionTypeEnum",
    "CloudAccountType",
    "CloudResourceAttachmentEventType",
    "CompactionStrategy",
    "ConditionOperatorEnum",
    "ConnectorStatus",
    "ConnectorType",
    "CostDataGroupBy",
    "CostGranularity",
    "CostRecordMetadataType",
    "CostUnit",
    "CreateGraphInputChartTypeEnum",
    "CreateOAuthAppRequestTypeEnum",
    "CreateSqlEngineInputWorkerSizeEnum",
    "DBSnapshotType",
    "DashboardGraphChartTypeEnum",
    "DataCatalogType",
    "DataClass",
    "DataTransferOperationType",
    "DayOfWeek",
    "DetectorSummaryDetectorTypeEnum",
    "DetectorSummaryConclusionEnum",
    "DetectorType",
    "DynamoDbBillingMode",
    "EFSRestoreDestinationRestoreTypeEnum",
    "EFSRestoreDestinationPerformanceModeEnum",
    "EFSRestoreDestinationThroughputModeEnum",
    "EfsSnapshotPropertiesPerformanceModeEnum",
    "EfsSnapshotPropertiesThroughputModeEnum",
    "EksClusterStatus",
    "Environment",
    "EonAccountStatus",
    "EonSparkVersion",
    "ErrorCode",
    "ErrorPolicy",
    "FileFormat",
    "FindingCountEntryDetectorTypeEnum",
    "FindingEntryObjectTypeEnum",
    "FsxOntapVolumeVolumeTypeEnum",
    "FsxOntapVolumeSecurityStyleEnum",
    "GcpDiskResourceDiskTypeEnum",
    "GcpDiskResourceStatusEnum",
    "GcpNetworkType",
    "GetAdditionalAzureAppsOnboardingStatus200ResponseStatusEnum",
    "GetAwsPrivateLinkStatusResponseStatusEnum",
    "HighFrequencyBackupScheduleFrequency",
    "HighFrequencyIntervalConfigIntervalMinutesEnum",
    "IcebergRestCatalogAuthType",
    "IndexRestoreMode",
    "IngestionPipelineStatus",
    "IngestionSourceType",
    "IntegType",
    "JobStatus",
    "JobStepName",
    "JobStepStatus",
    "KafkaKeyHandling",
    "KafkaMessageFormat",
    "KafkaSaslMechanism",
    "KafkaSecurityProtocol",
    "KafkaStartingOffset",
    "KubeAccessStatus",
    "KubernetesAccessMode",
    "ListOperators",
    "LogSourceTypeEnum",
    "LogSourceWithPolicyTypeEnum",
    "LogicalOperator",
    "MeteringDimension",
    "MinRetentionRuleFrequencyEnum",
    "NativeStandardBackupPolicyPlanVaultProtectionModeEnum",
    "NativeStandardConfigVaultProtectionModeEnum",
    "NetworkInterfaceConfigModeEnum",
    "NotebookExecutionOutputTypeEnum",
    "NotebookExecutionResultStatusEnum",
    "NotebookSessionStatus",
    "NotificationPolicyTypeEnum",
    "NotificationStatus",
    "NotificationType",
    "OAuthAppTypeEnum",
    "ObjectStoreExclusionRuleStoreTypeEnum",
    "ObjectStoreExclusionRuleMatchTypeEnum",
    "PartialRestoreType",
    "PartitionFormat",
    "PartitionSegmentType",
    "PartitionType",
    "PathType",
    "PermissionCategory",
    "PermissionType",
    "PitrIntervalConfigIntervalMinutesEnum",
    "PrivateLinkCheckResultStatusEnum",
    "PrivateLinkStatus",
    "ProjectConfigurationKeyEnum",
    "Provider",
    "QueryDBRestoreDestinationType",
    "QueryDBStatus",
    "QuotaStatus",
    "RdsPasswordConfigPasswordManagementTypeEnum",
    "ResourceSelectorMode",
    "ResourceSortField",
    "ResourceType",
    "RestoreAccountSortField",
    "RestoreJobSortField",
    "RestoreJobType",
    "RestoreMethod",
    "RestoreMethodAvailabilityReason",
    "RoleInstallationMethod",
    "ScalarOperators",
    "ScanJobType",
    "ScheduleMode",
    "ScheduleType",
    "SchemaEvolutionMode",
    "SchemaRegistryAuthType",
    "SecurityAssignmentStatus",
    "SecurityGroupRuleProtocol",
    "SecurityScanConclusionEnum",
    "SecurityScanDetectorTypeEnum",
    "SecurityScanReviewerTypeEnum",
    "SecurityScanConclusion",
    "SecurityScanExclusionPathType",
    "SecurityScanNotificationDataDetectorTypeEnum",
    "SecurityScanNotificationDataConclusionEnum",
    "SecurityScanResultEvidenceTypeEnum",
    "SecurityScanResultTypeEnum",
    "SegmentType",
    "SendA2AMessageRequestJsonrpcEnum",
    "SendA2AMessageRequestMethodEnum",
    "Severity",
    "SnapshotLocationSnapshotTypeEnum",
    "SnapshotSortField",
    "SnapshotStatus",
    "SortColumnSpecDirectionEnum",
    "SortLogsByFieldEnum",
    "SortOrder",
    "SourceAccountSortField",
    "SparkEngineStatus",
    "SparkJobStatus",
    "SqlEngineStatus",
    "SqlQueryExecutionStatus",
    "StandardBackupScheduleFrequency",
    "StandardIntervalConfigIntervalHoursEnum",
    "StorageGatewayStatus",
    "SubjectNamingStrategy",
    "SubnetConfigModeEnum",
    "TakeNativeSnapshotRequestVaultProtectionModeEnum",
    "UpdateGraphInputChartTypeEnum",
    "UsageUnit",
    "VNetConfigModeEnum",
    "VaultStatus",
    "VpcPeeringStatus",
    "WorkspaceStatus",
    "ZeroEtlIdentityColumnField",
    "ZeroEtlRoutingMode",
]);
let typeMap = {
    "AccessCondition": AccessCondition,
    "AccessConditionalExpression": AccessConditionalExpression,
    "Account": Account,
    "AccountConfigInput": AccountConfigInput,
    "AccountIdCondition": AccountIdCondition,
    "AccountIdFilters": AccountIdFilters,
    "AccountMetricsDestination": AccountMetricsDestination,
    "AccountNameFilters": AccountNameFilters,
    "AccountStatusFilters": AccountStatusFilters,
    "AccountUpdateInput": AccountUpdateInput,
    "AccountVersion": AccountVersion,
    "ActionFilters": ActionFilters,
    "ActivateAtlasOrganizationResponse": ActivateAtlasOrganizationResponse,
    "ActivateGcpFolderResponse": ActivateGcpFolderResponse,
    "ActivateGcpOrganizationResponse": ActivateGcpOrganizationResponse,
    "AddRestoreAtlasPrivateLinkRequest": AddRestoreAtlasPrivateLinkRequest,
    "AgreementWithCredits": AgreementWithCredits,
    "Ami": Ami,
    "AmiBlockDevice": AmiBlockDevice,
    "AnalyzeSqlQueryRequest": AnalyzeSqlQueryRequest,
    "AnnuallyConfig": AnnuallyConfig,
    "AnomalyDataPoint": AnomalyDataPoint,
    "AnomalyGraphData": AnomalyGraphData,
    "ApiCredentials": ApiCredentials,
    "ApiCredentialsProperties": ApiCredentialsProperties,
    "App": App,
    "AppFilters": AppFilters,
    "ApplicationOverride": ApplicationOverride,
    "AppsCondition": AppsCondition,
    "AppsDetails": AppsDetails,
    "AtlasOrganization": AtlasOrganization,
    "AtlasProject": AtlasProject,
    "AtlasProjects": AtlasProjects,
    "AuditLog": AuditLog,
    "AuditLogEntitiesInner": AuditLogEntitiesInner,
    "AuditLogExtendedData": AuditLogExtendedData,
    "AuditLogExtendedDataAuth": AuditLogExtendedDataAuth,
    "AuditLogFilterConditions": AuditLogFilterConditions,
    "AuthResponse": AuthResponse,
    "AwsAccountConfigInput": AwsAccountConfigInput,
    "AwsAccountConnectorProperties": AwsAccountConnectorProperties,
    "AwsAccountConnectorPropertiesInput": AwsAccountConnectorPropertiesInput,
    "AwsAccountMetricsDestination": AwsAccountMetricsDestination,
    "AwsDatabaseDestination": AwsDatabaseDestination,
    "AwsDynamoDBDestination": AwsDynamoDBDestination,
    "AwsDynamoDbResource": AwsDynamoDbResource,
    "AwsDynamoDbSnapshotProperties": AwsDynamoDbSnapshotProperties,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput,
    "AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner": AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner,
    "AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner": AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner,
    "AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection": AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection,
    "AwsEbsSnapshotConvertResult": AwsEbsSnapshotConvertResult,
    "AwsEbsVolumeResource": AwsEbsVolumeResource,
    "AwsEbsVolumeRestoreData": AwsEbsVolumeRestoreData,
    "AwsEbsVolumeRestoreResult": AwsEbsVolumeRestoreResult,
    "AwsEbsVolumeSnapshotProperties": AwsEbsVolumeSnapshotProperties,
    "AwsEc2AmiConvertResult": AwsEc2AmiConvertResult,
    "AwsEc2InstanceRestoreDestination": AwsEc2InstanceRestoreDestination,
    "AwsEc2InstanceRestoreResult": AwsEc2InstanceRestoreResult,
    "AwsEc2InstanceRestoreTarget": AwsEc2InstanceRestoreTarget,
    "AwsEc2Resource": AwsEc2Resource,
    "AwsEc2SnapshotProperties": AwsEc2SnapshotProperties,
    "AwsEksNamespaceResource": AwsEksNamespaceResource,
    "AwsEksNamespaceSnapshotProperties": AwsEksNamespaceSnapshotProperties,
    "AwsFsxResource": AwsFsxResource,
    "AwsKeyspacesDestination": AwsKeyspacesDestination,
    "AwsKeyspacesResource": AwsKeyspacesResource,
    "AwsNativePitrBackupPolicyPlan": AwsNativePitrBackupPolicyPlan,
    "AwsNativePitrBackupResourceType": AwsNativePitrBackupResourceType,
    "AwsNativePitrConfig": AwsNativePitrConfig,
    "AwsNeptuneResource": AwsNeptuneResource,
    "AwsRdsResource": AwsRdsResource,
    "AwsRdsResourceAurora": AwsRdsResourceAurora,
    "AwsRdsResourceStorageSettings": AwsRdsResourceStorageSettings,
    "AwsRedshiftResource": AwsRedshiftResource,
    "AwsRestoreAccountAttributes": AwsRestoreAccountAttributes,
    "AwsRestoreAccountAttributesInput": AwsRestoreAccountAttributesInput,
    "AwsRestoreAccountConnectivityConfig": AwsRestoreAccountConnectivityConfig,
    "AwsRuntimeConfig": AwsRuntimeConfig,
    "AwsSourceAccountAttributes": AwsSourceAccountAttributes,
    "AwsSourceAccountAttributesInput": AwsSourceAccountAttributesInput,
    "AwsVaultConfig": AwsVaultConfig,
    "AwsVaultConfigInput": AwsVaultConfigInput,
    "AwsVpcConnectivityConfig": AwsVpcConnectivityConfig,
    "AzureAccountConfigInput": AzureAccountConfigInput,
    "AzureAksNamespaceResource": AzureAksNamespaceResource,
    "AzureAppRegistrationOption": AzureAppRegistrationOption,
    "AzureBackupApplicationsResponse": AzureBackupApplicationsResponse,
    "AzureCmkEligibleApp": AzureCmkEligibleApp,
    "AzureConsentUrlResponse": AzureConsentUrlResponse,
    "AzureDisk": AzureDisk,
    "AzureDiskRestoreData": AzureDiskRestoreData,
    "AzureDiskRestoreDestination": AzureDiskRestoreDestination,
    "AzureDiskRestoreResult": AzureDiskRestoreResult,
    "AzureDiskSettings": AzureDiskSettings,
    "AzureDiskTarget": AzureDiskTarget,
    "AzureEonApplication": AzureEonApplication,
    "AzureListResourceGroupsResponse": AzureListResourceGroupsResponse,
    "AzureListSubscriptionsResponse": AzureListSubscriptionsResponse,
    "AzureManagementGroup": AzureManagementGroup,
    "AzureManagementGroups": AzureManagementGroups,
    "AzureMarketplaceWebhookInput": AzureMarketplaceWebhookInput,
    "AzureMarketplaceWebhookInputSubscription": AzureMarketplaceWebhookInputSubscription,
    "AzureMarketplaceWebhookInputSubscriptionBeneficiary": AzureMarketplaceWebhookInputSubscriptionBeneficiary,
    "AzureMarketplaceWebhookInputSubscriptionPurchaser": AzureMarketplaceWebhookInputSubscriptionPurchaser,
    "AzureMarketplaceWebhookInputSubscriptionTerm": AzureMarketplaceWebhookInputSubscriptionTerm,
    "AzureMssqlSnapshotProperties": AzureMssqlSnapshotProperties,
    "AzureOnboardedTenantsResponse": AzureOnboardedTenantsResponse,
    "AzureOnboardingStatus": AzureOnboardingStatus,
    "AzurePostgresDatabaseRestoreDestination": AzurePostgresDatabaseRestoreDestination,
    "AzurePostgresDatabaseRestoreTarget": AzurePostgresDatabaseRestoreTarget,
    "AzureResourceGroup": AzureResourceGroup,
    "AzureResourceGroups": AzureResourceGroups,
    "AzureRestoreAccountAttributes": AzureRestoreAccountAttributes,
    "AzureRestoreAccountAttributesInput": AzureRestoreAccountAttributesInput,
    "AzureRestoreAccountConnectivityConfig": AzureRestoreAccountConnectivityConfig,
    "AzureRestorePointData": AzureRestorePointData,
    "AzureRestorePointSpec": AzureRestorePointSpec,
    "AzureSapHanaResource": AzureSapHanaResource,
    "AzureScanningAccountSetupStatus200Response": AzureScanningAccountSetupStatus200Response,
    "AzureSourceAccountAttributes": AzureSourceAccountAttributes,
    "AzureSourceAccountAttributesInput": AzureSourceAccountAttributesInput,
    "AzureSqlDatabaseRestoreDestination": AzureSqlDatabaseRestoreDestination,
    "AzureSqlDatabaseRestoreTarget": AzureSqlDatabaseRestoreTarget,
    "AzureStorageAccount": AzureStorageAccount,
    "AzureStorageAccounts": AzureStorageAccounts,
    "AzureSubscription": AzureSubscription,
    "AzureTenant": AzureTenant,
    "AzureVaultConfig": AzureVaultConfig,
    "AzureVaultConfigInput": AzureVaultConfigInput,
    "AzureVmInstanceRestoreDestination": AzureVmInstanceRestoreDestination,
    "AzureVmInstanceRestoreResult": AzureVmInstanceRestoreResult,
    "AzureVmInstanceRestoreTarget": AzureVmInstanceRestoreTarget,
    "AzureVmSnapshotProperties": AzureVmSnapshotProperties,
    "AzureVnetConnectivityConfig": AzureVnetConnectivityConfig,
    "BackedUpByResourceType": BackedUpByResourceType,
    "BackedUpByResourceTypeDataInner": BackedUpByResourceTypeDataInner,
    "BackedUpStorageDateHistogram": BackedUpStorageDateHistogram,
    "BackupControlViolations": BackupControlViolations,
    "BackupJob": BackupJob,
    "BackupJobResponse": BackupJobResponse,
    "BackupJobTypeFilters": BackupJobTypeFilters,
    "BackupJobsFilterConditions": BackupJobsFilterConditions,
    "BackupPoliciesFilters": BackupPoliciesFilters,
    "BackupPoliciesLimits": BackupPoliciesLimits,
    "BackupPoliciesSecurityConfig": BackupPoliciesSecurityConfig,
    "BackupPolicy": BackupPolicy,
    "BackupPolicyAppliesNotificationArguments": BackupPolicyAppliesNotificationArguments,
    "BackupPolicyConfig": BackupPolicyConfig,
    "BackupPolicyExpression": BackupPolicyExpression,
    "BackupPolicyGroupCondition": BackupPolicyGroupCondition,
    "BackupPolicyNotificationArguments": BackupPolicyNotificationArguments,
    "BackupPolicyPlan": BackupPolicyPlan,
    "BackupPolicyResourceSelector": BackupPolicyResourceSelector,
    "BackupPolicySecurityConfig": BackupPolicySecurityConfig,
    "BackupRegionsFilters": BackupRegionsFilters,
    "BackupSchedule": BackupSchedule,
    "BackupScope": BackupScope,
    "BackupScopeSummary": BackupScopeSummary,
    "BackupStatusFilters": BackupStatusFilters,
    "BackupVault": BackupVault,
    "BackupZeroEtlAccessConfiguration": BackupZeroEtlAccessConfiguration,
    "BackupZeroEtlAwsAccessConfiguration": BackupZeroEtlAwsAccessConfiguration,
    "BackupZeroEtlAwsGlueCatalogConfiguration": BackupZeroEtlAwsGlueCatalogConfiguration,
    "BackupZeroEtlCatalogConfiguration": BackupZeroEtlCatalogConfiguration,
    "BackupZeroEtlIdentityColumnSpec": BackupZeroEtlIdentityColumnSpec,
    "BackupZeroEtlPolicy": BackupZeroEtlPolicy,
    "BackupZeroEtlResourceSelector": BackupZeroEtlResourceSelector,
    "BackupZeroEtlRoutingPolicy": BackupZeroEtlRoutingPolicy,
    "BackupZeroEtlStorageConfiguration": BackupZeroEtlStorageConfiguration,
    "BatchApplicationOverrides": BatchApplicationOverrides,
    "BatchOperationResponse": BatchOperationResponse,
    "BatchResourceValidationResult": BatchResourceValidationResult,
    "BatchUpdateLlgPoliciesRequest": BatchUpdateLlgPoliciesRequest,
    "BatchUpdateLlgPolicyItem": BatchUpdateLlgPolicyItem,
    "BatchValidateResourceConfigurationRequest": BatchValidateResourceConfigurationRequest,
    "BatchValidateResourceConfigurationResponse": BatchValidateResourceConfigurationResponse,
    "BigQueryDatasetDestination": BigQueryDatasetDestination,
    "BigQueryIntegrationConfig": BigQueryIntegrationConfig,
    "BigQueryNativePitrBackupPolicyPlan": BigQueryNativePitrBackupPolicyPlan,
    "BigQueryNativePitrBackupResourceType": BigQueryNativePitrBackupResourceType,
    "BigQueryNativePitrConfig": BigQueryNativePitrConfig,
    "BigQueryNativePitrDestination": BigQueryNativePitrDestination,
    "BiglakeCatalogProperties": BiglakeCatalogProperties,
    "BillingPeriod": BillingPeriod,
    "BillingTransactionHistory": BillingTransactionHistory,
    "BooleanFilters": BooleanFilters,
    "BucketPathPartitionSpec": BucketPathPartitionSpec,
    "CancelExclusionFromBackupResponse": CancelExclusionFromBackupResponse,
    "CatalogAccessRequest": CatalogAccessRequest,
    "CatalogAccessResponse": CatalogAccessResponse,
    "CdcBackupModeCheckResult": CdcBackupModeCheckResult,
    "CheckAzureVMNameExists200Response": CheckAzureVMNameExists200Response,
    "CheckAzureVMNameExistsRequest": CheckAzureVMNameExistsRequest,
    "CheckCdcPrerequisitesResponse": CheckCdcPrerequisitesResponse,
    "Classifications": Classifications,
    "CloudAccountIdFilters": CloudAccountIdFilters,
    "CloudAccountNotificationArguments": CloudAccountNotificationArguments,
    "CloudProviderCondition": CloudProviderCondition,
    "CloudProviderFilters": CloudProviderFilters,
    "CloudRegion": CloudRegion,
    "CloudResourceAttachmentEvent": CloudResourceAttachmentEvent,
    "CloudResourceConfiguration": CloudResourceConfiguration,
    "CloudResourceConfigurationCdcBackup": CloudResourceConfigurationCdcBackup,
    "CloudResourceConfigurationInventoryBackup": CloudResourceConfigurationInventoryBackup,
    "CloudResourceSecurityProperties": CloudResourceSecurityProperties,
    "CloudSnapshotsPerVolume": CloudSnapshotsPerVolume,
    "ClusterNameFilters": ClusterNameFilters,
    "ColumnMetadata": ColumnMetadata,
    "CompanyContact": CompanyContact,
    "Condition": Condition,
    "ConnectAtlasOrganizationRequest": ConnectAtlasOrganizationRequest,
    "ConnectAtlasOrganizationResponse": ConnectAtlasOrganizationResponse,
    "ConnectAzureBackupAccountRequest": ConnectAzureBackupAccountRequest,
    "ConnectAzureBackupApplicationsRequest": ConnectAzureBackupApplicationsRequest,
    "ConnectAzureRestoreAccountRequest": ConnectAzureRestoreAccountRequest,
    "ConnectAzureSourceAccountRequest": ConnectAzureSourceAccountRequest,
    "ConnectAzureVaultAccountRequest": ConnectAzureVaultAccountRequest,
    "ConnectBYOApps200Response": ConnectBYOApps200Response,
    "ConnectBYOAppsRequest": ConnectBYOAppsRequest,
    "ConnectBYOAzureBackupApplicationsRequest": ConnectBYOAzureBackupApplicationsRequest,
    "ConnectCustomerVaultAccountRequest": ConnectCustomerVaultAccountRequest,
    "ConnectCustomerVaultAccountResponse": ConnectCustomerVaultAccountResponse,
    "ConnectGcpFolderRequest": ConnectGcpFolderRequest,
    "ConnectGcpFolderResponse": ConnectGcpFolderResponse,
    "ConnectGcpOrganizationRequest": ConnectGcpOrganizationRequest,
    "ConnectGcpOrganizationResponse": ConnectGcpOrganizationResponse,
    "ConnectRestoreAccountRequest": ConnectRestoreAccountRequest,
    "ConnectRestoreAccountResponse": ConnectRestoreAccountResponse,
    "ConnectSourceAccountRequest": ConnectSourceAccountRequest,
    "ConnectSourceAccountResponse": ConnectSourceAccountResponse,
    "ConnectSourceAwsOrganizationalUnitRequest": ConnectSourceAwsOrganizationalUnitRequest,
    "ConnectSourceAwsOrganizationalUnitResponse": ConnectSourceAwsOrganizationalUnitResponse,
    "Connector": Connector,
    "Control": Control,
    "ControlPlaneConfig": ControlPlaneConfig,
    "ControlRules": ControlRules,
    "ControlViolation": ControlViolation,
    "ControlViolations": ControlViolations,
    "ControlViolationsPerSeverity": ControlViolationsPerSeverity,
    "ControlViolationsPerSeverityViolatedControlsInner": ControlViolationsPerSeverityViolatedControlsInner,
    "ControlsFilters": ControlsFilters,
    "ConvertEbsSnapshotConfig": ConvertEbsSnapshotConfig,
    "ConvertEc2ImageConfig": ConvertEc2ImageConfig,
    "ConvertOtherSnapshotsOnDemandRequest": ConvertOtherSnapshotsOnDemandRequest,
    "ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner": ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner,
    "ConvertResourceSnapshotsRequest": ConvertResourceSnapshotsRequest,
    "ConvertResourceSnapshotsResponse": ConvertResourceSnapshotsResponse,
    "Cost": Cost,
    "CostDataFilters": CostDataFilters,
    "CostDataRecord": CostDataRecord,
    "CostDataRecordCost": CostDataRecordCost,
    "CostDataRecordDimensions": CostDataRecordDimensions,
    "CostRecordMetadata": CostRecordMetadata,
    "CostRecordMetadataDataTransfer": CostRecordMetadataDataTransfer,
    "CreateAccountInput": CreateAccountInput,
    "CreateApiCredentialsRequest": CreateApiCredentialsRequest,
    "CreateApiCredentialsResponse": CreateApiCredentialsResponse,
    "CreateBackupPolicyRequest": CreateBackupPolicyRequest,
    "CreateBackupPolicyResponse": CreateBackupPolicyResponse,
    "CreateBackupZeroEtlPolicyInput": CreateBackupZeroEtlPolicyInput,
    "CreateConnectorInput": CreateConnectorInput,
    "CreateDashboardInput": CreateDashboardInput,
    "CreateDataCatalogInput": CreateDataCatalogInput,
    "CreateDlsgPolicyRequest": CreateDlsgPolicyRequest,
    "CreateDlsgPolicyResponse": CreateDlsgPolicyResponse,
    "CreateFabricTableShortcutDemoRequest": CreateFabricTableShortcutDemoRequest,
    "CreateFabricTableShortcutDemoRequestShortcutsInner": CreateFabricTableShortcutDemoRequestShortcutsInner,
    "CreateFabricTableShortcutDemoResponse": CreateFabricTableShortcutDemoResponse,
    "CreateFabricTableShortcutDemoResponseResultsInner": CreateFabricTableShortcutDemoResponseResultsInner,
    "CreateGraphInput": CreateGraphInput,
    "CreateIdpGroupRequest": CreateIdpGroupRequest,
    "CreateIdpGroupResponse": CreateIdpGroupResponse,
    "CreateInfectedExcludePathInput": CreateInfectedExcludePathInput,
    "CreateIngestionPipelineInput": CreateIngestionPipelineInput,
    "CreateIntegrationRequest": CreateIntegrationRequest,
    "CreateIntegrationResponse": CreateIntegrationResponse,
    "CreateJobTemplateInput": CreateJobTemplateInput,
    "CreateNotebookInput": CreateNotebookInput,
    "CreateOAuthAppRequest": CreateOAuthAppRequest,
    "CreateOAuthAppResponse": CreateOAuthAppResponse,
    "CreatePolicyInput": CreatePolicyInput,
    "CreatePolicyScheduleInput": CreatePolicyScheduleInput,
    "CreatePrivateLinkInput": CreatePrivateLinkInput,
    "CreateProjectInput": CreateProjectInput,
    "CreatePulumiConfigurationRequest": CreatePulumiConfigurationRequest,
    "CreateRoleRequest": CreateRoleRequest,
    "CreateRoleResponse": CreateRoleResponse,
    "CreateSamlIdentityProviderConfigInput": CreateSamlIdentityProviderConfigInput,
    "CreateSavedQueryInput": CreateSavedQueryInput,
    "CreateScanJobInput": CreateScanJobInput,
    "CreateScanJobResponse": CreateScanJobResponse,
    "CreateSessionRequest": CreateSessionRequest,
    "CreateSparkEngineInput": CreateSparkEngineInput,
    "CreateSqlEngineInput": CreateSqlEngineInput,
    "CreateUserInput": CreateUserInput,
    "CreateVaultRequest": CreateVaultRequest,
    "CreateVaultResponse": CreateVaultResponse,
    "CreateVpcPeeringInput": CreateVpcPeeringInput,
    "CreateZeroEtlPolicyInput": CreateZeroEtlPolicyInput,
    "CredentialFinding": CredentialFinding,
    "CreditsMonthlyUsageNotificationArguments": CreditsMonthlyUsageNotificationArguments,
    "CreditsNotificationArguments": CreditsNotificationArguments,
    "CrossResourceQueryRequest": CrossResourceQueryRequest,
    "CrossResourceQueryRequestResourcesInner": CrossResourceQueryRequestResourcesInner,
    "CustomTagsInner": CustomTagsInner,
    "CustomerVaultAccount": CustomerVaultAccount,
    "DBResourceMetadata": DBResourceMetadata,
    "DBServerRecord": DBServerRecord,
    "DBSnapshotMetadata": DBSnapshotMetadata,
    "DailyConfig": DailyConfig,
    "DailySnapshotData": DailySnapshotData,
    "DailyStorageSummaries": DailyStorageSummaries,
    "DailyStorageSummary": DailyStorageSummary,
    "Dashboard": Dashboard,
    "DashboardGraph": DashboardGraph,
    "DashboardGraphLayout": DashboardGraphLayout,
    "DashboardWithGraphs": DashboardWithGraphs,
    "DataCatalog": DataCatalog,
    "DataClassesCondition": DataClassesCondition,
    "DataClassesDetails": DataClassesDetails,
    "DataClassesFilters": DataClassesFilters,
    "DataClassificationEntity": DataClassificationEntity,
    "DataShareIntegrationConfig": DataShareIntegrationConfig,
    "DatabaseDestination": DatabaseDestination,
    "DatabaseRecord": DatabaseRecord,
    "DatabricksIntegrationConfig": DatabricksIntegrationConfig,
    "DeactivateAccountRequest": DeactivateAccountRequest,
    "DeactivateAccountResponse": DeactivateAccountResponse,
    "DeactivateAtlasOrganizationResponse": DeactivateAtlasOrganizationResponse,
    "DeactivateGcpFolderResponse": DeactivateGcpFolderResponse,
    "DeactivateGcpOrganizationResponse": DeactivateGcpOrganizationResponse,
    "DeleteRestoreAccountV1Request": DeleteRestoreAccountV1Request,
    "DestinationDetails": DestinationDetails,
    "DestinationProviderAttributes": DestinationProviderAttributes,
    "DestinationProviderAttributesAzure": DestinationProviderAttributesAzure,
    "DestinationRestoreTypeAttributes": DestinationRestoreTypeAttributes,
    "DetectorSummary": DetectorSummary,
    "DisableResourceOverrideLimitsResponse": DisableResourceOverrideLimitsResponse,
    "DisconnectCustomerVaultAccountResponse": DisconnectCustomerVaultAccountResponse,
    "DisconnectRestoreAccountResponse": DisconnectRestoreAccountResponse,
    "DisconnectSourceAccountResponse": DisconnectSourceAccountResponse,
    "DisconnectSourceAwsOrganizationalUnitResponse": DisconnectSourceAwsOrganizationalUnitResponse,
    "DiscoveryInvokeParams": DiscoveryInvokeParams,
    "DiscoveryJob": DiscoveryJob,
    "DiscoveryStatusResponse": DiscoveryStatusResponse,
    "DlsgPolicy": DlsgPolicy,
    "DlsgPolicyConfig": DlsgPolicyConfig,
    "DlsgPolicyFilters": DlsgPolicyFilters,
    "DlsgPolicyPlan": DlsgPolicyPlan,
    "DlsgSettings": DlsgSettings,
    "DocumentDBRestoreDestination": DocumentDBRestoreDestination,
    "DocumentDbClusterParameterGroup": DocumentDbClusterParameterGroup,
    "DocumentDbClusterParameterGroups": DocumentDbClusterParameterGroups,
    "DocumentDbSnapshotProperties": DocumentDbSnapshotProperties,
    "DriftProtectionPolicy": DriftProtectionPolicy,
    "DriftProtectionSummary": DriftProtectionSummary,
    "DriftProtectionTimePoint": DriftProtectionTimePoint,
    "DynamoDBAdvancedIndexConfig": DynamoDBAdvancedIndexConfig,
    "DynamoDBRestoreMethodAvailabilityRequest": DynamoDBRestoreMethodAvailabilityRequest,
    "DynamoDBRestoreMethodAvailabilityResponse": DynamoDBRestoreMethodAvailabilityResponse,
    "DynamoDbBackupConfig": DynamoDbBackupConfig,
    "DynamoDbBackupConfigApplication": DynamoDbBackupConfigApplication,
    "DynamodbTableRestoreDestination": DynamodbTableRestoreDestination,
    "EFSRestoreDestination": EFSRestoreDestination,
    "EbsRestoreDestination": EbsRestoreDestination,
    "EbsSnapshotRestoreDestination": EbsSnapshotRestoreDestination,
    "EbsSnapshotTarget": EbsSnapshotTarget,
    "EbsTarget": EbsTarget,
    "EfsSnapshotProperties": EfsSnapshotProperties,
    "EksCluster": EksCluster,
    "EksNamespaceRestoreDestination": EksNamespaceRestoreDestination,
    "EksNamespaceRestoreResult": EksNamespaceRestoreResult,
    "EksVolumeRestoreResult": EksVolumeRestoreResult,
    "EmrIntegrationConfig": EmrIntegrationConfig,
    "EnableFromLimitExceededResponse": EnableFromLimitExceededResponse,
    "EnableResourceOverrideLimitsResponse": EnableResourceOverrideLimitsResponse,
    "EnableRestoreAccountMetricsConfigRequest": EnableRestoreAccountMetricsConfigRequest,
    "EnableRestoreAccountMetricsConfigResponse": EnableRestoreAccountMetricsConfigResponse,
    "EnableSourceAccountMetricsConfigRequest": EnableSourceAccountMetricsConfigRequest,
    "EnableSourceAccountMetricsConfigResponse": EnableSourceAccountMetricsConfigResponse,
    "EncryptionKey": EncryptionKey,
    "EncryptionKeys": EncryptionKeys,
    "EndTimeDateFilters": EndTimeDateFilters,
    "EnvironmentCondition": EnvironmentCondition,
    "EnvironmentDetails": EnvironmentDetails,
    "EnvironmentFilters": EnvironmentFilters,
    "EonAccount": EonAccount,
    "EonAccountIdFilters": EonAccountIdFilters,
    "ExcludeFromBackupResponse": ExcludeFromBackupResponse,
    "ExecuteNotebookCodeInput": ExecuteNotebookCodeInput,
    "ExportCostData400Response": ExportCostData400Response,
    "ExportCostDataRequest": ExportCostDataRequest,
    "FSxRestoreDestination": FSxRestoreDestination,
    "FSxRestoreDestinationOntapRestoreOptions": FSxRestoreDestinationOntapRestoreOptions,
    "FeatureFlagOverrideGet200Response": FeatureFlagOverrideGet200Response,
    "FileExplorerCountSecurityAlertsInResourceResponse": FileExplorerCountSecurityAlertsInResourceResponse,
    "FileExplorerResponse": FileExplorerResponse,
    "FilePath": FilePath,
    "FileRestoreData": FileRestoreData,
    "FileSearchRecord": FileSearchRecord,
    "FileSnapshot": FileSnapshot,
    "FindingCountEntry": FindingCountEntry,
    "FindingEntry": FindingEntry,
    "ForceDeleteSnapshotsRequest": ForceDeleteSnapshotsRequest,
    "FreeTextFilters": FreeTextFilters,
    "FsxOntapVolume": FsxOntapVolume,
    "FsxSnapshotProperties": FsxSnapshotProperties,
    "FsxVolumeBackupInfo": FsxVolumeBackupInfo,
    "GCSBucket": GCSBucket,
    "GCSBuckets": GCSBuckets,
    "GCSRestoreDestination": GCSRestoreDestination,
    "GCSRestoreTarget": GCSRestoreTarget,
    "GcpAccountConfigInput": GcpAccountConfigInput,
    "GcpBigQueryResource": GcpBigQueryResource,
    "GcpBigQueryResourceMaterializedViewsInner": GcpBigQueryResourceMaterializedViewsInner,
    "GcpBigQueryResourceRoutinesInner": GcpBigQueryResourceRoutinesInner,
    "GcpBigQueryResourceTablesInner": GcpBigQueryResourceTablesInner,
    "GcpBigQueryResourceViewsInner": GcpBigQueryResourceViewsInner,
    "GcpCloudSqlResource": GcpCloudSqlResource,
    "GcpCloudSqlResourceStorageSettings": GcpCloudSqlResourceStorageSettings,
    "GcpCloudSqlRestoreDestination": GcpCloudSqlRestoreDestination,
    "GcpCloudSqlSnapshotProperties": GcpCloudSqlSnapshotProperties,
    "GcpCloudSqlTarget": GcpCloudSqlTarget,
    "GcpDiskResource": GcpDiskResource,
    "GcpDiskRestoreData": GcpDiskRestoreData,
    "GcpDiskRestoreDestination": GcpDiskRestoreDestination,
    "GcpDiskSettings": GcpDiskSettings,
    "GcpDiskSnapshotProperties": GcpDiskSnapshotProperties,
    "GcpDiskTarget": GcpDiskTarget,
    "GcpDiskTypesResponse": GcpDiskTypesResponse,
    "GcpEncryptionKey": GcpEncryptionKey,
    "GcpEncryptionKeys": GcpEncryptionKeys,
    "GcpGkeNamespaceResource": GcpGkeNamespaceResource,
    "GcpMachineTypesResponse": GcpMachineTypesResponse,
    "GcpNetworkConnectivityConfig": GcpNetworkConnectivityConfig,
    "GcpOrganization": GcpOrganization,
    "GcpProjectConnectorProperties": GcpProjectConnectorProperties,
    "GcpProjectConnectorPropertiesInput": GcpProjectConnectorPropertiesInput,
    "GcpRestoreAccountAttributes": GcpRestoreAccountAttributes,
    "GcpRestoreAccountAttributesInput": GcpRestoreAccountAttributesInput,
    "GcpRestoreAccountConnectivityConfig": GcpRestoreAccountConnectivityConfig,
    "GcpSapHanaResource": GcpSapHanaResource,
    "GcpSourceAccountAttributes": GcpSourceAccountAttributes,
    "GcpSourceAccountAttributesInput": GcpSourceAccountAttributesInput,
    "GcpSubnet": GcpSubnet,
    "GcpSubnetPerRegion": GcpSubnetPerRegion,
    "GcpVaultConfig": GcpVaultConfig,
    "GcpVaultConfigInput": GcpVaultConfigInput,
    "GcpVmInstanceRestoreDestination": GcpVmInstanceRestoreDestination,
    "GcpVmInstanceRestoreResult": GcpVmInstanceRestoreResult,
    "GcpVmInstanceRestoreTarget": GcpVmInstanceRestoreTarget,
    "GcpVmResource": GcpVmResource,
    "GcpVmSnapshotProperties": GcpVmSnapshotProperties,
    "GcsSourceProperties": GcsSourceProperties,
    "GenericSnapshotData": GenericSnapshotData,
    "GetAWSStackDetailsResponse": GetAWSStackDetailsResponse,
    "GetAdditionalAzureAppsOnboardingStatus200Response": GetAdditionalAzureAppsOnboardingStatus200Response,
    "GetAgreementsResponse": GetAgreementsResponse,
    "GetAwsPrivateLinkStatusResponse": GetAwsPrivateLinkStatusResponse,
    "GetBackupJobResponse": GetBackupJobResponse,
    "GetBackupPolicyResponse": GetBackupPolicyResponse,
    "GetBillingPeriodsResponse": GetBillingPeriodsResponse,
    "GetCloudResourceSecurityPropertiesResponse": GetCloudResourceSecurityPropertiesResponse,
    "GetCredits400Response": GetCredits400Response,
    "GetCreditsResponse": GetCreditsResponse,
    "GetDlsgPolicyResponse": GetDlsgPolicyResponse,
    "GetGcsServiceAgentResponse": GetGcsServiceAgentResponse,
    "GetIdpGroupResponse": GetIdpGroupResponse,
    "GetIntegrationResponse": GetIntegrationResponse,
    "GetLimitsResponseValue": GetLimitsResponseValue,
    "GetNotebookContent200Response": GetNotebookContent200Response,
    "GetProjectConfigurationKeyResponse": GetProjectConfigurationKeyResponse,
    "GetProjectConfigurationKeysResponse": GetProjectConfigurationKeysResponse,
    "GetResourceResponse": GetResourceResponse,
    "GetRestoreAccountConnectivityConfigResponse": GetRestoreAccountConnectivityConfigResponse,
    "GetRestoreAccountMetricsConfigResponse": GetRestoreAccountMetricsConfigResponse,
    "GetRestoreJobResponse": GetRestoreJobResponse,
    "GetRoleResponse": GetRoleResponse,
    "GetScanJobResponse": GetScanJobResponse,
    "GetSnapshotResponse": GetSnapshotResponse,
    "GetSourceAccountMetricsConfigResponse": GetSourceAccountMetricsConfigResponse,
    "GetSqlVmNetworkInfoRequest": GetSqlVmNetworkInfoRequest,
    "GetSqlVmNetworkInfoResponse": GetSqlVmNetworkInfoResponse,
    "GetVaultResponse": GetVaultResponse,
    "GlobalClusterIdentifierCondition": GlobalClusterIdentifierCondition,
    "GlueCatalogProperties": GlueCatalogProperties,
    "HighFrequencyBackupPolicyPlan": HighFrequencyBackupPolicyPlan,
    "HighFrequencyBackupResourceType": HighFrequencyBackupResourceType,
    "HighFrequencyBackupScheduleConfig": HighFrequencyBackupScheduleConfig,
    "HighFrequencyBackupSchedules": HighFrequencyBackupSchedules,
    "HighFrequencyIntervalConfig": HighFrequencyIntervalConfig,
    "IDs": IDs,
    "IcebergRestCatalogProperties": IcebergRestCatalogProperties,
    "IdFilters": IdFilters,
    "Identifier": Identifier,
    "IdentityProvidersNames": IdentityProvidersNames,
    "Idp": Idp,
    "IdpGroup": IdpGroup,
    "ImportDlsgCertificateRequest": ImportDlsgCertificateRequest,
    "InfectedDataByClassification": InfectedDataByClassification,
    "InfectedDataClassificationSize": InfectedDataClassificationSize,
    "InfectedDataOverTime": InfectedDataOverTime,
    "InfectedDateSize": InfectedDateSize,
    "InfectedExcludePath": InfectedExcludePath,
    "InfectedResourcesCountResponse": InfectedResourcesCountResponse,
    "IngestionPipeline": IngestionPipeline,
    "InitAuthInput": InitAuthInput,
    "Initiator": Initiator,
    "InitiatorNameFilters": InitiatorNameFilters,
    "IntegConfig": IntegConfig,
    "IntegrationConfig": IntegrationConfig,
    "InventoryFilterConditions": InventoryFilterConditions,
    "InventoryGcpDisk": InventoryGcpDisk,
    "InventoryResource": InventoryResource,
    "InventoryResourceMetadata": InventoryResourceMetadata,
    "InventorySnapshotVolume": InventorySnapshotVolume,
    "InventoryVault": InventoryVault,
    "InventoryVolume": InventoryVolume,
    "IsVaultDeletableResponse": IsVaultDeletableResponse,
    "IssueMutedNotificationArguments": IssueMutedNotificationArguments,
    "JobExecutionDetails": JobExecutionDetails,
    "JobFailedNotificationArguments": JobFailedNotificationArguments,
    "JobIdFilters": JobIdFilters,
    "JobInitiationResponse": JobInitiationResponse,
    "JobMetricsReportFailedArguments": JobMetricsReportFailedArguments,
    "JobSnapshotDetails": JobSnapshotDetails,
    "JobStatusFilters": JobStatusFilters,
    "JobStep": JobStep,
    "JobSucceededNotificationArguments": JobSucceededNotificationArguments,
    "JobTemplate": JobTemplate,
    "KafkaBatchConfig": KafkaBatchConfig,
    "KafkaErrorHandlingConfig": KafkaErrorHandlingConfig,
    "KafkaPartitioningConfig": KafkaPartitioningConfig,
    "KafkaSecurityConfig": KafkaSecurityConfig,
    "KafkaSourceConfig": KafkaSourceConfig,
    "KafkaSourceProperties": KafkaSourceProperties,
    "KeyspacesBackupConfig": KeyspacesBackupConfig,
    "KeyspacesBackupConfigApplication": KeyspacesBackupConfigApplication,
    "KeyspacesTableRestoreDestination": KeyspacesTableRestoreDestination,
    "LimitData": LimitData,
    "ListAccountsResponse": ListAccountsResponse,
    "ListAllRegionsResponse": ListAllRegionsResponse,
    "ListAllRegionsResponseRegions": ListAllRegionsResponseRegions,
    "ListApiCredentialsResponse": ListApiCredentialsResponse,
    "ListApplicationOverrideResponse": ListApplicationOverrideResponse,
    "ListAtlasOrganizationsResponse": ListAtlasOrganizationsResponse,
    "ListAuditLogRequest": ListAuditLogRequest,
    "ListAuditLogResponse": ListAuditLogResponse,
    "ListAuditLogsResponse": ListAuditLogsResponse,
    "ListAwsVpcsResponse": ListAwsVpcsResponse,
    "ListAwsVpcsResponseVpcsInner": ListAwsVpcsResponseVpcsInner,
    "ListAzureAppRegistrationsResponse": ListAzureAppRegistrationsResponse,
    "ListAzureCmkEligibleAppsResponse": ListAzureCmkEligibleAppsResponse,
    "ListAzureRegions200Response": ListAzureRegions200Response,
    "ListAzureSKUs200Response": ListAzureSKUs200Response,
    "ListAzureSKUs200ResponseSkusInner": ListAzureSKUs200ResponseSkusInner,
    "ListAzureSKUsRequest": ListAzureSKUsRequest,
    "ListAzureStorageAccountContainers200Response": ListAzureStorageAccountContainers200Response,
    "ListAzureStorageAccountContainersRequest": ListAzureStorageAccountContainersRequest,
    "ListAzureSubnets200Response": ListAzureSubnets200Response,
    "ListAzureSubnets200ResponseSubnetsInner": ListAzureSubnets200ResponseSubnetsInner,
    "ListAzureSubnetsRequest": ListAzureSubnetsRequest,
    "ListAzureUnassignedNetworkInterfaces200Response": ListAzureUnassignedNetworkInterfaces200Response,
    "ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner": ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner,
    "ListAzureUnassignedNetworkInterfacesRequest": ListAzureUnassignedNetworkInterfacesRequest,
    "ListAzureVirtualNetworks200Response": ListAzureVirtualNetworks200Response,
    "ListAzureVirtualNetworks200ResponseVirtualNetworksInner": ListAzureVirtualNetworks200ResponseVirtualNetworksInner,
    "ListAzureVirtualNetworksRequest": ListAzureVirtualNetworksRequest,
    "ListBackupJobTypesResponse": ListBackupJobTypesResponse,
    "ListBackupJobsInternal200Response": ListBackupJobsInternal200Response,
    "ListBackupJobsRequest": ListBackupJobsRequest,
    "ListBackupJobsResponse": ListBackupJobsResponse,
    "ListBackupPoliciesResponse": ListBackupPoliciesResponse,
    "ListBackupPolicyResponse": ListBackupPolicyResponse,
    "ListBackupVaultResponse": ListBackupVaultResponse,
    "ListBackupZeroEtlPoliciesResponse": ListBackupZeroEtlPoliciesResponse,
    "ListBillingTransactionHistoryRequest": ListBillingTransactionHistoryRequest,
    "ListBillingTransactionHistoryResponse": ListBillingTransactionHistoryResponse,
    "ListCloudSnapshotsResponse": ListCloudSnapshotsResponse,
    "ListConnectorsResponse": ListConnectorsResponse,
    "ListControlViolationsResponse": ListControlViolationsResponse,
    "ListControlsResponse": ListControlsResponse,
    "ListCredentialFindingsResponse": ListCredentialFindingsResponse,
    "ListDailySnapshotsResponse": ListDailySnapshotsResponse,
    "ListDashboardsResponse": ListDashboardsResponse,
    "ListDataCatalogsResponse": ListDataCatalogsResponse,
    "ListDataClassificationEntitiesResponse": ListDataClassificationEntitiesResponse,
    "ListDatabaseSnapshotsResponse": ListDatabaseSnapshotsResponse,
    "ListDlsgPoliciesResponse": ListDlsgPoliciesResponse,
    "ListDynamoDbBackupConfigsResponse": ListDynamoDbBackupConfigsResponse,
    "ListEksClustersResponse": ListEksClustersResponse,
    "ListFindingsResponse": ListFindingsResponse,
    "ListGcpFoldersResponse": ListGcpFoldersResponse,
    "ListGcpNetworksResponse": ListGcpNetworksResponse,
    "ListGcpNetworksResponseNetworksInner": ListGcpNetworksResponseNetworksInner,
    "ListGcpOrganizationsResponse": ListGcpOrganizationsResponse,
    "ListGcpSubnetsResponse": ListGcpSubnetsResponse,
    "ListIdpGroupsResponse": ListIdpGroupsResponse,
    "ListIdpsResponse": ListIdpsResponse,
    "ListInfectedExcludePathsResponse": ListInfectedExcludePathsResponse,
    "ListIngestionPipelinesResponse": ListIngestionPipelinesResponse,
    "ListInstanceProfilesResponse": ListInstanceProfilesResponse,
    "ListInstanceTypesResponse": ListInstanceTypesResponse,
    "ListIntegrationsResponse": ListIntegrationsResponse,
    "ListInventoryAppsResponse": ListInventoryAppsResponse,
    "ListInventoryBackupRegionsResponse": ListInventoryBackupRegionsResponse,
    "ListInventoryEnvironmentsResponse": ListInventoryEnvironmentsResponse,
    "ListInventoryGlobalDatabasesResponse": ListInventoryGlobalDatabasesResponse,
    "ListInventoryItemSnapshotsResponse": ListInventoryItemSnapshotsResponse,
    "ListInventoryNetworksResponse": ListInventoryNetworksResponse,
    "ListInventoryRequest": ListInventoryRequest,
    "ListInventoryResourceGroupsResponse": ListInventoryResourceGroupsResponse,
    "ListInventoryResourceIdentifiersResponse": ListInventoryResourceIdentifiersResponse,
    "ListInventoryResourceTypesResponse": ListInventoryResourceTypesResponse,
    "ListInventoryResourcesResponse": ListInventoryResourcesResponse,
    "ListInventorySensitivityAnnotationValuesResponse": ListInventorySensitivityAnnotationValuesResponse,
    "ListInventorySnapshotsRequest": ListInventorySnapshotsRequest,
    "ListInventorySnapshotsResponse": ListInventorySnapshotsResponse,
    "ListInventorySourceRegionsResponse": ListInventorySourceRegionsResponse,
    "ListInventorySubnetsResponse": ListInventorySubnetsResponse,
    "ListInventoryTagsResponse": ListInventoryTagsResponse,
    "ListJobErrorCodesResponse": ListJobErrorCodesResponse,
    "ListJobTemplatesResponse": ListJobTemplatesResponse,
    "ListKeyspacesBackupConfigsResponse": ListKeyspacesBackupConfigsResponse,
    "ListKnownAppsResponse": ListKnownAppsResponse,
    "ListLogSourcesPoliciesResponse": ListLogSourcesPoliciesResponse,
    "ListLogSourcesResponse": ListLogSourcesResponse,
    "ListMongoAtlasPrivateLinks200Response": ListMongoAtlasPrivateLinks200Response,
    "ListNotebooksResponse": ListNotebooksResponse,
    "ListNotificationPoliciesResponse": ListNotificationPoliciesResponse,
    "ListNotificationsResponse": ListNotificationsResponse,
    "ListOAuthAppsResponse": ListOAuthAppsResponse,
    "ListObjectStoreExclusionRulesResponse": ListObjectStoreExclusionRulesResponse,
    "ListPermissionsResponse": ListPermissionsResponse,
    "ListProjectsResponse": ListProjectsResponse,
    "ListResourceAttachmentEventsResponse": ListResourceAttachmentEventsResponse,
    "ListResourcesResponse": ListResourcesResponse,
    "ListRestoreAccountsRequest": ListRestoreAccountsRequest,
    "ListRestoreAccountsResponse": ListRestoreAccountsResponse,
    "ListRestoreJobTypesResponse": ListRestoreJobTypesResponse,
    "ListRestoreJobsInternal200Response": ListRestoreJobsInternal200Response,
    "ListRestoreJobsRequest": ListRestoreJobsRequest,
    "ListRestoreJobsResponse": ListRestoreJobsResponse,
    "ListRolesResponse": ListRolesResponse,
    "ListSavedQueriesResponse": ListSavedQueriesResponse,
    "ListScanJobTypesResponse": ListScanJobTypesResponse,
    "ListScanJobsInternal200Response": ListScanJobsInternal200Response,
    "ListScanJobsRequest": ListScanJobsRequest,
    "ListScanJobsResponse": ListScanJobsResponse,
    "ListSensitivityAnnotationsResponse": ListSensitivityAnnotationsResponse,
    "ListSourceAccountsRequest": ListSourceAccountsRequest,
    "ListSourceAccountsResponse": ListSourceAccountsResponse,
    "ListSourceAwsOrganizationalUnitsResponse": ListSourceAwsOrganizationalUnitsResponse,
    "ListSparkEnginesResponse": ListSparkEnginesResponse,
    "ListSparkJobsResponse": ListSparkJobsResponse,
    "ListSqlEnginesResponse": ListSqlEnginesResponse,
    "ListSqlQueryExecutionsResponse": ListSqlQueryExecutionsResponse,
    "ListStorageGatewaysResponse": ListStorageGatewaysResponse,
    "ListSubnetsResponse": ListSubnetsResponse,
    "ListSubnetsResponseV2": ListSubnetsResponseV2,
    "ListSubnetsResponseV2SubnetsInner": ListSubnetsResponseV2SubnetsInner,
    "ListUsersResponse": ListUsersResponse,
    "ListZeroEtlPoliciesResponse": ListZeroEtlPoliciesResponse,
    "LlgLocationResource": LlgLocationResource,
    "LlgLocationWithResources": LlgLocationWithResources,
    "LlgResourcePolicy": LlgResourcePolicy,
    "LogRecord": LogRecord,
    "LogSource": LogSource,
    "LogSourceLocation": LogSourceLocation,
    "LogSourceLocationCloudTrail": LogSourceLocationCloudTrail,
    "LogSourceLocationCloudWatchLogs": LogSourceLocationCloudWatchLogs,
    "LogSourceLocationDatadog": LogSourceLocationDatadog,
    "LogSourceLocationGcpCloudLogging": LogSourceLocationGcpCloudLogging,
    "LogSourceLocationSplunkDdss": LogSourceLocationSplunkDdss,
    "LogSourceWithPolicy": LogSourceWithPolicy,
    "LogsHistogramDataPoint": LogsHistogramDataPoint,
    "LogsSchema": LogsSchema,
    "LogsSchemaColumn": LogsSchemaColumn,
    "LogsSchemaEntry": LogsSchemaEntry,
    "LogsSchemasResponse": LogsSchemasResponse,
    "LuceneQueryInput": LuceneQueryInput,
    "MaxRetentionRule": MaxRetentionRule,
    "Message": Message,
    "MicrosoftFabricIntegrationConfig": MicrosoftFabricIntegrationConfig,
    "MinRetentionRule": MinRetentionRule,
    "ModelError": ModelError,
    "MongoAtlasPrivateLinkEntry": MongoAtlasPrivateLinkEntry,
    "MongoAtlasRestoreAccountAttributes": MongoAtlasRestoreAccountAttributes,
    "MongoAtlasRestoreAccountAttributesInput": MongoAtlasRestoreAccountAttributesInput,
    "MongoAtlasSourceAccountAttributes": MongoAtlasSourceAccountAttributes,
    "MongoAtlasSourceAccountAttributesInput": MongoAtlasSourceAccountAttributesInput,
    "MonthlyConfig": MonthlyConfig,
    "MonthlySnapshotData": MonthlySnapshotData,
    "MsaAcceptanceResponse": MsaAcceptanceResponse,
    "NativeStandardBackupPolicyPlan": NativeStandardBackupPolicyPlan,
    "NativeStandardBackupSchedules": NativeStandardBackupSchedules,
    "NativeStandardConfig": NativeStandardConfig,
    "NeptuneClusterParameterGroup": NeptuneClusterParameterGroup,
    "NeptuneClusterParameterGroups": NeptuneClusterParameterGroups,
    "NeptuneRestoreDestination": NeptuneRestoreDestination,
    "NeptuneSnapshotProperties": NeptuneSnapshotProperties,
    "NetworkInterfaceConfig": NetworkInterfaceConfig,
    "Notebook": Notebook,
    "NotebookExecutionOutput": NotebookExecutionOutput,
    "NotebookExecutionResult": NotebookExecutionResult,
    "NotebookSession": NotebookSession,
    "Notification": Notification,
    "NotificationArguments": NotificationArguments,
    "NotificationPolicy": NotificationPolicy,
    "NotificationPolicyConfig": NotificationPolicyConfig,
    "NotificationPolicyConfigEmail": NotificationPolicyConfigEmail,
    "NotificationPolicyConfigServiceNow": NotificationPolicyConfigServiceNow,
    "NotificationPolicyConfigSlack": NotificationPolicyConfigSlack,
    "NotificationPolicyConfigSns": NotificationPolicyConfigSns,
    "NotificationPolicyConfigSplunk": NotificationPolicyConfigSplunk,
    "NotificationPolicyConfigWebhook": NotificationPolicyConfigWebhook,
    "NumberOfCopiesRule": NumberOfCopiesRule,
    "OAuthApp": OAuthApp,
    "Oauth2TokenResponse": Oauth2TokenResponse,
    "ObjectStorageDestination": ObjectStorageDestination,
    "ObjectStoreExclusionRule": ObjectStoreExclusionRule,
    "OnboardAdditionalAzureApps200Response": OnboardAdditionalAzureApps200Response,
    "OnboardAdditionalAzureAppsRequest": OnboardAdditionalAzureAppsRequest,
    "OnboardRdsCdcRequest": OnboardRdsCdcRequest,
    "OnboardRdsCdcResponse": OnboardRdsCdcResponse,
    "OnboardingAzureResourceGroup": OnboardingAzureResourceGroup,
    "OperationIdFilters": OperationIdFilters,
    "OverrideDataClassificationsRequest": OverrideDataClassificationsRequest,
    "OverrideDataClassificationsResponse": OverrideDataClassificationsResponse,
    "OverrideEnvironmentRequest": OverrideEnvironmentRequest,
    "OverrideEnvironmentResponse": OverrideEnvironmentResponse,
    "OverrideSensitivityAnnotationsRequest": OverrideSensitivityAnnotationsRequest,
    "Pagination": Pagination,
    "ParameterCheckResult": ParameterCheckResult,
    "ParentIdFilters": ParentIdFilters,
    "PartialRestoreData": PartialRestoreData,
    "Path": Path,
    "PathSegment": PathSegment,
    "PathSnapshotsRequest": PathSnapshotsRequest,
    "PathSnapshotsResponse": PathSnapshotsResponse,
    "Permission": Permission,
    "PermissionGrant": PermissionGrant,
    "PermissionGrantInput": PermissionGrantInput,
    "PersistentVolumeClaimProperties": PersistentVolumeClaimProperties,
    "PitrBackupPolicyPlan": PitrBackupPolicyPlan,
    "PitrBackupResourceType": PitrBackupResourceType,
    "PitrBackupSchedules": PitrBackupSchedules,
    "PitrIntervalConfig": PitrIntervalConfig,
    "PitrRestoreVaultWindows": PitrRestoreVaultWindows,
    "PitrRestoreWindow": PitrRestoreWindow,
    "PitrRestoreWindowsResponse": PitrRestoreWindowsResponse,
    "Preferences": Preferences,
    "PrivateLink": PrivateLink,
    "PrivateLinkCheckResult": PrivateLinkCheckResult,
    "PrivateLinkFormatInstructions": PrivateLinkFormatInstructions,
    "PrivateLinkInstructionStep": PrivateLinkInstructionStep,
    "Project": Project,
    "ProjectIdFilters": ProjectIdFilters,
    "ProviderAccountIdFilters": ProviderAccountIdFilters,
    "ProviderParentIdFilters": ProviderParentIdFilters,
    "ProviderRestoreAccountConnectivityConfig": ProviderRestoreAccountConnectivityConfig,
    "PulumiConfiguration": PulumiConfiguration,
    "PulumiConfigurations": PulumiConfigurations,
    "PulumiConfigurationsFilterConditions": PulumiConfigurationsFilterConditions,
    "PulumiConfigurationsRequest": PulumiConfigurationsRequest,
    "QueryCostData400Response": QueryCostData400Response,
    "QueryCostDataRequest": QueryCostDataRequest,
    "QueryCostDataResponse": QueryCostDataResponse,
    "QueryDBRequest": QueryDBRequest,
    "QueryDBResponse": QueryDBResponse,
    "QueryDBRestoreDestination": QueryDBRestoreDestination,
    "QueryDBResultResponse": QueryDBResultResponse,
    "QueryDBStatusResponse": QueryDBStatusResponse,
    "QuotaStatusFilters": QuotaStatusFilters,
    "RamShareCheckResult": RamShareCheckResult,
    "RansomwareResourceNotificationArguments": RansomwareResourceNotificationArguments,
    "RdsNativePitrAdvancedConfig": RdsNativePitrAdvancedConfig,
    "RdsNativePitrClusterAdvancedConfig": RdsNativePitrClusterAdvancedConfig,
    "RdsNativePitrNetworkConfig": RdsNativePitrNetworkConfig,
    "RdsNativePitrWindow": RdsNativePitrWindow,
    "RdsPasswordConfig": RdsPasswordConfig,
    "RdsSecurityGroup": RdsSecurityGroup,
    "ReactivateAccountRequest": ReactivateAccountRequest,
    "ReconnectCustomerVaultAccountResponse": ReconnectCustomerVaultAccountResponse,
    "ReconnectRestoreAccountResponse": ReconnectRestoreAccountResponse,
    "ReconnectSourceAccountResponse": ReconnectSourceAccountResponse,
    "ReconnectSourceAwsOrganizationalUnitResponse": ReconnectSourceAwsOrganizationalUnitResponse,
    "RecordRestoreResult": RecordRestoreResult,
    "RecoveryPointData": RecoveryPointData,
    "RedshiftCluster": RedshiftCluster,
    "RedshiftClusters": RedshiftClusters,
    "RedshiftIntegrationConfig": RedshiftIntegrationConfig,
    "RedshiftRestoreDestination": RedshiftRestoreDestination,
    "RedshiftServerlessNamespace": RedshiftServerlessNamespace,
    "RedshiftServerlessNamespaces": RedshiftServerlessNamespaces,
    "RedshiftSnapshotProperties": RedshiftSnapshotProperties,
    "RegionCondition": RegionCondition,
    "RegisterInput": RegisterInput,
    "RegisterInputBillingToken": RegisterInputBillingToken,
    "RegisterResponse": RegisterResponse,
    "RelatedGlobalDbCluster": RelatedGlobalDbCluster,
    "RequestDetails": RequestDetails,
    "ResourceDetails": ResourceDetails,
    "ResourceGroupNameCondition": ResourceGroupNameCondition,
    "ResourceIdCondition": ResourceIdCondition,
    "ResourceIdFilters": ResourceIdFilters,
    "ResourceIdentifiers": ResourceIdentifiers,
    "ResourceNameCondition": ResourceNameCondition,
    "ResourceNameFilters": ResourceNameFilters,
    "ResourceProperties": ResourceProperties,
    "ResourceSnapshot": ResourceSnapshot,
    "ResourceSnapshotProperties": ResourceSnapshotProperties,
    "ResourceTag": ResourceTag,
    "ResourceTypeCondition": ResourceTypeCondition,
    "ResourceTypeFilters": ResourceTypeFilters,
    "ResourceTypeToSecurityGroup": ResourceTypeToSecurityGroup,
    "ResourceValidationError": ResourceValidationError,
    "RestoreAccount": RestoreAccount,
    "RestoreAccountAttributesInput": RestoreAccountAttributesInput,
    "RestoreAccountCloudAttributes": RestoreAccountCloudAttributes,
    "RestoreAccountConnectivityConfig": RestoreAccountConnectivityConfig,
    "RestoreAccountMetricsConfig": RestoreAccountMetricsConfig,
    "RestoreAccountRegions": RestoreAccountRegions,
    "RestoreAccountsFilterConditions": RestoreAccountsFilterConditions,
    "RestoreAtlasClusterInput": RestoreAtlasClusterInput,
    "RestoreAvailabilityZones": RestoreAvailabilityZones,
    "RestoreAwsEc2InstanceRequest": RestoreAwsEc2InstanceRequest,
    "RestoreAzureDiskConfig": RestoreAzureDiskConfig,
    "RestoreAzureDiskRequest": RestoreAzureDiskRequest,
    "RestoreAzureInstanceDiskInput": RestoreAzureInstanceDiskInput,
    "RestoreAzurePostgresDatabaseRequest": RestoreAzurePostgresDatabaseRequest,
    "RestoreAzureSqlDatabaseRequest": RestoreAzureSqlDatabaseRequest,
    "RestoreAzureSqlVmPitrRequest": RestoreAzureSqlVmPitrRequest,
    "RestoreAzureVMInstanceConfig": RestoreAzureVMInstanceConfig,
    "RestoreAzureVmInstanceRequest": RestoreAzureVmInstanceRequest,
    "RestoreBigQueryDatasetRequest": RestoreBigQueryDatasetRequest,
    "RestoreBigQueryNativePitrRequest": RestoreBigQueryNativePitrRequest,
    "RestoreBucketRequest": RestoreBucketRequest,
    "RestoreDbToRdsInstanceRequest": RestoreDbToRdsInstanceRequest,
    "RestoreDbToRdsSnapshotRequest": RestoreDbToRdsSnapshotRequest,
    "RestoreDestinationLimits": RestoreDestinationLimits,
    "RestoreDocumentDBRequest": RestoreDocumentDBRequest,
    "RestoreDynamoDBTableRequest": RestoreDynamoDBTableRequest,
    "RestoreDynamoDBToExistingTableRequest": RestoreDynamoDBToExistingTableRequest,
    "RestoreDynamoDbTableConfig": RestoreDynamoDbTableConfig,
    "RestoreEFSRequest": RestoreEFSRequest,
    "RestoreEbsVolumeConfig": RestoreEbsVolumeConfig,
    "RestoreEc2InstanceConfig": RestoreEc2InstanceConfig,
    "RestoreEksNamespaceConfig": RestoreEksNamespaceConfig,
    "RestoreEksNamespaceInput": RestoreEksNamespaceInput,
    "RestoreEksNamespaceVolumeInput": RestoreEksNamespaceVolumeInput,
    "RestoreFSxRequest": RestoreFSxRequest,
    "RestoreFilesRequest": RestoreFilesRequest,
    "RestoreGceDiskConfig": RestoreGceDiskConfig,
    "RestoreGceInstanceConfig": RestoreGceInstanceConfig,
    "RestoreGcpCloudSqlDatabaseConfig": RestoreGcpCloudSqlDatabaseConfig,
    "RestoreGcpCloudSqlRequest": RestoreGcpCloudSqlRequest,
    "RestoreGcpDiskRequest": RestoreGcpDiskRequest,
    "RestoreGcpInstanceDiskInput": RestoreGcpInstanceDiskInput,
    "RestoreGcpVmInstanceRequest": RestoreGcpVmInstanceRequest,
    "RestoreImageImageDeviceInput": RestoreImageImageDeviceInput,
    "RestoreImageImageInput": RestoreImageImageInput,
    "RestoreImageInput": RestoreImageInput,
    "RestoreImageVolumeInput": RestoreImageVolumeInput,
    "RestoreInstanceImageDeviceInput": RestoreInstanceImageDeviceInput,
    "RestoreInstanceImageInput": RestoreInstanceImageInput,
    "RestoreInstanceVolumeInput": RestoreInstanceVolumeInput,
    "RestoreJob": RestoreJob,
    "RestoreJobConfiguration": RestoreJobConfiguration,
    "RestoreJobInitiationResponse": RestoreJobInitiationResponse,
    "RestoreJobTypeFilters": RestoreJobTypeFilters,
    "RestoreJobsFilterConditions": RestoreJobsFilterConditions,
    "RestoreKeyspacesTableRequest": RestoreKeyspacesTableRequest,
    "RestoreNeptuneRequest": RestoreNeptuneRequest,
    "RestoreRdsInstanceClasses": RestoreRdsInstanceClasses,
    "RestoreRdsInstanceConfig": RestoreRdsInstanceConfig,
    "RestoreRdsNativePitrRequest": RestoreRdsNativePitrRequest,
    "RestoreRdsSubnetGroups": RestoreRdsSubnetGroups,
    "RestoreRdsSubnetGroupsRdsSubnetGroupsInner": RestoreRdsSubnetGroupsRdsSubnetGroupsInner,
    "RestoreRedshiftRequest": RestoreRedshiftRequest,
    "RestoreResult": RestoreResult,
    "RestoreSecurityGroups": RestoreSecurityGroups,
    "RestoreSecurityGroupsSecurityGroupsInner": RestoreSecurityGroupsSecurityGroupsInner,
    "RestoreVolumeToEbsRequest": RestoreVolumeToEbsRequest,
    "RestoreVolumeToEbsSnapshotRequest": RestoreVolumeToEbsSnapshotRequest,
    "Role": Role,
    "RoleAccessGroupCondition": RoleAccessGroupCondition,
    "S3Bucket": S3Bucket,
    "S3Buckets": S3Buckets,
    "S3RestoreDestination": S3RestoreDestination,
    "S3RestoreTarget": S3RestoreTarget,
    "S3SourceProperties": S3SourceProperties,
    "SAMLCallback400Response": SAMLCallback400Response,
    "SAMLCallback401Response": SAMLCallback401Response,
    "SAMLCallback500Response": SAMLCallback500Response,
    "SamlIdentityProvider": SamlIdentityProvider,
    "SamlIdentityProviderConfigsResponse": SamlIdentityProviderConfigsResponse,
    "SapHanaInstance": SapHanaInstance,
    "SapHanaRestoreProperties": SapHanaRestoreProperties,
    "SaveCloudResourceSecurityPropertiesRequest": SaveCloudResourceSecurityPropertiesRequest,
    "SaveNotebookContentRequest": SaveNotebookContentRequest,
    "SavedQuery": SavedQuery,
    "ScanJob": ScanJob,
    "SchemaRecord": SchemaRecord,
    "SchemaRegistryAuthConfig": SchemaRegistryAuthConfig,
    "SchemaRegistryConfig": SchemaRegistryConfig,
    "SearchDBResponse": SearchDBResponse,
    "SearchFilesResponse": SearchFilesResponse,
    "SearchInput": SearchInput,
    "SearchLogsHistogramInput": SearchLogsHistogramInput,
    "SearchLogsHistogramResponse": SearchLogsHistogramResponse,
    "SearchLogsInput": SearchLogsInput,
    "SearchLogsResponse": SearchLogsResponse,
    "SearchResources200Response": SearchResources200Response,
    "SearchResources200ResponseTablesInner": SearchResources200ResponseTablesInner,
    "SearchResources200ResponseTablesInnerResource": SearchResources200ResponseTablesInnerResource,
    "SearchResources200ResponseTablesInnerSnapshots": SearchResources200ResponseTablesInnerSnapshots,
    "SearchResources200ResponseTablesInnerSource": SearchResources200ResponseTablesInnerSource,
    "SearchResources200ResponseTablesInnerTablesInner": SearchResources200ResponseTablesInnerTablesInner,
    "SearchResources200ResponseTablesInnerTablesInnerColumnsInner": SearchResources200ResponseTablesInnerTablesInnerColumnsInner,
    "SearchResourcesRequest": SearchResourcesRequest,
    "SecurityGroupRule": SecurityGroupRule,
    "SecurityInformation": SecurityInformation,
    "SecurityPlan": SecurityPlan,
    "SecurityPlanEnabledResponse": SecurityPlanEnabledResponse,
    "SecurityResourceNotificationArguments": SecurityResourceNotificationArguments,
    "SecurityScan": SecurityScan,
    "SecurityScanNotificationData": SecurityScanNotificationData,
    "SecurityScanResult": SecurityScanResult,
    "SecurityScansSummaryResponse": SecurityScansSummaryResponse,
    "SecuritySnapshotNotificationArguments": SecuritySnapshotNotificationArguments,
    "SecuritySummary": SecuritySummary,
    "SendA2AMessageRequest": SendA2AMessageRequest,
    "SendMessageToAI400Response": SendMessageToAI400Response,
    "SendMessageToAIRequest": SendMessageToAIRequest,
    "SensitivityAnnotation": SensitivityAnnotation,
    "SensitivityAnnotationsDetails": SensitivityAnnotationsDetails,
    "ServiceProviderDetails": ServiceProviderDetails,
    "Session": Session,
    "SetupAwsPrivateLinkRequest": SetupAwsPrivateLinkRequest,
    "SetupAwsPrivateLinkResponse": SetupAwsPrivateLinkResponse,
    "SetupMongoAtlasPrivateLinkRequest": SetupMongoAtlasPrivateLinkRequest,
    "SetupMongoAtlasPrivateLinkResponse": SetupMongoAtlasPrivateLinkResponse,
    "SeverityFilters": SeverityFilters,
    "Snapshot": Snapshot,
    "SnapshotAccessDeniedNotificationArguments": SnapshotAccessDeniedNotificationArguments,
    "SnapshotDateFilters": SnapshotDateFilters,
    "SnapshotFilterConditions": SnapshotFilterConditions,
    "SnapshotFindingCountsResponse": SnapshotFindingCountsResponse,
    "SnapshotIdFilters": SnapshotIdFilters,
    "SnapshotLocation": SnapshotLocation,
    "SnapshotReference": SnapshotReference,
    "SnapshotStorage": SnapshotStorage,
    "SnapshotsSummaryResponse": SnapshotsSummaryResponse,
    "SnowflakeIntegrationConfig": SnowflakeIntegrationConfig,
    "SortBackupJobBy": SortBackupJobBy,
    "SortColumnSpec": SortColumnSpec,
    "SortLogsBy": SortLogsBy,
    "SortResourceBy": SortResourceBy,
    "SortRestoreAccountsBy": SortRestoreAccountsBy,
    "SortRestoreJobBy": SortRestoreJobBy,
    "SortSnapshotsBy": SortSnapshotsBy,
    "SortSourceAccountsBy": SortSourceAccountsBy,
    "SourceAccount": SourceAccount,
    "SourceAccountAttributesInput": SourceAccountAttributesInput,
    "SourceAccountCloudAttributes": SourceAccountCloudAttributes,
    "SourceAccountMetricsConfig": SourceAccountMetricsConfig,
    "SourceAccountProviderIdFilters": SourceAccountProviderIdFilters,
    "SourceAccountsFilterConditions": SourceAccountsFilterConditions,
    "SourceAwsOrganizationalUnit": SourceAwsOrganizationalUnit,
    "SourceRegionFilters": SourceRegionFilters,
    "SourceSizeCheckResult": SourceSizeCheckResult,
    "SourceStorage": SourceStorage,
    "SourceStorageBackupStatus": SourceStorageBackupStatus,
    "SparkEngine": SparkEngine,
    "SparkJob": SparkJob,
    "SparkJobRetryPolicy": SparkJobRetryPolicy,
    "SparkJobSparkSubmitParams": SparkJobSparkSubmitParams,
    "SqlEngine": SqlEngine,
    "SqlInstructions": SqlInstructions,
    "SqlQueryExecution": SqlQueryExecution,
    "SqlQueryExecutionResult": SqlQueryExecutionResult,
    "SqlQueryExecutionResultColumn": SqlQueryExecutionResultColumn,
    "SqlVmNetworkInfo": SqlVmNetworkInfo,
    "SsoIntegrationSettings": SsoIntegrationSettings,
    "StackNameFilters": StackNameFilters,
    "StandardBackupPolicyPlan": StandardBackupPolicyPlan,
    "StandardBackupScheduleConfig": StandardBackupScheduleConfig,
    "StandardBackupSchedules": StandardBackupSchedules,
    "StandardIntervalConfig": StandardIntervalConfig,
    "StartNotebookSessionInput": StartNotebookSessionInput,
    "StartSparkJobDirectParams": StartSparkJobDirectParams,
    "StartSparkJobInput": StartSparkJobInput,
    "StartSparkJobTemplateParams": StartSparkJobTemplateParams,
    "StartSqlQueryExecutionInput": StartSqlQueryExecutionInput,
    "StartTimeDateFilters": StartTimeDateFilters,
    "StatusCodeFilters": StatusCodeFilters,
    "StorageAccountContainerRestoreDestination": StorageAccountContainerRestoreDestination,
    "StorageAccountRestoreTarget": StorageAccountRestoreTarget,
    "StorageConfig": StorageConfig,
    "StorageGateway": StorageGateway,
    "StorageGatewayDetails": StorageGatewayDetails,
    "SubnetConfig": SubnetConfig,
    "SubnetFilters": SubnetFilters,
    "SubnetPerAvailabilityZone": SubnetPerAvailabilityZone,
    "SubnetsCondition": SubnetsCondition,
    "SupportedProviders": SupportedProviders,
    "TableMaintenanceConfig": TableMaintenanceConfig,
    "TableRecord": TableRecord,
    "TagKeyValue": TagKeyValue,
    "TagKeyValuesCondition": TagKeyValuesCondition,
    "TagKeyValuesFilters": TagKeyValuesFilters,
    "TagKeysCondition": TagKeysCondition,
    "TagKeysFilters": TagKeysFilters,
    "TakeNativeSnapshotRequest": TakeNativeSnapshotRequest,
    "TakeSnapshotRequest": TakeSnapshotRequest,
    "TakeSnapshotResponse": TakeSnapshotResponse,
    "TeardownAwsPrivateLinkResponse": TeardownAwsPrivateLinkResponse,
    "TeardownMongoAtlasPrivateLinkResponse": TeardownMongoAtlasPrivateLinkResponse,
    "TimeFrame": TimeFrame,
    "TimeOfDay": TimeOfDay,
    "TimeOfYear": TimeOfYear,
    "TokenResponse": TokenResponse,
    "TotalSourceStorageSizeResponse": TotalSourceStorageSizeResponse,
    "TriggerKeyspacesScheduledDump200Response": TriggerKeyspacesScheduledDump200Response,
    "UnifiedDBRecord": UnifiedDBRecord,
    "UnifiedDBServerRecord": UnifiedDBServerRecord,
    "UnifiedDatabaseRecord": UnifiedDatabaseRecord,
    "UnifiedSchemaRecord": UnifiedSchemaRecord,
    "UnifiedTableRecord": UnifiedTableRecord,
    "UpPulumiStacksResponse": UpPulumiStacksResponse,
    "UpdateAccountCompanyContactsRequest": UpdateAccountCompanyContactsRequest,
    "UpdateAccountLabelsRequest": UpdateAccountLabelsRequest,
    "UpdateAccountProfileResponse": UpdateAccountProfileResponse,
    "UpdateApiCredentialsRequest": UpdateApiCredentialsRequest,
    "UpdateBackupPolicyRequest": UpdateBackupPolicyRequest,
    "UpdateBackupPolicyResponse": UpdateBackupPolicyResponse,
    "UpdateBackupZeroEtlPolicyInput": UpdateBackupZeroEtlPolicyInput,
    "UpdateCloudResourceConfigurationRequest": UpdateCloudResourceConfigurationRequest,
    "UpdateCloudResourceConfigurationRequestCdcBackup": UpdateCloudResourceConfigurationRequestCdcBackup,
    "UpdateCloudResourceConfigurationRequestInventoryBackup": UpdateCloudResourceConfigurationRequestInventoryBackup,
    "UpdateControlViolationInput": UpdateControlViolationInput,
    "UpdateDashboardInput": UpdateDashboardInput,
    "UpdateDlsgPolicyRequest": UpdateDlsgPolicyRequest,
    "UpdateDlsgPolicyResponse": UpdateDlsgPolicyResponse,
    "UpdateGraphInput": UpdateGraphInput,
    "UpdateIdpGroupRequest": UpdateIdpGroupRequest,
    "UpdateIdpGroupResponse": UpdateIdpGroupResponse,
    "UpdateIngestionPipelineInput": UpdateIngestionPipelineInput,
    "UpdateIntegrationRequest": UpdateIntegrationRequest,
    "UpdateIntegrationResponse": UpdateIntegrationResponse,
    "UpdateJobTemplateInput": UpdateJobTemplateInput,
    "UpdateNotebookInput": UpdateNotebookInput,
    "UpdatePrivateLinkInput": UpdatePrivateLinkInput,
    "UpdateProjectConfigurationKeyRequest": UpdateProjectConfigurationKeyRequest,
    "UpdatePulumiConfigurationRequest": UpdatePulumiConfigurationRequest,
    "UpdateResourceSecurityScansExclusionRequest": UpdateResourceSecurityScansExclusionRequest,
    "UpdateRestoreAccountConnectivityConfigRequest": UpdateRestoreAccountConnectivityConfigRequest,
    "UpdateRestoreAccountConnectivityConfigResponse": UpdateRestoreAccountConnectivityConfigResponse,
    "UpdateRoleRequest": UpdateRoleRequest,
    "UpdateRoleResponse": UpdateRoleResponse,
    "UpdateSamlIdentityProviderInput": UpdateSamlIdentityProviderInput,
    "UpdateSavedQueryInput": UpdateSavedQueryInput,
    "UpdateSessionRequest": UpdateSessionRequest,
    "UpdateShouldFullBackupResourceRequest": UpdateShouldFullBackupResourceRequest,
    "UpdateTableMaintenanceConfigInput": UpdateTableMaintenanceConfigInput,
    "UpdateUserInput": UpdateUserInput,
    "UpdateVaultRequest": UpdateVaultRequest,
    "UpdateVaultResponse": UpdateVaultResponse,
    "UpdateViewerRoleRequest": UpdateViewerRoleRequest,
    "UpdateWorkspaceBucketPolicyInput": UpdateWorkspaceBucketPolicyInput,
    "UpdateWorkspaceLoggingSettingsInput": UpdateWorkspaceLoggingSettingsInput,
    "UpdateWorkspaceMetricsSettingsInput": UpdateWorkspaceMetricsSettingsInput,
    "UpdateZeroEtlPolicyInput": UpdateZeroEtlPolicyInput,
    "Usage": Usage,
    "User": User,
    "UserIdFilters": UserIdFilters,
    "VNetConfig": VNetConfig,
    "ValidateResourceConfigurationRequest": ValidateResourceConfigurationRequest,
    "ValidateResourceConfigurationResponse": ValidateResourceConfigurationResponse,
    "VaultFilters": VaultFilters,
    "VaultMetadataReplicationConfig": VaultMetadataReplicationConfig,
    "VaultNotificationArguments": VaultNotificationArguments,
    "VaultProviderAttributes": VaultProviderAttributes,
    "VaultProviderAttributesInput": VaultProviderAttributesInput,
    "VaultSnapshotCount": VaultSnapshotCount,
    "VerifyMongoAtlasPrivateLinkResponse": VerifyMongoAtlasPrivateLinkResponse,
    "Viewer": Viewer,
    "ViolationsDetectionNotificationArguments": ViolationsDetectionNotificationArguments,
    "VirtualMachineRestoreDestination": VirtualMachineRestoreDestination,
    "VisualizationHistogramSeries": VisualizationHistogramSeries,
    "VisualizationHistogramTimePoint": VisualizationHistogramTimePoint,
    "VisualizationLabel": VisualizationLabel,
    "VolumeSettings": VolumeSettings,
    "VpcCondition": VpcCondition,
    "VpcPeering": VpcPeering,
    "VpcPropertyFilters": VpcPropertyFilters,
    "WarmCapacity": WarmCapacity,
    "WeeklyConfig": WeeklyConfig,
    "Workspace": Workspace,
    "WorkspaceBucketPolicy": WorkspaceBucketPolicy,
    "WorkspaceLoggingSettings": WorkspaceLoggingSettings,
    "WorkspaceMetricsSettings": WorkspaceMetricsSettings,
    "WorkspaceNetworkingSettings": WorkspaceNetworkingSettings,
    "YearlySnapshotDistribution": YearlySnapshotDistribution,
    "ZeroEtlIdentityColumnSpec": ZeroEtlIdentityColumnSpec,
    "ZeroEtlPolicy": ZeroEtlPolicy,
    "ZeroEtlResourceSelector": ZeroEtlResourceSelector,
    "ZeroEtlRoutingPolicy": ZeroEtlRoutingPolicy,
};
export class ObjectSerializer {
    static findCorrectType(data, expectedType) {
        if (data == undefined) {
            return expectedType;
        }
        else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
            return expectedType;
        }
        else if (expectedType === "Date") {
            return expectedType;
        }
        else {
            if (enumsMap.has(expectedType)) {
                return expectedType;
            }
            if (!typeMap[expectedType]) {
                return expectedType;
            }
            let discriminatorProperty = typeMap[expectedType].discriminator;
            if (discriminatorProperty == null) {
                return expectedType;
            }
            else {
                if (data[discriminatorProperty]) {
                    var discriminatorType = data[discriminatorProperty];
                    if (typeMap[discriminatorType]) {
                        return discriminatorType;
                    }
                    else {
                        return expectedType;
                    }
                }
                else {
                    return expectedType;
                }
            }
        }
    }
    static serialize(data, type, format) {
        if (data === undefined || data === null || primitives.includes(type.toLowerCase())) {
            return data;
        }
        else if (type.startsWith("Array<", 0)) {
            let subType = type.replace("Array<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.serialize(date, subType, format));
            }
            return transformedData;
        }
        else if (type === "Date") {
            if (format == "date") {
                let month = data.getMonth() + 1;
                month = month < 10 ? "0" + month.toString() : month.toString();
                let day = data.getDate();
                day = day < 10 ? "0" + day.toString() : day.toString();
                return data.getFullYear() + "-" + month + "-" + day;
            }
            else {
                return data.toISOString();
            }
        }
        else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            type = this.findCorrectType(data, type);
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            let instance = {};
            for (let attributeType of attributeTypes) {
                instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type, attributeType.format);
            }
            return instance;
        }
    }
    static deserialize(data, type, format) {
        type = ObjectSerializer.findCorrectType(data, type);
        if (data == undefined) {
            return data;
        }
        else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        }
        else if (type.lastIndexOf("Array<", 0) === 0) {
            let subType = type.replace("Array<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.deserialize(date, subType, format));
            }
            return transformedData;
        }
        else if (type === "Date") {
            return new Date(data);
        }
        else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            let instance = new typeMap[type]();
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            for (let attributeType of attributeTypes) {
                let value = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type, attributeType.format);
                if (value !== undefined) {
                    instance[attributeType.name] = value;
                }
            }
            return instance;
        }
    }
    static getPreferredMediaType(mediaTypes) {
        return "application/json";
    }
}
